var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _rect2, _rect3, _rect4, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _g, _g2, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _rect5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 180,
    viewBox: "0 0 586 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_3329)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 180,
    rx: 90,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.291 84.5775L117.631 83.8872L116.898 83.5258L116.558 84.2161L117.291 84.5775Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.558 81.7523L111.898 81.062L111.165 80.7006L110.825 81.3909L111.558 81.7523Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.825 78.927L106.166 78.2367L105.432 77.8754L105.092 78.5656L105.825 78.927Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.093 76.1018L100.433 75.4115L99.6997 75.0501L99.3595 75.7404L100.093 76.1018Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3601 73.2765L94.7003 72.5862L93.9671 72.2249L93.6269 72.9152L94.3601 73.2765Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6275 70.4513L88.9677 69.761L88.2344 69.3996L87.8942 70.0899L88.6275 70.4513Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8948 67.626L83.235 66.9358L82.5018 66.5744L82.1616 67.2647L82.8948 67.626Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1622 64.8008L77.5024 64.1105L76.7691 63.7491L76.4289 64.4394L77.1622 64.8008Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4295 61.9756L71.7697 61.2853L71.0365 60.9239L70.6963 61.6142L71.4295 61.9756Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6969 59.1503L66.0371 58.46L65.3038 58.0987L64.9636 58.7889L65.6969 59.1503Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9642 56.3251L60.3044 55.6348L59.5711 55.2734L59.2309 55.9637L59.9642 56.3251Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2315 53.4998L54.5717 52.8095L53.8385 52.4482L53.4983 53.1385L54.2315 53.4998Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4989 50.6746L48.8391 49.9843L48.1058 49.6229L47.7656 50.3132L48.4989 50.6746Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7662 47.8494L43.1064 47.1591L42.3732 46.7977L42.033 47.488L42.7662 47.8494Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0336 45.0241L37.3738 44.3338L36.6405 43.9724L36.3003 44.6627L37.0336 45.0241Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3009 42.1989L31.6411 41.5086L30.9079 41.1472L30.5677 41.8375L31.3009 42.1989Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5683 39.3736L25.9085 38.6833L25.1752 38.322L24.835 39.0123L25.5683 39.3736Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8356 36.5484L20.1758 35.8581L19.4425 35.4967L19.1024 36.187L19.8356 36.5484Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.103 33.7231L14.4432 33.0329L13.7099 32.6715L13.3697 33.3618L14.103 33.7231Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M117.544 91.5124L117.966 90.6573L117.057 90.2096L116.636 91.0647L117.544 91.5124Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.812 88.6872L112.233 87.832L111.325 87.3844L110.903 88.2395L111.812 88.6872Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.079 85.8619L106.5 85.0068L105.592 84.5591L105.171 85.4143L106.079 85.8619Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.346 83.0367L100.768 82.1816L99.8594 81.7339L99.438 82.589L100.346 83.0367Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6137 80.2114L95.0352 79.3563L94.1268 78.9086L93.7054 79.7638L94.6137 80.2114Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8811 77.3862L89.3025 76.5311L88.3941 76.0834L87.9727 76.9385L88.8811 77.3862Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1484 74.561L83.5698 73.7058L82.6615 73.2582L82.24 74.1133L83.1484 74.561Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4157 71.7357L77.8372 70.8806L76.9288 70.4329L76.5074 71.288L77.4157 71.7357Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6831 68.9105L72.1045 68.0553L71.1962 67.6077L70.7747 68.4628L71.6831 68.9105Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9504 66.0852L66.3719 65.2301L65.4635 64.7824L65.0421 65.6376L65.9504 66.0852Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2178 63.26L60.6392 62.4049L59.7309 61.9572L59.3094 62.8123L60.2178 63.26Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4851 60.4348L54.9066 59.5796L53.9982 59.1319L53.5768 59.9871L54.4851 60.4348Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7525 57.6095L49.1739 56.7544L48.2655 56.3067L47.8441 57.1618L48.7525 57.6095Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0198 54.7843L43.4413 53.9291L42.5329 53.4815L42.1114 54.3366L43.0198 54.7843Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2872 51.959L37.7086 51.1039L36.8002 50.6562L36.3788 51.5114L37.2872 51.959Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5545 49.1338L31.9759 48.2786L31.0676 47.831L30.6461 48.6861L31.5545 49.1338Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218 46.3085L26.2433 45.4534L25.3349 45.0057L24.9135 45.8609L25.8218 46.3085Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0892 43.4833L20.5106 42.6282L19.6023 42.1805L19.1808 43.0356L20.0892 43.4833Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3565 40.6581L14.778 39.8029L13.8696 39.3553L13.4482 40.2104L14.3565 40.6581Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M117.801 98.4552L118.309 97.4249L117.214 96.8855L116.706 97.9158L117.801 98.4552Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M112.068 95.6299L112.576 94.5997L111.482 94.0603L110.974 95.0906L112.068 95.6299Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.336 92.8047L106.843 91.7744L105.749 91.235L105.241 92.2653L106.336 92.8047Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M100.603 89.9795L101.111 88.9492L100.016 88.4098L99.5085 89.4401L100.603 89.9795Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8702 87.1542L95.378 86.1239L94.2836 85.5846L93.7758 86.6148L94.8702 87.1542Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1376 84.329L89.6453 83.2987L88.5509 82.7593L88.0431 83.7896L89.1376 84.329Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4049 81.5037L83.9127 80.4734L82.8183 79.9341L82.3105 80.9644L83.4049 81.5037Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6723 78.6785L78.18 77.6482L77.0856 77.1088L76.5778 78.1391L77.6723 78.6785Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9396 75.8532L72.4474 74.823L71.3529 74.2836L70.8452 75.3139L71.9396 75.8532Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M66.207 73.028L66.7147 71.9977L65.6203 71.4583L65.1125 72.4886L66.207 73.028Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4743 70.2028L60.9821 69.1725L59.8876 68.6331L59.3799 69.6634L60.4743 70.2028Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7416 67.3775L55.2494 66.3472L54.155 65.8079L53.6472 66.8382L54.7416 67.3775Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M49.009 64.5523L49.5167 63.522L48.4223 62.9826L47.9146 64.0129L49.009 64.5523Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2763 61.727L43.7841 60.6967L42.6897 60.1574L42.1819 61.1877L43.2763 61.727Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5437 58.9018L38.0514 57.8715L36.957 57.3321L36.4493 58.3624L37.5437 58.9018Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.811 56.0765L32.3188 55.0463L31.2244 54.5069L30.7166 55.5372L31.811 56.0765Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0784 53.2513L26.5861 52.221L25.4917 51.6817L24.9839 52.7119L26.0784 53.2513Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3457 50.4261L20.8535 49.3958L19.759 48.8564L19.2513 49.8867L20.3457 50.4261Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6131 47.6008L15.1208 46.5705L14.0264 46.0312L13.5186 47.0615L14.6131 47.6008Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88039 44.7756L9.38815 43.7453L8.29373 43.2059L7.78598 44.2362L8.88039 44.7756Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M118.057 105.398L118.651 104.193L117.371 103.561L116.777 104.767L118.057 105.398Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M112.325 102.573L112.919 101.367L111.638 100.736L111.044 101.942L112.325 102.573Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M106.592 99.7475L107.186 98.542L105.906 97.911L105.312 99.1164L106.592 99.7475Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M100.859 96.9222L101.453 95.7168L100.173 95.0857L99.5789 96.2912L100.859 96.9222Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1267 94.097L95.7208 92.8915L94.4404 92.2605L93.8463 93.4659L95.1267 94.097Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3941 91.2717L89.9882 90.0663L88.7077 89.4352L88.1136 90.6407L89.3941 91.2717Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6614 88.4465L84.2555 87.2411L82.975 86.61L82.381 87.8154L83.6614 88.4465Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9288 85.6212L78.5228 84.4158L77.2424 83.7848L76.6483 84.9902L77.9288 85.6212Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1961 82.796L72.7902 81.5906L71.5097 80.9595L70.9156 82.1649L72.1961 82.796Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4635 79.9708L67.0575 78.7653L65.7771 78.1343L65.183 79.3397L66.4635 79.9708Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7308 77.1455L61.3249 75.9401L60.0444 75.309L59.4503 76.5145L60.7308 77.1455Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9982 74.3203L55.5922 73.1148L54.3118 72.4838L53.7177 73.6892L54.9982 74.3203Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2655 71.495L49.8596 70.2896L48.5791 69.6585L47.985 70.864L49.2655 71.495Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5328 68.6698L44.1269 67.4644L42.8464 66.8333L42.2524 68.0387L43.5328 68.6698Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8002 65.8446L38.3943 64.6391L37.1138 64.0081L36.5197 65.2135L37.8002 65.8446Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0675 63.0193L32.6616 61.8139L31.3811 61.1828L30.7871 62.3883L32.0675 63.0193Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3349 60.1941L26.9289 58.9886L25.6485 58.3576L25.0544 59.563L26.3349 60.1941Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6022 57.3688L21.1963 56.1634L19.9158 55.5323L19.3217 56.7378L20.6022 57.3688Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8696 54.5436L15.4636 53.3381L14.1832 52.7071L13.5891 53.9125L14.8696 54.5436Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1369 51.7183L9.73098 50.5129L8.45052 49.8819L7.85644 51.0873L9.1369 51.7183Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M118.311 112.333L118.986 110.963L117.531 110.245L116.855 111.616L118.311 112.333Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M112.578 109.508L113.254 108.137L111.798 107.42L111.123 108.79L112.578 109.508Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M106.846 106.682L107.521 105.312L106.065 104.595L105.39 105.965L106.846 106.682Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M101.113 103.857L101.788 102.487L100.333 101.769L99.6574 103.14L101.113 103.857Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3803 101.032L96.0556 99.6616L94.6001 98.9443L93.9247 100.315L95.3803 101.032Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6477 98.2066L90.323 96.8364L88.8674 96.119L88.1921 97.4893L89.6477 98.2066Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M83.915 95.3814L84.5903 94.0111L83.1347 93.2938L82.4594 94.6641L83.915 95.3814Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1823 92.5562L78.8577 91.1859L77.4021 90.4685L76.7268 91.8388L78.1823 92.5562Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4497 89.7309L73.125 88.3606L71.6694 87.6433L70.9941 89.0136L72.4497 89.7309Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M66.717 86.9057L67.3924 85.5354L65.9368 84.818L65.2615 86.1883L66.717 86.9057Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9844 84.0804L61.6597 82.7102L60.2041 81.9928L59.5288 83.3631L60.9844 84.0804Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2517 81.2552L55.927 79.8849L54.4715 79.1676L53.7961 80.5378L55.2517 81.2552Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5191 78.43L50.1944 77.0597L48.7388 76.3423L48.0635 77.7126L49.5191 78.43Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7864 75.6047L44.4617 74.2344L43.0062 73.5171L42.3308 74.8874L43.7864 75.6047Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0538 72.7795L38.7291 71.4092L37.2735 70.6918L36.5982 72.0621L38.0538 72.7795Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3211 69.9542L32.9964 68.5839L31.5408 67.8666L30.8655 69.2369L32.3211 69.9542Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5884 67.129L27.2638 65.7587L25.8082 65.0414L25.1329 66.4116L26.5884 67.129Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8558 64.3037L21.5311 62.9335L20.0755 62.2161L19.4002 63.5864L20.8558 64.3037Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1231 61.4785L15.7985 60.1082L14.3429 59.3909L13.6676 60.7611L15.1231 61.4785Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39048 58.6533L10.0658 57.283L8.61023 56.5656L7.93491 57.9359L9.39048 58.6533Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65783 55.828L4.33314 54.4577L2.87757 53.7404L2.20225 55.1107L3.65783 55.828Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M118.567 119.276L119.329 117.73L117.687 116.921L116.926 118.467L118.567 119.276Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M112.835 116.45L113.596 114.905L111.955 114.096L111.193 115.641L112.835 116.45Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M107.102 113.625L107.864 112.08L106.222 111.271L105.461 112.816L107.102 113.625Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M101.369 110.8L102.131 109.254L100.489 108.445L99.7279 109.991L101.369 110.8Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6368 107.975L96.3985 106.429L94.7568 105.62L93.9952 107.166L95.6368 107.975Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9042 105.149L90.6658 103.604L89.0242 102.795L88.2625 104.34L89.9042 105.149Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1715 102.324L84.9331 100.779L83.2915 99.9697L82.5299 101.515L84.1715 102.324Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4389 99.4989L79.2005 97.9535L77.5589 97.1445L76.7972 98.6899L78.4389 99.4989Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7062 96.6737L73.4678 95.1283L71.8262 94.3192L71.0646 95.8646L72.7062 96.6737Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9735 93.8484L67.7352 92.303L66.0936 91.494L65.3319 93.0394L66.9735 93.8484Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2409 91.0232L62.0025 89.4778L60.3609 88.6687L59.5993 90.2142L61.2409 91.0232Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5082 88.198L56.2699 86.6525L54.6282 85.8435L53.8666 87.3889L55.5082 88.198Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7756 85.3727L50.5372 83.8273L48.8956 83.0182L48.134 84.5637L49.7756 85.3727Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0429 82.5475L44.8046 81.002L43.1629 80.193L42.4013 81.7384L44.0429 82.5475Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3103 79.7222L39.0719 78.1768L37.4303 77.3678L36.6686 78.9132L38.3103 79.7222Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5776 76.897L33.3392 75.3516L31.6976 74.5425L30.936 76.0879L32.5776 76.897Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M26.845 74.0717L27.6066 72.5263L25.965 71.7173L25.2033 73.2627L26.845 74.0717Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1123 71.2465L21.8739 69.7011L20.2323 68.892L19.4707 70.4375L21.1123 71.2465Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3796 68.4213L16.1413 66.8758L14.4997 66.0668L13.738 67.6122L15.3796 68.4213Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64699 65.596L10.4086 64.0506L8.767 63.2415L8.00536 64.787L9.64699 65.596Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91434 62.7708L4.67597 61.2254L3.03435 60.4163L2.27271 61.9617L3.91434 62.7708Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M113.091 123.393L113.939 121.673L112.112 120.772L111.264 122.492L113.091 123.393Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M107.359 120.568L108.207 118.847L106.379 117.947L105.531 119.667L107.359 120.568Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M101.626 117.743L102.474 116.022L100.646 115.121L99.7983 116.842L101.626 117.743Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8933 114.917L96.7413 113.197L94.9136 112.296L94.0657 114.017L95.8933 114.917Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1607 112.092L91.0086 110.372L89.181 109.471L88.333 111.191L90.1607 112.092Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M84.428 109.267L85.276 107.546L83.4483 106.646L82.6004 108.366L84.428 109.267Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6954 106.442L79.5433 104.721L77.7157 103.82L76.8677 105.541L78.6954 106.442Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9627 103.616L73.8107 101.896L71.983 100.995L71.135 102.716L72.9627 103.616Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2301 100.791L68.078 99.0706L66.2503 98.1699L65.4024 99.8905L67.2301 100.791Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4974 97.966L62.3454 96.2454L60.5177 95.3446L59.6697 97.0652L61.4974 97.966Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7647 95.1407L56.6127 93.4201L54.785 92.5194L53.9371 94.24L55.7647 95.1407Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0321 92.3155L50.88 90.5949L49.0524 89.6942L48.2044 91.4147L50.0321 92.3155Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2994 89.4902L45.1474 87.7697L43.3197 86.8689L42.4718 88.5895L44.2994 89.4902Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5668 86.665L39.4147 84.9444L37.5871 84.0437L36.7391 85.7643L38.5668 86.665Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8341 83.8398L33.6821 82.1192L31.8544 81.2184L31.0064 82.939L32.8341 83.8398Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1015 81.0145L27.9494 79.2939L26.1217 78.3932L25.2738 80.1138L27.1015 81.0145Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3688 78.1893L22.2168 76.4687L20.3891 75.568L19.5411 77.2885L21.3688 78.1893Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6362 75.364L16.4841 73.6435L14.6564 72.7427L13.8085 74.4633L15.6362 75.364Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9035 72.5388L10.7515 70.8182L8.92378 69.9175L8.07583 71.638L9.9035 72.5388Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17085 69.7135L5.0188 67.993L3.19112 67.0922L2.34317 68.8128L4.17085 69.7135Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.56181 66.8883L-0.713855 65.1677L-2.54153 64.267L-3.38948 65.9876L-1.56181 66.8883Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M113.345 130.328L114.274 128.443L112.271 127.456L111.342 129.341L113.345 130.328Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M107.612 127.503L108.541 125.617L106.539 124.63L105.609 126.516L107.612 127.503Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M101.88 124.678L102.809 122.792L100.806 121.805L99.8768 123.691L101.88 124.678Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1469 121.852L97.0761 119.967L95.0733 118.98L94.1441 120.865L96.1469 121.852Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4143 119.027L91.3435 117.142L89.3407 116.155L88.4115 118.04L90.4143 119.027Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6816 116.202L85.6108 114.316L83.608 113.329L82.6788 115.215L84.6816 116.202Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M78.949 113.377L79.8781 111.491L77.8754 110.504L76.9462 112.39L78.949 113.377Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2163 110.551L74.1455 108.666L72.1427 107.679L71.2135 109.564L73.2163 110.551Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4836 107.726L68.4128 105.841L66.41 104.854L65.4808 106.739L67.4836 107.726Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M61.751 104.901L62.6802 103.015L60.6774 102.028L59.7482 103.914L61.751 104.901Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0183 102.076L56.9475 100.19L54.9447 99.2032L54.0155 101.089L56.0183 102.076Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2857 99.2504L51.2149 97.365L49.2121 96.3779L48.2829 98.2634L50.2857 99.2504Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M44.553 96.4252L45.4822 94.5397L43.4794 93.5527L42.5502 95.4381L44.553 96.4252Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8204 93.5999L39.7496 91.7145L37.7468 90.7275L36.8176 92.6129L38.8204 93.5999Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0877 90.7747L34.0169 88.8893L32.0141 87.9022L31.0849 89.7876L33.0877 90.7747Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M27.355 87.9494L28.2842 86.064L26.2815 85.077L25.3523 86.9624L27.355 87.9494Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6224 85.1242L22.5516 83.2388L20.5488 82.2517L19.6196 84.1371L21.6224 85.1242Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8897 82.2989L16.8189 80.4135L14.8161 79.4265L13.887 81.3119L15.8897 82.2989Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1571 79.4737L11.0863 77.5883L9.08349 76.6012L8.1543 78.4867L10.1571 79.4737Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42442 76.6485L5.35361 74.763L3.35083 73.776L2.42164 75.6614L4.42442 76.6485Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.30823 73.8232L-0.379035 71.9378L-2.38182 70.9508L-3.31101 72.8362L-1.30823 73.8232Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M107.869 134.446L108.884 132.385L106.695 131.306L105.68 133.367L107.869 134.446Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M102.136 131.62L103.152 129.56L100.963 128.481L99.9472 130.542L102.136 131.62Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4034 128.795L97.4189 126.735L95.2301 125.656L94.2146 127.716L96.4034 128.795Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6708 125.97L91.6863 123.909L89.4975 122.831L88.4819 124.891L90.6708 125.97Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9381 123.145L85.9536 121.084L83.7648 120.005L82.7493 122.066L84.9381 123.145Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2055 120.319L80.221 118.259L78.0321 117.18L77.0166 119.241L79.2055 120.319Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4728 117.494L74.4883 115.434L72.2995 114.355L71.284 116.415L73.4728 117.494Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7401 114.669L68.7557 112.608L66.5668 111.53L65.5513 113.59L67.7401 114.669Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0075 111.844L63.023 109.783L60.8342 108.704L59.8187 110.765L62.0075 111.844Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2748 109.018L57.2903 106.958L55.1015 105.879L54.086 107.94L56.2748 109.018Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5422 106.193L51.5577 104.133L49.3689 103.054L48.3533 105.114L50.5422 106.193Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8095 103.368L45.825 101.307L43.6362 100.229L42.6207 102.289L44.8095 103.368Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0769 100.543L40.0924 98.4821L37.9035 97.4034L36.888 99.4639L39.0769 100.543Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3442 97.7174L34.3597 95.6569L32.1709 94.5781L31.1554 96.6387L33.3442 97.7174Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6116 94.8922L28.6271 92.8316L26.4382 91.7529L25.4227 93.8135L27.6116 94.8922Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8789 92.0669L22.8944 90.0064L20.7056 88.9277L19.6901 90.9882L21.8789 92.0669Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1462 89.2417L17.1618 87.1811L14.9729 86.1024L13.9574 88.163L16.1462 89.2417Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4136 86.4165L11.4291 84.3559L9.24027 83.2772L8.22476 85.3377L10.4136 86.4165Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68093 83.5912L5.69645 81.5307L3.50761 80.4519L2.4921 82.5125L4.68093 83.5912Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.05172 80.766L-0.0362043 78.7054L-2.22504 77.6267L-3.24055 79.6873L-1.05172 80.766Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.78438 77.9407L-5.76886 75.8802L-7.9577 74.8014L-8.97321 76.862L-6.78438 77.9407Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M108.125 141.388L109.227 139.153L106.852 137.982L105.75 140.218L108.125 141.388Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M102.393 138.563L103.494 136.327L101.12 135.157L100.018 137.393L102.393 138.563Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6599 135.738L97.7618 133.502L95.3869 132.332L94.2851 134.567L96.6599 135.738Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9273 132.913L92.0291 130.677L89.6542 129.506L88.5524 131.742L90.9273 132.913Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1946 130.087L86.2965 127.852L83.9216 126.681L82.8197 128.917L85.1946 130.087Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M79.462 127.262L80.5638 125.026L78.1889 123.856L77.0871 126.092L79.462 127.262Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7293 124.437L74.8311 122.201L72.4563 121.031L71.3544 123.266L73.7293 124.437Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9967 121.612L69.0985 119.376L66.7236 118.206L65.6218 120.441L67.9967 121.612Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M62.264 118.786L63.3658 116.551L60.991 115.38L59.8891 117.616L62.264 118.786Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5313 115.961L57.6332 113.725L55.2583 112.555L54.1565 114.791L56.5313 115.961Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7987 113.136L51.9005 110.9L49.5256 109.73L48.4238 111.966L50.7987 113.136Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M45.066 110.311L46.1679 108.075L43.793 106.905L42.6911 109.14L45.066 110.311Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3334 107.485L40.4352 105.25L38.0603 104.079L36.9585 106.315L39.3334 107.485Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6007 104.66L34.7026 102.424L32.3277 101.254L31.2258 103.49L33.6007 104.66Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8681 101.835L28.9699 99.5992L26.595 98.4288L25.4932 100.665L27.8681 101.835Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1354 99.0097L23.2372 96.774L20.8624 95.6036L19.7605 97.8393L22.1354 99.0097Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4028 96.1845L17.5046 93.9488L15.1297 92.7783L14.0279 95.0141L16.4028 96.1845Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6701 93.3592L11.7719 91.1235L9.39705 89.9531L8.29521 92.1888L10.6701 93.3592Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93744 90.534L6.03928 88.2983L3.6644 87.1279L2.56256 89.3636L4.93744 90.534Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.795216 87.7087L0.306618 85.473L-2.06826 84.3026L-3.1701 86.5383L-0.795216 87.7087Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.52787 84.8835L-5.42603 82.6478L-7.80091 81.4774L-8.90275 83.7131L-6.52787 84.8835Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M102.646 145.498L103.829 143.097L101.279 141.841L100.096 144.241L102.646 145.498Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9135 142.673L98.0966 140.272L95.5466 139.015L94.3635 141.416L96.9135 142.673Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1809 139.848L92.3639 137.447L89.8139 136.19L88.6309 138.591L91.1809 139.848Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4482 137.022L86.6313 134.622L84.0813 133.365L82.8982 135.766L85.4482 137.022Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7155 134.197L80.8986 131.796L78.3486 130.54L77.1656 132.94L79.7155 134.197Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9829 131.372L75.166 128.971L72.616 127.715L71.4329 130.115L73.9829 131.372Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2502 128.547L69.4333 126.146L66.8833 124.889L65.7002 127.29L68.2502 128.547Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5176 125.721L63.7007 123.321L61.1507 122.064L59.9676 124.465L62.5176 125.721Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7849 122.896L57.968 120.496L55.418 119.239L54.2349 121.639L56.7849 122.896Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0523 120.071L52.2353 117.67L49.6854 116.414L48.5023 118.814L51.0523 120.071Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3196 117.246L46.5027 114.845L43.9527 113.588L42.7696 115.989L45.3196 117.246Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M39.587 114.42L40.77 112.02L38.22 110.763L37.037 113.164L39.587 114.42Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8543 111.595L35.0374 109.195L32.4874 107.938L31.3043 110.338L33.8543 111.595Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1216 108.77L29.3047 106.369L26.7547 105.113L25.5716 107.513L28.1216 108.77Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M22.389 105.945L23.5721 103.544L21.0221 102.287L19.839 104.688L22.389 105.945Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6563 103.119L17.8394 100.719L15.2894 99.4621L14.1063 101.863L16.6563 103.119Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9237 100.294L12.1067 97.8936L9.55677 96.6369L8.37369 99.0374L10.9237 100.294Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19102 97.4689L6.3741 95.0683L3.82411 93.8116L2.64103 96.2122L5.19102 97.4689Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.541634 94.6437L0.641442 92.2431L-1.90855 90.9864L-3.09163 93.3869L-0.541634 94.6437Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.27429 91.8184L-5.09122 89.4179L-7.6412 88.1611L-8.82428 90.5617L-6.27429 91.8184Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M-12.0069 88.9932L-10.8239 86.5926L-13.3739 85.3359L-14.5569 87.7365L-12.0069 88.9932Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M102.903 152.441L104.172 149.865L101.436 148.517L100.167 151.092L102.903 152.441Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M97.17 149.616L98.4394 147.04L95.7034 145.691L94.434 148.267L97.17 149.616Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4374 146.79L92.7068 144.215L89.9707 142.866L88.7013 145.442L91.4374 146.79Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7047 143.965L86.9741 141.389L84.2381 140.041L82.9687 142.617L85.7047 143.965Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9721 141.14L81.2415 138.564L78.5054 137.216L77.236 139.791L79.9721 141.14Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2394 138.315L75.5088 135.739L72.7728 134.39L71.5034 136.966L74.2394 138.315Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5067 135.489L69.7761 132.914L67.0401 131.565L65.7707 134.141L68.5067 135.489Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7741 132.664L64.0435 130.088L61.3074 128.74L60.0381 131.316L62.7741 132.664Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0414 129.839L58.3108 127.263L55.5748 125.915L54.3054 128.49L57.0414 129.839Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3088 127.014L52.5782 124.438L49.8421 123.089L48.5727 125.665L51.3088 127.014Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5761 124.188L46.8455 121.613L44.1095 120.264L42.8401 122.84L45.5761 124.188Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8435 121.363L41.1129 118.787L38.3768 117.439L37.1074 120.015L39.8435 121.363Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1108 118.538L35.3802 115.962L32.6442 114.614L31.3748 117.189L34.1108 118.538Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3782 115.713L29.6475 113.137L26.9115 111.789L25.6421 114.364L28.3782 115.713Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6455 112.887L23.9149 110.312L21.1789 108.963L19.9095 111.539L22.6455 112.887Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9128 110.062L18.1822 107.486L15.4462 106.138L14.1768 108.714L16.9128 110.062Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1802 107.237L12.4496 104.661L9.71354 103.313L8.44414 105.888L11.1802 107.237Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44753 104.412L6.71693 101.836L3.98089 100.488L2.71149 103.063L5.44753 104.412Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.285126 101.586L0.984272 99.0107L-1.75177 97.6623L-3.02117 100.238L-0.285126 101.586Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.01778 98.7612L-4.74839 96.1855L-7.48443 94.8371L-8.75382 97.4128L-6.01778 98.7612Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.7504 95.9359L-10.481 93.3602L-13.2171 92.0118L-14.4865 94.5875L-11.7504 95.9359Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4265 156.558L98.7822 153.807L95.8602 152.367L94.5044 155.118L97.4265 156.558Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6939 153.733L93.0496 150.982L90.1275 149.542L88.7718 152.293L91.6939 153.733Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9612 150.908L87.3169 148.157L84.3948 146.717L83.0391 149.468L85.9612 150.908Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2286 148.083L81.5843 145.332L78.6622 143.892L77.3065 146.642L80.2286 148.083Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4959 145.257L75.8516 142.506L72.9295 141.066L71.5738 143.817L74.4959 145.257Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7633 142.432L70.119 139.681L67.1969 138.241L65.8412 140.992L68.7633 142.432Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0306 139.607L64.3863 136.856L61.4642 135.416L60.1085 138.167L63.0306 139.607Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2979 136.782L58.6537 134.031L55.7316 132.591L54.3759 135.342L57.2979 136.782Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5653 133.956L52.921 131.206L49.9989 129.765L48.6432 132.516L51.5653 133.956Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8326 131.131L47.1883 128.38L44.2663 126.94L42.9105 129.691L45.8326 131.131Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1 128.306L41.4557 125.555L38.5336 124.115L37.1779 126.866L40.1 128.306Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3673 125.481L35.723 122.73L32.8009 121.29L31.4452 124.041L34.3673 125.481Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6347 122.655L29.9904 119.905L27.0683 118.464L25.7126 121.215L28.6347 122.655Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M22.902 119.83L24.2577 117.079L21.3356 115.639L19.9799 118.39L22.902 119.83Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1694 117.005L18.5251 114.254L15.603 112.814L14.2473 115.565L17.1694 117.005Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4367 114.18L12.7924 111.429L9.87032 109.989L8.51461 112.74L11.4367 114.18Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70405 111.354L7.05976 108.604L4.13766 107.163L2.78195 109.914L5.70405 111.354Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0286123 108.529L1.3271 105.778L-1.59499 104.338L-2.9507 107.089L-0.0286123 108.529Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.76127 105.704L-4.40556 102.953L-7.32765 101.513L-8.68336 104.264L-5.76127 105.704Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.4939 102.879L-10.1382 100.128L-13.0603 98.6877L-14.416 101.439L-11.4939 102.879Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M-17.2266 100.053L-15.8709 97.3026L-18.793 95.8625L-20.1487 98.6134L-17.2266 100.053Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6801 163.493L99.1171 160.578L96.0199 159.051L94.5829 161.967L97.6801 163.493Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9474 160.668L93.3844 157.752L90.2872 156.226L88.8503 159.142L91.9474 160.668Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2148 157.843L87.6518 154.927L84.5546 153.401L83.1176 156.316L86.2148 157.843Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4821 155.017L81.9191 152.102L78.8219 150.575L77.3849 153.491L80.4821 155.017Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7495 152.192L76.1864 149.277L73.0892 147.75L71.6523 150.666L74.7495 152.192Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0168 149.367L70.4538 146.451L67.3566 144.925L65.9196 147.841L69.0168 149.367Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2842 146.542L64.7211 143.626L61.6239 142.1L60.187 145.015L63.2842 146.542Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5515 143.717L58.9885 140.801L55.8913 139.274L54.4543 142.19L57.5515 143.717Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8189 140.891L53.2558 137.976L50.1586 136.449L48.7217 139.365L51.8189 140.891Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0862 138.066L47.5232 135.15L44.426 133.624L42.989 136.54L46.0862 138.066Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3536 135.241L41.7905 132.325L38.6933 130.799L37.2564 133.714L40.3536 135.241Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6209 132.416L36.0579 129.5L32.9607 127.973L31.5237 130.889L34.6209 132.416Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8882 129.59L30.3252 126.675L27.228 125.148L25.7911 128.064L28.8882 129.59Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1556 126.765L24.5925 123.849L21.4953 122.323L20.0584 125.239L23.1556 126.765Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4229 123.94L18.8599 121.024L15.7627 119.498L14.3257 122.413L17.4229 123.94Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6903 121.115L13.1272 118.199L10.03 116.672L8.59308 119.588L11.6903 121.115Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95762 118.289L7.39457 115.374L4.29737 113.847L2.86042 116.763L5.95762 118.289Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M0.224961 115.464L1.66191 112.548L-1.43528 111.022L-2.87223 113.938L0.224961 115.464Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.50769 112.639L-4.07074 109.723L-7.16794 108.197L-8.60489 111.112L-5.50769 112.639Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.2403 109.814L-9.80339 106.898L-12.9006 105.372L-14.3375 108.287L-11.2403 109.814Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M-16.973 106.988L-15.536 104.073L-18.6332 102.546L-20.0702 105.462L-16.973 106.988Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M92.204 167.611L93.7272 164.52L90.444 162.902L88.9207 165.993L92.204 167.611Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4713 164.785L87.9946 161.695L84.7113 160.077L83.1881 163.167L86.4713 164.785Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7387 161.96L82.2619 158.869L78.9787 157.251L77.4554 160.342L80.7387 161.96Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M75.006 159.135L76.5293 156.044L73.246 154.426L71.7228 157.517L75.006 159.135Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2734 156.31L70.7966 153.219L67.5134 151.601L65.9901 154.692L69.2734 156.31Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5407 153.485L65.064 150.394L61.7807 148.776L60.2574 151.866L63.5407 153.485Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M57.808 150.659L59.3313 147.568L56.0481 145.95L54.5248 149.041L57.808 150.659Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0754 147.834L53.5987 144.743L50.3154 143.125L48.7921 146.216L52.0754 147.834Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3427 145.009L47.866 141.918L44.5828 140.3L43.0595 143.391L46.3427 145.009Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6101 142.184L42.1333 139.093L38.8501 137.475L37.3268 140.565L40.6101 142.184Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8774 139.358L36.4007 136.267L33.1174 134.649L31.5942 137.74L34.8774 139.358Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1448 136.533L30.668 133.442L27.3848 131.824L25.8615 134.915L29.1448 136.533Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4121 133.708L24.9354 130.617L21.6521 128.999L20.1289 132.09L23.4121 133.708Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6794 130.883L19.2027 127.792L15.9195 126.174L14.3962 129.264L17.6794 130.883Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9468 128.057L13.4701 124.966L10.1868 123.348L8.66355 126.439L11.9468 128.057Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21414 125.232L7.73741 122.141L4.45416 120.523L2.93089 123.614L6.21414 125.232Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0.481479 122.407L2.00475 119.316L-1.2785 117.698L-2.80177 120.789L0.481479 122.407Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.25117 119.582L-3.7279 116.491L-7.01115 114.873L-8.53442 117.964L-5.25117 119.582Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M-10.9838 116.756L-9.46056 113.666L-12.7438 112.047L-14.2671 115.138L-10.9838 116.756Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M-16.7165 113.931L-15.1932 110.84L-18.4765 109.222L-19.9997 112.313L-16.7165 113.931Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.4491 111.106L-20.9259 108.015L-24.2091 106.397L-25.7324 109.488L-22.4491 111.106Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4605 174.553L94.0701 171.288L90.6008 169.578L88.9912 172.844L92.4605 174.553Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7278 171.728L88.3374 168.462L84.8681 166.752L83.2585 170.018L86.7278 171.728Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9952 168.903L82.6048 165.637L79.1355 163.927L77.5259 167.193L80.9952 168.903Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2625 166.078L76.8721 162.812L73.4028 161.102L71.7932 164.368L75.2625 166.078Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5299 163.253L71.1395 159.987L67.6701 158.277L66.0606 161.543L69.5299 163.253Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7972 160.427L65.4068 157.161L61.9375 155.452L60.3279 158.718L63.7972 160.427Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0645 157.602L59.6741 154.336L56.2048 152.626L54.5953 155.892L58.0645 157.602Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3319 154.777L53.9415 151.511L50.4722 149.801L48.8626 153.067L52.3319 154.777Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5992 151.952L48.2088 148.686L44.7395 146.976L43.1299 150.242L46.5992 151.952Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8666 149.126L42.4762 145.86L39.0069 144.151L37.3973 147.417L40.8666 149.126Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1339 146.301L36.7435 143.035L33.2742 141.325L31.6646 144.591L35.1339 146.301Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4013 143.476L31.0109 140.21L27.5416 138.5L25.932 141.766L29.4013 143.476Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6686 140.651L25.2782 137.385L21.8089 135.675L20.1993 138.941L23.6686 140.651Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M17.936 137.825L19.5455 134.559L16.0762 132.85L14.4667 136.116L17.936 137.825Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2033 135L13.8129 131.734L10.3436 130.024L8.734 133.29L12.2033 135Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47064 132.175L8.08023 128.909L4.61094 127.199L3.00135 130.465L6.47064 132.175Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M0.737987 129.35L2.34758 126.084L-1.12172 124.374L-2.73131 127.64L0.737987 129.35Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.99466 126.524L-3.38508 123.258L-6.85438 121.549L-8.46397 124.815L-4.99466 126.524Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M-10.7273 123.699L-9.11773 120.433L-12.587 118.723L-14.1966 121.989L-10.7273 123.699Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M-16.46 120.874L-14.8504 117.608L-18.3197 115.898L-19.9293 119.164L-16.46 120.874Z",
    fill: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.1926 118.049L-20.583 114.783L-24.0523 113.073L-25.6619 116.339L-22.1926 118.049Z",
    fill: "black"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9814 178.663L88.6722 175.232L85.0278 173.436L83.337 176.867L86.9814 178.663Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2487 175.838L82.9396 172.407L79.2952 170.611L77.6043 174.042L81.2487 175.838Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5161 173.013L77.2069 169.582L73.5625 167.786L71.8717 171.217L75.5161 173.013Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7834 170.187L71.4743 166.757L67.8299 164.961L66.139 168.391L69.7834 170.187Z",
    fill: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0508 167.362L65.7416 163.931L62.0972 162.135L60.4064 165.566L64.0508 167.362Z",
    fill: "black"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3181 164.537L60.009 161.106L56.3645 159.31L54.6737 162.741L58.3181 164.537Z",
    fill: "black"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5855 161.712L54.2763 158.281L50.6319 156.485L48.9411 159.916L52.5855 161.712Z",
    fill: "black"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8528 158.886L48.5436 155.456L44.8992 153.66L43.2084 157.09L46.8528 158.886Z",
    fill: "black"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1201 156.061L42.811 152.63L39.1666 150.834L37.4757 154.265L41.1201 156.061Z",
    fill: "black"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3875 153.236L37.0783 149.805L33.4339 148.009L31.7431 151.44L35.3875 153.236Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6548 150.411L31.3457 146.98L27.7013 145.184L26.0104 148.615L29.6548 150.411Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9222 147.586L25.613 144.155L21.9686 142.359L20.2778 145.789L23.9222 147.586Z",
    fill: "black"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1895 144.76L19.8804 141.329L16.236 139.533L14.5451 142.964L18.1895 144.76Z",
    fill: "black"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4569 141.935L14.1477 138.504L10.5033 136.708L8.81247 140.139L12.4569 141.935Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72422 139.11L8.41505 135.679L4.77065 133.883L3.07981 137.314L6.72422 139.11Z",
    fill: "black"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M0.991565 136.285L2.6824 132.854L-0.962009 131.058L-2.65284 134.488L0.991565 136.285Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.74109 133.459L-3.05026 130.028L-6.69466 128.232L-8.38549 131.663L-4.74109 133.459Z",
    fill: "black"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M-10.4737 130.634L-8.78291 127.203L-12.4273 125.407L-14.1182 128.838L-10.4737 130.634Z",
    fill: "black"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M-16.2064 127.809L-14.5156 124.378L-18.16 122.582L-19.8508 126.013L-16.2064 127.809Z",
    fill: "black"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M-21.9391 124.984L-20.2482 121.553L-23.8926 119.757L-25.5835 123.187L-21.9391 124.984Z",
    fill: "black"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M-27.6717 122.158L-25.9809 118.727L-29.6253 116.931L-31.3161 120.362L-27.6717 122.158Z",
    fill: "black"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2379 185.606L89.0151 182L85.1846 180.112L83.4075 183.718L87.2379 185.606Z",
    fill: "black"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5053 182.781L83.2824 179.175L79.452 177.287L77.6748 180.893L81.5053 182.781Z",
    fill: "black"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7726 179.955L77.5497 176.349L73.7193 174.462L71.9421 178.068L75.7726 179.955Z",
    fill: "black"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0399 177.13L71.8171 173.524L67.9866 171.636L66.2095 175.242L70.0399 177.13Z",
    fill: "black"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3073 174.305L66.0844 170.699L62.254 168.811L60.4768 172.417L64.3073 174.305Z",
    fill: "black"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5746 171.48L60.3518 167.874L56.5213 165.986L54.7442 169.592L58.5746 171.48Z",
    fill: "black"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M52.842 168.654L54.6191 165.048L50.7887 163.161L49.0115 166.767L52.842 168.654Z",
    fill: "black"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1093 165.829L48.8865 162.223L45.056 160.335L43.2789 163.941L47.1093 165.829Z",
    fill: "black"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3767 163.004L43.1538 159.398L39.3234 157.51L37.5462 161.116L41.3767 163.004Z",
    fill: "black"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M35.644 160.179L37.4212 156.573L33.5907 154.685L31.8136 158.291L35.644 160.179Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9114 157.354L31.6885 153.748L27.8581 151.86L26.0809 155.466L29.9114 157.354Z",
    fill: "black"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1787 154.528L25.9559 150.922L22.1254 149.035L20.3482 152.64L24.1787 154.528Z",
    fill: "black"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M18.446 151.703L20.2232 148.097L16.3927 146.209L14.6156 149.815L18.446 151.703Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7134 148.878L14.4905 145.272L10.6601 143.384L8.88293 146.99L12.7134 148.878Z",
    fill: "black"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98073 146.053L8.75788 142.447L4.92743 140.559L3.15027 144.165L6.98073 146.053Z",
    fill: "black"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24808 143.227L3.02523 139.621L-0.805225 137.734L-2.58238 141.34L1.24808 143.227Z",
    fill: "black"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.48458 140.402L-2.70742 136.796L-6.53788 134.908L-8.31504 138.514L-4.48458 140.402Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M-10.2172 137.577L-8.44008 133.971L-12.2705 132.083L-14.0477 135.689L-10.2172 137.577Z",
    fill: "black"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.9499 134.752L-14.1727 131.146L-18.0032 129.258L-19.7803 132.864L-15.9499 134.752Z",
    fill: "black"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M-21.6825 131.926L-19.9054 128.32L-23.7359 126.433L-25.513 130.039L-21.6825 131.926Z",
    fill: "black"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M-27.4152 129.101L-25.638 125.495L-29.4685 123.607L-31.2457 127.213L-27.4152 129.101Z",
    fill: "black"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7618 189.723L83.6252 185.942L79.6087 183.963L77.7453 187.744L81.7618 189.723Z",
    fill: "black"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0291 186.898L77.8926 183.117L73.8761 181.138L72.0126 184.919L76.0291 186.898Z",
    fill: "black"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2965 184.073L72.1599 180.292L68.1434 178.312L66.2799 182.094L70.2965 184.073Z",
    fill: "black"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5638 181.248L66.4273 177.467L62.4108 175.487L60.5473 179.268L64.5638 181.248Z",
    fill: "black"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8311 178.422L60.6946 174.641L56.6781 172.662L54.8146 176.443L58.8311 178.422Z",
    fill: "black"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0985 175.597L54.9619 171.816L50.9454 169.837L49.082 173.618L53.0985 175.597Z",
    fill: "black"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3658 172.772L49.2293 168.991L45.2128 167.011L43.3493 170.793L47.3658 172.772Z",
    fill: "black"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6332 169.947L43.4966 166.166L39.4801 164.186L37.6167 167.967L41.6332 169.947Z",
    fill: "black"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9005 167.122L37.764 163.34L33.7475 161.361L31.884 165.142L35.9005 167.122Z",
    fill: "black"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1679 164.296L32.0313 160.515L28.0148 158.536L26.1514 162.317L30.1679 164.296Z",
    fill: "black"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4352 161.471L26.2987 157.69L22.2822 155.71L20.4187 159.492L24.4352 161.471Z",
    fill: "black"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7026 158.646L20.566 154.865L16.5495 152.885L14.686 156.666L18.7026 158.646Z",
    fill: "black"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9699 155.821L14.8334 152.039L10.8169 150.06L8.9534 153.841L12.9699 155.821Z",
    fill: "black"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23724 152.995L9.10071 149.214L5.0842 147.235L3.22073 151.016L7.23724 152.995Z",
    fill: "black"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50459 150.17L3.36806 146.389L-0.648457 144.409L-2.51192 148.191L1.50459 150.17Z",
    fill: "black"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.22807 147.345L-2.3646 143.564L-6.38111 141.584L-8.24457 145.365L-4.22807 147.345Z",
    fill: "black"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.96072 144.52L-8.09725 140.738L-12.1138 138.759L-13.9772 142.54L-9.96072 144.52Z",
    fill: "black"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.6934 141.694L-13.8299 137.913L-17.8464 135.934L-19.7099 139.715L-15.6934 141.694Z",
    fill: "black"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M-21.426 138.869L-19.5626 135.088L-23.5791 133.108L-25.4425 136.89L-21.426 138.869Z",
    fill: "black"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M-27.1587 136.044L-25.2952 132.263L-29.3117 130.283L-31.1752 134.064L-27.1587 136.044Z",
    fill: "black"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M-32.8913 133.219L-31.0279 129.437L-35.0444 127.458L-36.9079 131.239L-32.8913 133.219Z",
    fill: "black"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0153 196.658L83.96 192.712L79.7684 190.647L77.8237 194.593L82.0153 196.658Z",
    fill: "black"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2827 193.833L78.2274 189.887L74.0358 187.821L72.0911 191.767L76.2827 193.833Z",
    fill: "black"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M70.55 191.008L72.4947 187.062L68.3031 184.996L66.3584 188.942L70.55 191.008Z",
    fill: "black"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8174 188.183L66.7621 184.237L62.5705 182.171L60.6258 186.117L64.8174 188.183Z",
    fill: "black"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0847 185.357L61.0294 181.411L56.8378 179.346L54.8931 183.292L59.0847 185.357Z",
    fill: "black"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3521 182.532L55.2968 178.586L51.1052 176.52L49.1605 180.466L53.3521 182.532Z",
    fill: "black"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6194 179.707L49.5641 175.761L45.3725 173.695L43.4278 177.641L47.6194 179.707Z",
    fill: "black"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8868 176.882L43.8315 172.936L39.6398 170.87L37.6951 174.816L41.8868 176.882Z",
    fill: "black"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1541 174.056L38.0988 170.11L33.9072 168.045L31.9625 171.991L36.1541 174.056Z",
    fill: "black"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4214 171.231L32.3661 167.285L28.1745 165.219L26.2298 169.165L30.4214 171.231Z",
    fill: "black"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6888 168.406L26.6335 164.46L22.4419 162.394L20.4972 166.34L24.6888 168.406Z",
    fill: "black"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9561 165.581L20.9008 161.635L16.7092 159.569L14.7645 163.515L18.9561 165.581Z",
    fill: "black"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2235 162.755L15.1682 158.809L10.9766 156.744L9.03186 160.69L13.2235 162.755Z",
    fill: "black"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49082 159.93L9.43553 155.984L5.24391 153.918L3.2992 157.864L7.49082 159.93Z",
    fill: "black"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75816 157.105L3.70287 153.159L-0.488738 151.093L-2.43345 155.039L1.75816 157.105Z",
    fill: "black"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.97449 154.28L-2.02978 150.334L-6.2214 148.268L-8.16611 152.214L-3.97449 154.28Z",
    fill: "black"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.70715 151.454L-7.76244 147.509L-11.9541 145.443L-13.8988 149.389L-9.70715 151.454Z",
    fill: "black"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.4398 148.629L-13.4951 144.683L-17.6867 142.618L-19.6314 146.563L-15.4398 148.629Z",
    fill: "black"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M-21.1725 145.804L-19.2277 141.858L-23.4194 139.792L-25.3641 143.738L-21.1725 145.804Z",
    fill: "black"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M-26.9051 142.979L-24.9604 139.033L-29.152 136.967L-31.0967 140.913L-26.9051 142.979Z",
    fill: "black"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M-32.6378 140.154L-30.6931 136.208L-34.8847 134.142L-36.8294 138.088L-32.6378 140.154Z",
    fill: "black"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5392 200.776L78.5702 196.655L74.1926 194.497L72.1615 198.618L76.5392 200.776Z",
    fill: "black"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8065 197.951L72.8376 193.83L68.4599 191.672L66.4289 195.793L70.8065 197.951Z",
    fill: "black"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0739 195.125L67.1049 191.004L62.7273 188.847L60.6962 192.968L65.0739 195.125Z",
    fill: "black"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3412 192.3L61.3723 188.179L56.9946 186.022L54.9636 190.143L59.3412 192.3Z",
    fill: "black"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6086 189.475L55.6396 185.354L51.2619 183.196L49.2309 187.317L53.6086 189.475Z",
    fill: "black"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8759 186.65L49.907 182.529L45.5293 180.371L43.4983 184.492L47.8759 186.65Z",
    fill: "black"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1433 183.824L44.1743 179.703L39.7966 177.546L37.7656 181.667L42.1433 183.824Z",
    fill: "black"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4106 180.999L38.4416 176.878L34.064 174.721L32.0329 178.842L36.4106 180.999Z",
    fill: "black"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M30.678 178.174L32.709 174.053L28.3313 171.895L26.3003 176.016L30.678 178.174Z",
    fill: "black"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9453 175.349L26.9763 171.228L22.5987 169.07L20.5676 173.191L24.9453 175.349Z",
    fill: "black"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2126 172.523L21.2437 168.402L16.866 166.245L14.835 170.366L19.2126 172.523Z",
    fill: "black"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M13.48 169.698L15.511 165.577L11.1334 163.42L9.10232 167.541L13.48 169.698Z",
    fill: "black"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74733 166.873L9.77837 162.752L5.4007 160.594L3.36966 164.716L7.74733 166.873Z",
    fill: "black"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01467 164.048L4.0457 159.927L-0.331957 157.769L-2.36299 161.89L2.01467 164.048Z",
    fill: "black"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.71798 161.223L-1.68695 157.101L-6.06461 154.944L-8.09564 159.065L-3.71798 161.223Z",
    fill: "black"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.45063 158.397L-7.4196 154.276L-11.7973 152.119L-13.8283 156.24L-9.45063 158.397Z",
    fill: "black"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.1833 155.572L-13.1523 151.451L-17.5299 149.293L-19.561 153.415L-15.1833 155.572Z",
    fill: "black"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M-20.9159 152.747L-18.8849 148.626L-23.2626 146.468L-25.2936 150.589L-20.9159 152.747Z",
    fill: "black"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M-26.6486 149.922L-24.6176 145.8L-28.9952 143.643L-31.0263 147.764L-26.6486 149.922Z",
    fill: "black"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M-32.3813 147.096L-30.3502 142.975L-34.7279 140.818L-36.7589 144.939L-32.3813 147.096Z",
    fill: "black"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M-38.1139 144.271L-36.0829 140.15L-40.4605 137.992L-42.4916 142.114L-38.1139 144.271Z",
    fill: "black"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M260.91 102.527L261.25 101.836L260.517 101.475L260.177 102.165L260.91 102.527Z",
    fill: "black"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M255.177 99.7015L255.517 99.0112L254.784 98.6498L254.444 99.3401L255.177 99.7015Z",
    fill: "black"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M249.445 96.8762L249.785 96.1859L249.052 95.8246L248.711 96.5149L249.445 96.8762Z",
    fill: "black"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M243.712 94.051L244.052 93.3607L243.319 92.9993L242.979 93.6896L243.712 94.051Z",
    fill: "black"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M237.979 91.2258L238.319 90.5355L237.586 90.1741L237.246 90.8644L237.979 91.2258Z",
    fill: "black"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M232.247 88.4005L232.587 87.7102L231.854 87.3488L231.513 88.0391L232.247 88.4005Z",
    fill: "black"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M226.514 85.5753L226.854 84.885L226.121 84.5236L225.781 85.2139L226.514 85.5753Z",
    fill: "black"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M220.781 82.75L221.122 82.0597L220.388 81.6984L220.048 82.3887L220.781 82.75Z",
    fill: "black"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M215.049 79.9248L215.389 79.2345L214.656 78.8731L214.315 79.5634L215.049 79.9248Z",
    fill: "black"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M209.316 77.0995L209.656 76.4092L208.923 76.0479L208.583 76.7382L209.316 77.0995Z",
    fill: "black"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M203.583 74.2743L203.924 73.584L203.19 73.2226L202.85 73.9129L203.583 74.2743Z",
    fill: "black"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M197.851 71.4491L198.191 70.7588L197.458 70.3974L197.117 71.0877L197.851 71.4491Z",
    fill: "black"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M192.118 68.6238L192.458 67.9335L191.725 67.5721L191.385 68.2624L192.118 68.6238Z",
    fill: "black"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M186.385 65.7986L186.726 65.1083L185.992 64.7469L185.652 65.4372L186.385 65.7986Z",
    fill: "black"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M180.653 62.9733L180.993 62.283L180.26 61.9217L179.919 62.612L180.653 62.9733Z",
    fill: "black"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M174.92 60.1481L175.26 59.4578L174.527 59.0964L174.187 59.7867L174.92 60.1481Z",
    fill: "black"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M169.187 57.3228L169.528 56.6326L168.794 56.2712L168.454 56.9615L169.187 57.3228Z",
    fill: "black"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M163.455 54.4976L163.795 53.8073L163.062 53.4459L162.721 54.1362L163.455 54.4976Z",
    fill: "black"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M157.722 51.6724L158.062 50.9821L157.329 50.6207L156.989 51.311L157.722 51.6724Z",
    fill: "black"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M261.163 109.462L261.585 108.606L260.677 108.159L260.255 109.014L261.163 109.462Z",
    fill: "black"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M255.431 106.636L255.852 105.781L254.944 105.334L254.522 106.189L255.431 106.636Z",
    fill: "black"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M249.698 103.811L250.12 102.956L249.211 102.508L248.79 103.363L249.698 103.811Z",
    fill: "black"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M243.966 100.986L244.387 100.131L243.479 99.6831L243.057 100.538L243.966 100.986Z",
    fill: "black"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M238.233 98.1607L238.654 97.3055L237.746 96.8579L237.324 97.713L238.233 98.1607Z",
    fill: "black"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M232.5 95.3354L232.922 94.4803L232.013 94.0326L231.592 94.8877L232.5 95.3354Z",
    fill: "black"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M226.768 92.5102L227.189 91.655L226.281 91.2074L225.859 92.0625L226.768 92.5102Z",
    fill: "black"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M221.035 89.6849L221.456 88.8298L220.548 88.3821L220.127 89.2373L221.035 89.6849Z",
    fill: "black"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M215.302 86.8597L215.724 86.0046L214.815 85.5569L214.394 86.412L215.302 86.8597Z",
    fill: "black"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M209.57 84.0345L209.991 83.1793L209.083 82.7316L208.661 83.5868L209.57 84.0345Z",
    fill: "black"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M203.837 81.2092L204.258 80.3541L203.35 79.9064L202.929 80.7615L203.837 81.2092Z",
    fill: "black"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M198.104 78.384L198.526 77.5288L197.617 77.0812L197.196 77.9363L198.104 78.384Z",
    fill: "black"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M192.372 75.5587L192.793 74.7036L191.885 74.2559L191.463 75.1111L192.372 75.5587Z",
    fill: "black"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M186.639 72.7335L187.06 71.8784L186.152 71.4307L185.731 72.2858L186.639 72.7335Z",
    fill: "black"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M180.906 69.9082L181.328 69.0531L180.419 68.6054L179.998 69.4606L180.906 69.9082Z",
    fill: "black"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M175.174 67.083L175.595 66.2279L174.687 65.7802L174.265 66.6353L175.174 67.083Z",
    fill: "black"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M169.441 64.2578L169.862 63.4026L168.954 62.955L168.533 63.8101L169.441 64.2578Z",
    fill: "black"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M163.708 61.4325L164.13 60.5774L163.221 60.1297L162.8 60.9848L163.708 61.4325Z",
    fill: "black"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M157.976 58.6073L158.397 57.7521L157.489 57.3045L157.067 58.1596L157.976 58.6073Z",
    fill: "black"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M261.42 116.404L261.928 115.374L260.833 114.835L260.326 115.865L261.42 116.404Z",
    fill: "black"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M255.687 113.579L256.195 112.549L255.101 112.01L254.593 113.04L255.687 113.579Z",
    fill: "black"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M249.955 110.754L250.462 109.724L249.368 109.184L248.86 110.215L249.955 110.754Z",
    fill: "black"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M244.222 107.929L244.73 106.898L243.635 106.359L243.128 107.389L244.222 107.929Z",
    fill: "black"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M238.489 105.103L238.997 104.073L237.903 103.534L237.395 104.564L238.489 105.103Z",
    fill: "black"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M232.757 102.278L233.264 101.248L232.17 100.709L231.662 101.739L232.757 102.278Z",
    fill: "black"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M227.024 99.4529L227.532 98.4227L226.437 97.8833L225.93 98.9136L227.024 99.4529Z",
    fill: "black"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M221.291 96.6277L221.799 95.5974L220.705 95.0581L220.197 96.0883L221.291 96.6277Z",
    fill: "black"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M215.559 93.8025L216.067 92.7722L214.972 92.2328L214.464 93.2631L215.559 93.8025Z",
    fill: "black"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M209.826 90.9772L210.334 89.9469L209.239 89.4076L208.732 90.4379L209.826 90.9772Z",
    fill: "black"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M204.093 88.152L204.601 87.1217L203.507 86.5823L202.999 87.6126L204.093 88.152Z",
    fill: "black"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M198.361 85.3267L198.869 84.2965L197.774 83.7571L197.266 84.7874L198.361 85.3267Z",
    fill: "black"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M192.628 82.5015L193.136 81.4712L192.041 80.9318L191.534 81.9621L192.628 82.5015Z",
    fill: "black"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M186.895 79.6763L187.403 78.646L186.309 78.1066L185.801 79.1369L186.895 79.6763Z",
    fill: "black"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M181.163 76.851L181.671 75.8207L180.576 75.2814L180.068 76.3116L181.163 76.851Z",
    fill: "black"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M175.43 74.0258L175.938 72.9955L174.843 72.4561L174.336 73.4864L175.43 74.0258Z",
    fill: "black"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M169.698 71.2005L170.205 70.1702L169.111 69.6309L168.603 70.6612L169.698 71.2005Z",
    fill: "black"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M163.965 68.3753L164.473 67.345L163.378 66.8056L162.87 67.8359L163.965 68.3753Z",
    fill: "black"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M158.232 65.55L158.74 64.5198L157.646 63.9804L157.138 65.0107L158.232 65.55Z",
    fill: "black"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 62.7248L153.007 61.6945L151.913 61.1552L151.405 62.1854L152.5 62.7248Z",
    fill: "black"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M261.677 123.347L262.271 122.142L260.99 121.511L260.396 122.716L261.677 123.347Z",
    fill: "black"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M255.944 120.522L256.538 119.316L255.257 118.685L254.663 119.891L255.944 120.522Z",
    fill: "black"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M250.211 117.697L250.805 116.491L249.525 115.86L248.931 117.066L250.211 117.697Z",
    fill: "black"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M244.479 114.871L245.073 113.666L243.792 113.035L243.198 114.24L244.479 114.871Z",
    fill: "black"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M238.746 112.046L239.34 110.841L238.059 110.21L237.465 111.415L238.746 112.046Z",
    fill: "black"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M233.013 109.221L233.607 108.016L232.327 107.384L231.733 108.59L233.013 109.221Z",
    fill: "black"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M227.281 106.396L227.875 105.19L226.594 104.559L226 105.765L227.281 106.396Z",
    fill: "black"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M221.548 103.57L222.142 102.365L220.862 101.734L220.267 102.939L221.548 103.57Z",
    fill: "black"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M215.815 100.745L216.409 99.5398L215.129 98.9087L214.535 100.114L215.815 100.745Z",
    fill: "black"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M210.083 97.92L210.677 96.7145L209.396 96.0835L208.802 97.2889L210.083 97.92Z",
    fill: "black"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M204.35 95.0947L204.944 93.8893L203.664 93.2583L203.069 94.4637L204.35 95.0947Z",
    fill: "black"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M198.617 92.2695L199.211 91.0641L197.931 90.433L197.337 91.6384L198.617 92.2695Z",
    fill: "black"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M192.885 89.4443L193.479 88.2388L192.198 87.6078L191.604 88.8132L192.885 89.4443Z",
    fill: "black"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M187.152 86.619L187.746 85.4136L186.466 84.7825L185.872 85.988L187.152 86.619Z",
    fill: "black"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M181.419 83.7938L182.013 82.5883L180.733 81.9573L180.139 83.1627L181.419 83.7938Z",
    fill: "black"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M175.687 80.9685L176.281 79.7631L175 79.132L174.406 80.3375L175.687 80.9685Z",
    fill: "black"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M169.954 78.1433L170.548 76.9379L169.268 76.3068L168.674 77.5122L169.954 78.1433Z",
    fill: "black"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M164.221 75.318L164.815 74.1126L163.535 73.4816L162.941 74.687L164.221 75.318Z",
    fill: "black"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M158.489 72.4928L159.083 71.2874L157.802 70.6563L157.208 71.8617L158.489 72.4928Z",
    fill: "black"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M152.756 69.6676L153.35 68.4621L152.07 67.8311L151.476 69.0365L152.756 69.6676Z",
    fill: "black"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M261.93 130.282L262.605 128.912L261.15 128.194L260.475 129.565L261.93 130.282Z",
    fill: "black"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M256.197 127.457L256.873 126.087L255.417 125.369L254.742 126.739L256.197 127.457Z",
    fill: "black"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M250.465 124.632L251.14 123.261L249.685 122.544L249.009 123.914L250.465 124.632Z",
    fill: "black"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M244.732 121.806L245.407 120.436L243.952 119.719L243.277 121.089L244.732 121.806Z",
    fill: "black"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M238.999 118.981L239.675 117.611L238.219 116.893L237.544 118.264L238.999 118.981Z",
    fill: "black"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M233.267 116.156L233.942 114.786L232.487 114.068L231.811 115.439L233.267 116.156Z",
    fill: "black"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M227.534 113.331L228.209 111.96L226.754 111.243L226.079 112.613L227.534 113.331Z",
    fill: "black"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M221.801 110.505L222.477 109.135L221.021 108.418L220.346 109.788L221.801 110.505Z",
    fill: "black"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M216.069 107.68L216.744 106.31L215.289 105.593L214.613 106.963L216.069 107.68Z",
    fill: "black"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M210.336 104.855L211.011 103.485L209.556 102.767L208.881 104.138L210.336 104.855Z",
    fill: "black"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M204.604 102.03L205.279 100.659L203.823 99.942L203.148 101.312L204.604 102.03Z",
    fill: "black"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M198.871 99.2044L199.546 97.8341L198.091 97.1168L197.415 98.4871L198.871 99.2044Z",
    fill: "black"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M193.138 96.3792L193.814 95.0089L192.358 94.2915L191.683 95.6618L193.138 96.3792Z",
    fill: "black"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M187.406 93.5539L188.081 92.1837L186.625 91.4663L185.95 92.8366L187.406 93.5539Z",
    fill: "black"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M181.673 90.7287L182.348 89.3584L180.893 88.6411L180.217 90.0113L181.673 90.7287Z",
    fill: "black"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M175.94 87.9034L176.616 86.5332L175.16 85.8158L174.485 87.1861L175.94 87.9034Z",
    fill: "black"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M170.208 85.0782L170.883 83.7079L169.427 82.9906L168.752 84.3609L170.208 85.0782Z",
    fill: "black"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M164.475 82.253L165.15 80.8827L163.695 80.1653L163.019 81.5356L164.475 82.253Z",
    fill: "black"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M158.742 79.4277L159.418 78.0574L157.962 77.3401L157.287 78.7104L158.742 79.4277Z",
    fill: "black"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M153.01 76.6025L153.685 75.2322L152.229 74.5148L151.554 75.8851L153.01 76.6025Z",
    fill: "black"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M147.277 73.7772L147.952 72.407L146.497 71.6896L145.821 73.0599L147.277 73.7772Z",
    fill: "black"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M262.187 137.225L262.948 135.679L261.307 134.87L260.545 136.416L262.187 137.225Z",
    fill: "black"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M256.454 134.4L257.216 132.854L255.574 132.045L254.812 133.591L256.454 134.4Z",
    fill: "black"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M250.721 131.574L251.483 130.029L249.841 129.22L249.08 130.765L250.721 131.574Z",
    fill: "black"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M244.989 128.749L245.75 127.204L244.109 126.395L243.347 127.94L244.989 128.749Z",
    fill: "black"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M239.256 125.924L240.018 124.378L238.376 123.569L237.614 125.115L239.256 125.924Z",
    fill: "black"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M233.523 123.099L234.285 121.553L232.643 120.744L231.882 122.29L233.523 123.099Z",
    fill: "black"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M227.791 120.273L228.552 118.728L226.911 117.919L226.149 119.464L227.791 120.273Z",
    fill: "black"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M222.058 117.448L222.82 115.903L221.178 115.094L220.416 116.639L222.058 117.448Z",
    fill: "black"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M216.325 114.623L217.087 113.077L215.445 112.268L214.684 113.814L216.325 114.623Z",
    fill: "black"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M210.593 111.798L211.354 110.252L209.713 109.443L208.951 110.989L210.593 111.798Z",
    fill: "black"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M204.86 108.972L205.622 107.427L203.98 106.618L203.218 108.163L204.86 108.972Z",
    fill: "black"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M199.127 106.147L199.889 104.602L198.247 103.793L197.486 105.338L199.127 106.147Z",
    fill: "black"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M193.395 103.322L194.156 101.777L192.515 100.967L191.753 102.513L193.395 103.322Z",
    fill: "black"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M187.662 100.497L188.424 98.9513L186.782 98.1422L186.02 99.6876L187.662 100.497Z",
    fill: "black"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M181.929 97.6714L182.691 96.126L181.049 95.317L180.288 96.8624L181.929 97.6714Z",
    fill: "black"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M176.197 94.8462L176.958 93.3008L175.317 92.4917L174.555 94.0372L176.197 94.8462Z",
    fill: "black"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M170.464 92.021L171.226 90.4755L169.584 89.6665L168.822 91.2119L170.464 92.021Z",
    fill: "black"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M164.731 89.1957L165.493 87.6503L163.851 86.8413L163.09 88.3867L164.731 89.1957Z",
    fill: "black"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M158.999 86.3705L159.76 84.8251L158.119 84.016L157.357 85.5614L158.999 86.3705Z",
    fill: "black"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M153.266 83.5452L154.028 81.9998L152.386 81.1908L151.625 82.7362L153.266 83.5452Z",
    fill: "black"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M147.533 80.72L148.295 79.1746L146.653 78.3655L145.892 79.911L147.533 80.72Z",
    fill: "black"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M256.71 141.342L257.558 139.622L255.731 138.721L254.883 140.442L256.71 141.342Z",
    fill: "black"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M250.978 138.517L251.826 136.797L249.998 135.896L249.15 137.616L250.978 138.517Z",
    fill: "black"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M245.245 135.692L246.093 133.971L244.265 133.071L243.417 134.791L245.245 135.692Z",
    fill: "black"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M239.512 132.867L240.36 131.146L238.533 130.245L237.685 131.966L239.512 132.867Z",
    fill: "black"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M233.78 130.041L234.628 128.321L232.8 127.42L231.952 129.141L233.78 130.041Z",
    fill: "black"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M228.047 127.216L228.895 125.496L227.067 124.595L226.219 126.315L228.047 127.216Z",
    fill: "black"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M222.315 124.391L223.162 122.67L221.335 121.77L220.487 123.49L222.315 124.391Z",
    fill: "black"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M216.582 121.566L217.43 119.845L215.602 118.944L214.754 120.665L216.582 121.566Z",
    fill: "black"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M210.849 118.74L211.697 117.02L209.869 116.119L209.022 117.84L210.849 118.74Z",
    fill: "black"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M205.117 115.915L205.964 114.195L204.137 113.294L203.289 115.014L205.117 115.915Z",
    fill: "black"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M199.384 113.09L200.232 111.369L198.404 110.469L197.556 112.189L199.384 113.09Z",
    fill: "black"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M193.651 110.265L194.499 108.544L192.672 107.643L191.824 109.364L193.651 110.265Z",
    fill: "black"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M187.919 107.439L188.767 105.719L186.939 104.818L186.091 106.539L187.919 107.439Z",
    fill: "black"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M182.186 104.614L183.034 102.894L181.206 101.993L180.358 103.713L182.186 104.614Z",
    fill: "black"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M176.453 101.789L177.301 100.068L175.474 99.1677L174.626 100.888L176.453 101.789Z",
    fill: "black"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M170.721 98.9637L171.569 97.2432L169.741 96.3424L168.893 98.063L170.721 98.9637Z",
    fill: "black"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M164.988 96.1385L165.836 94.4179L164.008 93.5172L163.16 95.2378L164.988 96.1385Z",
    fill: "black"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M159.255 93.3132L160.103 91.5927L158.276 90.6919L157.428 92.4125L159.255 93.3132Z",
    fill: "black"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M153.523 90.488L154.371 88.7674L152.543 87.8667L151.695 89.5873L153.523 90.488Z",
    fill: "black"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M147.79 87.6628L148.638 85.9422L146.81 85.0414L145.962 86.762L147.79 87.6628Z",
    fill: "black"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M142.057 84.8375L142.905 83.1169L141.078 82.2162L140.23 83.9368L142.057 84.8375Z",
    fill: "black"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M256.964 148.277L257.893 146.392L255.89 145.405L254.961 147.29L256.964 148.277Z",
    fill: "black"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M251.231 145.452L252.161 143.567L250.158 142.58L249.229 144.465L251.231 145.452Z",
    fill: "black"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M245.499 142.627L246.428 140.741L244.425 139.754L243.496 141.64L245.499 142.627Z",
    fill: "black"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M239.766 139.802L240.695 137.916L238.692 136.929L237.763 138.815L239.766 139.802Z",
    fill: "black"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M234.033 136.976L234.963 135.091L232.96 134.104L232.031 135.989L234.033 136.976Z",
    fill: "black"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M228.301 134.151L229.23 132.266L227.227 131.279L226.298 133.164L228.301 134.151Z",
    fill: "black"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M222.568 131.326L223.497 129.44L221.495 128.453L220.565 130.339L222.568 131.326Z",
    fill: "black"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M216.835 128.501L217.765 126.615L215.762 125.628L214.833 127.514L216.835 128.501Z",
    fill: "black"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M211.103 125.675L212.032 123.79L210.029 122.803L209.1 124.688L211.103 125.675Z",
    fill: "black"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M205.37 122.85L206.299 120.965L204.297 119.978L203.367 121.863L205.37 122.85Z",
    fill: "black"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M199.637 120.025L200.567 118.139L198.564 117.152L197.635 119.038L199.637 120.025Z",
    fill: "black"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M193.905 117.2L194.834 115.314L192.831 114.327L191.902 116.213L193.905 117.2Z",
    fill: "black"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M188.172 114.374L189.101 112.489L187.099 111.502L186.169 113.387L188.172 114.374Z",
    fill: "black"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M182.439 111.549L183.369 109.664L181.366 108.677L180.437 110.562L182.439 111.549Z",
    fill: "black"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M176.707 108.724L177.636 106.838L175.633 105.851L174.704 107.737L176.707 108.724Z",
    fill: "black"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M170.974 105.899L171.903 104.013L169.901 103.026L168.971 104.912L170.974 105.899Z",
    fill: "black"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M165.242 103.073L166.171 101.188L164.168 100.201L163.239 102.086L165.242 103.073Z",
    fill: "black"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M159.509 100.248L160.438 98.3627L158.435 97.3757L157.506 99.2611L159.509 100.248Z",
    fill: "black"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M153.776 97.4229L154.705 95.5375L152.703 94.5505L151.773 96.4359L153.776 97.4229Z",
    fill: "black"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M148.044 94.5977L148.973 92.7123L146.97 91.7252L146.041 93.6106L148.044 94.5977Z",
    fill: "black"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M142.311 91.7724L143.24 89.887L141.237 88.9L140.308 90.7854L142.311 91.7724Z",
    fill: "black"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M251.488 152.395L252.503 150.334L250.315 149.255L249.299 151.316L251.488 152.395Z",
    fill: "black"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M245.755 149.57L246.771 147.509L244.582 146.43L243.566 148.491L245.755 149.57Z",
    fill: "black"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M240.023 146.744L241.038 144.684L238.849 143.605L237.834 145.666L240.023 146.744Z",
    fill: "black"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M234.29 143.919L235.305 141.859L233.117 140.78L232.101 142.84L234.29 143.919Z",
    fill: "black"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M228.557 141.094L229.573 139.033L227.384 137.955L226.368 140.015L228.557 141.094Z",
    fill: "black"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M222.825 138.269L223.84 136.208L221.651 135.129L220.636 137.19L222.825 138.269Z",
    fill: "black"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M217.092 135.443L218.107 133.383L215.919 132.304L214.903 134.365L217.092 135.443Z",
    fill: "black"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M211.359 132.618L212.375 130.558L210.186 129.479L209.17 131.539L211.359 132.618Z",
    fill: "black"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M205.627 129.793L206.642 127.732L204.453 126.654L203.438 128.714L205.627 129.793Z",
    fill: "black"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M199.894 126.968L200.909 124.907L198.721 123.828L197.705 125.889L199.894 126.968Z",
    fill: "black"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M194.161 124.142L195.177 122.082L192.988 121.003L191.972 123.064L194.161 124.142Z",
    fill: "black"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M188.429 121.317L189.444 119.257L187.255 118.178L186.24 120.238L188.429 121.317Z",
    fill: "black"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M182.696 118.492L183.712 116.431L181.523 115.353L180.507 117.413L182.696 118.492Z",
    fill: "black"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M176.963 115.667L177.979 113.606L175.79 112.527L174.775 114.588L176.963 115.667Z",
    fill: "black"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M171.231 112.841L172.246 110.781L170.057 109.702L169.042 111.763L171.231 112.841Z",
    fill: "black"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M165.498 110.016L166.514 107.956L164.325 106.877L163.309 108.937L165.498 110.016Z",
    fill: "black"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M159.765 107.191L160.781 105.13L158.592 104.052L157.577 106.112L159.765 107.191Z",
    fill: "black"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M154.033 104.366L155.048 102.305L152.859 101.226L151.844 103.287L154.033 104.366Z",
    fill: "black"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M148.3 101.54L149.316 99.4799L147.127 98.4011L146.111 100.462L148.3 101.54Z",
    fill: "black"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M142.567 98.7152L143.583 96.6546L141.394 95.5759L140.379 97.6365L142.567 98.7152Z",
    fill: "black"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M136.835 95.89L137.85 93.8294L135.661 92.7507L134.646 94.8112L136.835 95.89Z",
    fill: "black"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M251.744 159.338L252.846 157.102L250.471 155.931L249.37 158.167L251.744 159.338Z",
    fill: "black"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M246.012 156.512L247.114 154.277L244.739 153.106L243.637 155.342L246.012 156.512Z",
    fill: "black"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M240.279 153.687L241.381 151.451L239.006 150.281L237.904 152.517L240.279 153.687Z",
    fill: "black"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M234.546 150.862L235.648 148.626L233.273 147.456L232.172 149.691L234.546 150.862Z",
    fill: "black"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M228.814 148.037L229.916 145.801L227.541 144.63L226.439 146.866L228.814 148.037Z",
    fill: "black"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M223.081 145.211L224.183 142.976L221.808 141.805L220.706 144.041L223.081 145.211Z",
    fill: "black"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M217.348 142.386L218.45 140.15L216.075 138.98L214.974 141.216L217.348 142.386Z",
    fill: "black"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M211.616 139.561L212.718 137.325L210.343 136.155L209.241 138.39L211.616 139.561Z",
    fill: "black"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M205.883 136.736L206.985 134.5L204.61 133.329L203.508 135.565L205.883 136.736Z",
    fill: "black"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M200.15 133.91L201.252 131.675L198.877 130.504L197.776 132.74L200.15 133.91Z",
    fill: "black"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M194.418 131.085L195.52 128.849L193.145 127.679L192.043 129.915L194.418 131.085Z",
    fill: "black"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M188.685 128.26L189.787 126.024L187.412 124.854L186.31 127.089L188.685 128.26Z",
    fill: "black"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M182.953 125.435L184.054 123.199L181.679 122.029L180.578 124.264L182.953 125.435Z",
    fill: "black"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M177.22 122.609L178.322 120.374L175.947 119.203L174.845 121.439L177.22 122.609Z",
    fill: "black"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M171.487 119.784L172.589 117.548L170.214 116.378L169.112 118.614L171.487 119.784Z",
    fill: "black"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M165.755 116.959L166.856 114.723L164.482 113.553L163.38 115.789L165.755 116.959Z",
    fill: "black"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M160.022 114.134L161.124 111.898L158.749 110.728L157.647 112.963L160.022 114.134Z",
    fill: "black"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M154.289 111.308L155.391 109.073L153.016 107.902L151.914 110.138L154.289 111.308Z",
    fill: "black"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M148.557 108.483L149.658 106.247L147.284 105.077L146.182 107.313L148.557 108.483Z",
    fill: "black"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M142.824 105.658L143.926 103.422L141.551 102.252L140.449 104.488L142.824 105.658Z",
    fill: "black"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M137.091 102.833L138.193 100.597L135.818 99.4266L134.716 101.662L137.091 102.833Z",
    fill: "black"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M246.265 163.447L247.448 161.047L244.898 159.79L243.715 162.191L246.265 163.447Z",
    fill: "black"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M240.533 160.622L241.716 158.221L239.166 156.965L237.983 159.365L240.533 160.622Z",
    fill: "black"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M234.8 157.797L235.983 155.396L233.433 154.139L232.25 156.54L234.8 157.797Z",
    fill: "black"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M229.067 154.972L230.25 152.571L227.7 151.314L226.517 153.715L229.067 154.972Z",
    fill: "black"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M223.335 152.146L224.518 149.746L221.968 148.489L220.785 150.89L223.335 152.146Z",
    fill: "black"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M217.602 149.321L218.785 146.92L216.235 145.664L215.052 148.064L217.602 149.321Z",
    fill: "black"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M211.869 146.496L213.052 144.095L210.502 142.839L209.319 145.239L211.869 146.496Z",
    fill: "black"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M206.137 143.671L207.32 141.27L204.77 140.013L203.587 142.414L206.137 143.671Z",
    fill: "black"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M200.404 140.845L201.587 138.445L199.037 137.188L197.854 139.589L200.404 140.845Z",
    fill: "black"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M194.671 138.02L195.854 135.619L193.304 134.363L192.121 136.763L194.671 138.02Z",
    fill: "black"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M188.939 135.195L190.122 132.794L187.572 131.538L186.389 133.938L188.939 135.195Z",
    fill: "black"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M183.206 132.37L184.389 129.969L181.839 128.712L180.656 131.113L183.206 132.37Z",
    fill: "black"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M177.473 129.544L178.657 127.144L176.107 125.887L174.923 128.288L177.473 129.544Z",
    fill: "black"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M171.741 126.719L172.924 124.319L170.374 123.062L169.191 125.462L171.741 126.719Z",
    fill: "black"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M166.008 123.894L167.191 121.493L164.641 120.237L163.458 122.637L166.008 123.894Z",
    fill: "black"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M160.275 121.069L161.459 118.668L158.909 117.411L157.725 119.812L160.275 121.069Z",
    fill: "black"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M154.543 118.243L155.726 115.843L153.176 114.586L151.993 116.987L154.543 118.243Z",
    fill: "black"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M148.81 115.418L149.993 113.018L147.443 111.761L146.26 114.161L148.81 115.418Z",
    fill: "black"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M143.078 112.593L144.261 110.192L141.711 108.936L140.528 111.336L143.078 112.593Z",
    fill: "black"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M137.345 109.768L138.528 107.367L135.978 106.11L134.795 108.511L137.345 109.768Z",
    fill: "black"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M131.612 106.942L132.795 104.542L130.245 103.285L129.062 105.686L131.612 106.942Z",
    fill: "black"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M246.522 170.39L247.791 167.814L245.055 166.466L243.786 169.042L246.522 170.39Z",
    fill: "black"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M240.789 167.565L242.059 164.989L239.323 163.641L238.053 166.216L240.789 167.565Z",
    fill: "black"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M235.057 164.74L236.326 162.164L233.59 160.815L232.32 163.391L235.057 164.74Z",
    fill: "black"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M229.324 161.914L230.593 159.339L227.857 157.99L226.588 160.566L229.324 161.914Z",
    fill: "black"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M223.591 159.089L224.861 156.513L222.125 155.165L220.855 157.741L223.591 159.089Z",
    fill: "black"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M217.859 156.264L219.128 153.688L216.392 152.34L215.122 154.915L217.859 156.264Z",
    fill: "black"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M212.126 153.439L213.395 150.863L210.659 149.514L209.39 152.09L212.126 153.439Z",
    fill: "black"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M206.393 150.613L207.663 148.038L204.927 146.689L203.657 149.265L206.393 150.613Z",
    fill: "black"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M200.661 147.788L201.93 145.212L199.194 143.864L197.925 146.44L200.661 147.788Z",
    fill: "black"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M194.928 144.963L196.197 142.387L193.461 141.039L192.192 143.614L194.928 144.963Z",
    fill: "black"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M189.195 142.138L190.465 139.562L187.729 138.213L186.459 140.789L189.195 142.138Z",
    fill: "black"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M183.463 139.312L184.732 136.737L181.996 135.388L180.727 137.964L183.463 139.312Z",
    fill: "black"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M177.73 136.487L178.999 133.911L176.263 132.563L174.994 135.139L177.73 136.487Z",
    fill: "black"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M171.997 133.662L173.267 131.086L170.531 129.738L169.261 132.313L171.997 133.662Z",
    fill: "black"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M166.265 130.837L167.534 128.261L164.798 126.912L163.529 129.488L166.265 130.837Z",
    fill: "black"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M160.532 128.011L161.801 125.436L159.065 124.087L157.796 126.663L160.532 128.011Z",
    fill: "black"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M154.799 125.186L156.069 122.61L153.333 121.262L152.063 123.838L154.799 125.186Z",
    fill: "black"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M149.067 122.361L150.336 119.785L147.6 118.437L146.331 121.012L149.067 122.361Z",
    fill: "black"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M143.334 119.536L144.603 116.96L141.867 115.612L140.598 118.187L143.334 119.536Z",
    fill: "black"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M137.601 116.71L138.871 114.135L136.135 112.786L134.865 115.362L137.601 116.71Z",
    fill: "black"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M131.869 113.885L133.138 111.309L130.402 109.961L129.133 112.537L131.869 113.885Z",
    fill: "black"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M241.046 174.508L242.401 171.757L239.479 170.317L238.124 173.067L241.046 174.508Z",
    fill: "black"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M235.313 171.682L236.669 168.931L233.747 167.491L232.391 170.242L235.313 171.682Z",
    fill: "black"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M229.58 168.857L230.936 166.106L228.014 164.666L226.658 167.417L229.58 168.857Z",
    fill: "black"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M223.848 166.032L225.203 163.281L222.281 161.841L220.926 164.592L223.848 166.032Z",
    fill: "black"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M218.115 163.207L219.471 160.456L216.549 159.016L215.193 161.766L218.115 163.207Z",
    fill: "black"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M212.382 160.381L213.738 157.63L210.816 156.19L209.46 158.941L212.382 160.381Z",
    fill: "black"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M206.65 157.556L208.005 154.805L205.083 153.365L203.728 156.116L206.65 157.556Z",
    fill: "black"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M200.917 154.731L202.273 151.98L199.351 150.54L197.995 153.291L200.917 154.731Z",
    fill: "black"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M195.184 151.906L196.54 149.155L193.618 147.715L192.262 150.465L195.184 151.906Z",
    fill: "black"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M189.452 149.08L190.807 146.329L187.885 144.889L186.53 147.64L189.452 149.08Z",
    fill: "black"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M183.719 146.255L185.075 143.504L182.153 142.064L180.797 144.815L183.719 146.255Z",
    fill: "black"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M177.986 143.43L179.342 140.679L176.42 139.239L175.064 141.99L177.986 143.43Z",
    fill: "black"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M172.254 140.605L173.61 137.854L170.687 136.414L169.332 139.165L172.254 140.605Z",
    fill: "black"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M166.521 137.779L167.877 135.029L164.955 133.588L163.599 136.339L166.521 137.779Z",
    fill: "black"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M160.788 134.954L162.144 132.203L159.222 130.763L157.866 133.514L160.788 134.954Z",
    fill: "black"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M155.056 132.129L156.412 129.378L153.489 127.938L152.134 130.689L155.056 132.129Z",
    fill: "black"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M149.323 129.304L150.679 126.553L147.757 125.113L146.401 127.864L149.323 129.304Z",
    fill: "black"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M143.591 126.478L144.946 123.728L142.024 122.287L140.668 125.038L143.591 126.478Z",
    fill: "black"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M137.858 123.653L139.214 120.902L136.291 119.462L134.936 122.213L137.858 123.653Z",
    fill: "black"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M132.125 120.828L133.481 118.077L130.559 116.637L129.203 119.388L132.125 120.828Z",
    fill: "black"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M126.393 118.003L127.748 115.252L124.826 113.812L123.47 116.563L126.393 118.003Z",
    fill: "black"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M241.299 181.442L242.736 178.527L239.639 177L238.202 179.916L241.299 181.442Z",
    fill: "black"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M235.567 178.617L237.004 175.701L233.906 174.175L232.469 177.091L235.567 178.617Z",
    fill: "black"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M229.834 175.792L231.271 172.876L228.174 171.35L226.737 174.266L229.834 175.792Z",
    fill: "black"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M224.101 172.967L225.538 170.051L222.441 168.525L221.004 171.44L224.101 172.967Z",
    fill: "black"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M218.369 170.141L219.806 167.226L216.708 165.699L215.271 168.615L218.369 170.141Z",
    fill: "black"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M212.636 167.316L214.073 164.401L210.976 162.874L209.539 165.79L212.636 167.316Z",
    fill: "black"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M206.903 164.491L208.34 161.575L205.243 160.049L203.806 162.965L206.903 164.491Z",
    fill: "black"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M201.171 161.666L202.608 158.75L199.51 157.224L198.073 160.139L201.171 161.666Z",
    fill: "black"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M195.438 158.84L196.875 155.925L193.778 154.398L192.341 157.314L195.438 158.84Z",
    fill: "black"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M189.705 156.015L191.142 153.1L188.045 151.573L186.608 154.489L189.705 156.015Z",
    fill: "black"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M183.973 153.19L185.41 150.274L182.312 148.748L180.875 151.664L183.973 153.19Z",
    fill: "black"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M178.24 150.365L179.677 147.449L176.58 145.923L175.143 148.838L178.24 150.365Z",
    fill: "black"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M172.507 147.54L173.944 144.624L170.847 143.097L169.41 146.013L172.507 147.54Z",
    fill: "black"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M166.775 144.714L168.212 141.799L165.114 140.272L163.678 143.188L166.775 144.714Z",
    fill: "black"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M161.042 141.889L162.479 138.973L159.382 137.447L157.945 140.363L161.042 141.889Z",
    fill: "black"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M155.309 139.064L156.746 136.148L153.649 134.622L152.212 137.537L155.309 139.064Z",
    fill: "black"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M149.577 136.239L151.014 133.323L147.917 131.796L146.48 134.712L149.577 136.239Z",
    fill: "black"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M143.844 133.413L145.281 130.498L142.184 128.971L140.747 131.887L143.844 133.413Z",
    fill: "black"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M138.111 130.588L139.548 127.672L136.451 126.146L135.014 129.062L138.111 130.588Z",
    fill: "black"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M132.379 127.763L133.816 124.847L130.719 123.321L129.282 126.236L132.379 127.763Z",
    fill: "black"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M126.646 124.938L128.083 122.022L124.986 120.495L123.549 123.411L126.646 124.938Z",
    fill: "black"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M235.823 185.56L237.346 182.469L234.063 180.851L232.54 183.942L235.823 185.56Z",
    fill: "black"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M230.09 182.735L231.614 179.644L228.33 178.026L226.807 181.117L230.09 182.735Z",
    fill: "black"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M224.358 179.909L225.881 176.819L222.598 175.201L221.075 178.291L224.358 179.909Z",
    fill: "black"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M218.625 177.084L220.148 173.993L216.865 172.375L215.342 175.466L218.625 177.084Z",
    fill: "black"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M212.892 174.259L214.416 171.168L211.133 169.55L209.609 172.641L212.892 174.259Z",
    fill: "black"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M207.16 171.434L208.683 168.343L205.4 166.725L203.877 169.816L207.16 171.434Z",
    fill: "black"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M201.427 168.608L202.95 165.518L199.667 163.9L198.144 166.99L201.427 168.608Z",
    fill: "black"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M195.695 165.783L197.218 162.692L193.935 161.074L192.411 164.165L195.695 165.783Z",
    fill: "black"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M189.962 162.958L191.485 159.867L188.202 158.249L186.679 161.34L189.962 162.958Z",
    fill: "black"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M184.229 160.133L185.752 157.042L182.469 155.424L180.946 158.515L184.229 160.133Z",
    fill: "black"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M178.497 157.308L180.02 154.217L176.737 152.599L175.213 155.689L178.497 157.308Z",
    fill: "black"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M172.764 154.482L174.287 151.391L171.004 149.773L169.481 152.864L172.764 154.482Z",
    fill: "black"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M167.031 151.657L168.555 148.566L165.271 146.948L163.748 150.039L167.031 151.657Z",
    fill: "black"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M161.299 148.832L162.822 145.741L159.539 144.123L158.015 147.214L161.299 148.832Z",
    fill: "black"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M155.566 146.007L157.089 142.916L153.806 141.298L152.283 144.388L155.566 146.007Z",
    fill: "black"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M149.833 143.181L151.357 140.09L148.073 138.472L146.55 141.563L149.833 143.181Z",
    fill: "black"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M144.101 140.356L145.624 137.265L142.341 135.647L140.817 138.738L144.101 140.356Z",
    fill: "black"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M138.368 137.531L139.891 134.44L136.608 132.822L135.085 135.913L138.368 137.531Z",
    fill: "black"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M132.635 134.706L134.159 131.615L130.875 129.997L129.352 133.087L132.635 134.706Z",
    fill: "black"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M126.903 131.88L128.426 128.789L125.143 127.171L123.619 130.262L126.903 131.88Z",
    fill: "black"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M121.17 129.055L122.693 125.964L119.41 124.346L117.887 127.437L121.17 129.055Z",
    fill: "black"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M236.08 192.503L237.689 189.237L234.22 187.527L232.61 190.793L236.08 192.503Z",
    fill: "black"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M230.347 189.677L231.957 186.411L228.487 184.702L226.878 187.968L230.347 189.677Z",
    fill: "black"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M224.614 186.852L226.224 183.586L222.755 181.876L221.145 185.142L224.614 186.852Z",
    fill: "black"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M218.882 184.027L220.491 180.761L217.022 179.051L215.412 182.317L218.882 184.027Z",
    fill: "black"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M213.149 181.202L214.759 177.936L211.289 176.226L209.68 179.492L213.149 181.202Z",
    fill: "black"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M207.416 178.377L209.026 175.111L205.557 173.401L203.947 176.667L207.416 178.377Z",
    fill: "black"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M201.684 175.551L203.293 172.285L199.824 170.575L198.214 173.841L201.684 175.551Z",
    fill: "black"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M195.951 172.726L197.561 169.46L194.091 167.75L192.482 171.016L195.951 172.726Z",
    fill: "black"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M190.218 169.901L191.828 166.635L188.359 164.925L186.749 168.191L190.218 169.901Z",
    fill: "black"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M184.486 167.076L186.095 163.81L182.626 162.1L181.016 165.366L184.486 167.076Z",
    fill: "black"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M178.753 164.25L180.363 160.984L176.893 159.275L175.284 162.541L178.753 164.25Z",
    fill: "black"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M173.02 161.425L174.63 158.159L171.161 156.449L169.551 159.715L173.02 161.425Z",
    fill: "black"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M167.288 158.6L168.897 155.334L165.428 153.624L163.818 156.89L167.288 158.6Z",
    fill: "black"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M161.555 155.775L163.165 152.509L159.695 150.799L158.086 154.065L161.555 155.775Z",
    fill: "black"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M155.822 152.949L157.432 149.683L153.963 147.974L152.353 151.24L155.822 152.949Z",
    fill: "black"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M150.09 150.124L151.699 146.858L148.23 145.148L146.62 148.414L150.09 150.124Z",
    fill: "black"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M144.357 147.299L145.967 144.033L142.497 142.323L140.888 145.589L144.357 147.299Z",
    fill: "black"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M138.624 144.474L140.234 141.208L136.765 139.498L135.155 142.764L138.624 144.474Z",
    fill: "black"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M132.892 141.648L134.501 138.382L131.032 136.673L129.423 139.939L132.892 141.648Z",
    fill: "black"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M127.159 138.823L128.769 135.557L125.299 133.847L123.69 137.113L127.159 138.823Z",
    fill: "black"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M121.427 135.998L123.036 132.732L119.567 131.022L117.957 134.288L121.427 135.998Z",
    fill: "black"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M230.601 196.612L232.291 193.182L228.647 191.385L226.956 194.816L230.601 196.612Z",
    fill: "black"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M224.868 193.787L226.559 190.356L222.914 188.56L221.223 191.991L224.868 193.787Z",
    fill: "black"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M219.135 190.962L220.826 187.531L217.182 185.735L215.491 189.166L219.135 190.962Z",
    fill: "black"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M213.403 188.137L215.093 184.706L211.449 182.91L209.758 186.341L213.403 188.137Z",
    fill: "black"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M207.67 185.311L209.361 181.881L205.716 180.084L204.026 183.515L207.67 185.311Z",
    fill: "black"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M201.937 182.486L203.628 179.055L199.984 177.259L198.293 180.69L201.937 182.486Z",
    fill: "black"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M196.205 179.661L197.895 176.23L194.251 174.434L192.56 177.865L196.205 179.661Z",
    fill: "black"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M190.472 176.836L192.163 173.405L188.518 171.609L186.828 175.04L190.472 176.836Z",
    fill: "black"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M184.739 174.01L186.43 170.58L182.786 168.784L181.095 172.214L184.739 174.01Z",
    fill: "black"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M179.007 171.185L180.697 167.754L177.053 165.958L175.362 169.389L179.007 171.185Z",
    fill: "black"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M173.274 168.36L174.965 164.929L171.32 163.133L169.63 166.564L173.274 168.36Z",
    fill: "black"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M167.541 165.535L169.232 162.104L165.588 160.308L163.897 163.739L167.541 165.535Z",
    fill: "black"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M161.809 162.709L163.5 159.279L159.855 157.483L158.164 160.913L161.809 162.709Z",
    fill: "black"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M156.076 159.884L157.767 156.453L154.122 154.657L152.432 158.088L156.076 159.884Z",
    fill: "black"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M150.343 157.059L152.034 153.628L148.39 151.832L146.699 155.263L150.343 157.059Z",
    fill: "black"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M144.611 154.234L146.302 150.803L142.657 149.007L140.966 152.438L144.611 154.234Z",
    fill: "black"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M138.878 151.409L140.569 147.978L136.924 146.182L135.234 149.612L138.878 151.409Z",
    fill: "black"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M133.145 148.583L134.836 145.152L131.192 143.356L129.501 146.787L133.145 148.583Z",
    fill: "black"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M127.413 145.758L129.104 142.327L125.459 140.531L123.768 143.962L127.413 145.758Z",
    fill: "black"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M121.68 142.933L123.371 139.502L119.727 137.706L118.036 141.137L121.68 142.933Z",
    fill: "black"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M115.947 140.108L117.638 136.677L113.994 134.881L112.303 138.311L115.947 140.108Z",
    fill: "black"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M230.857 203.555L232.634 199.949L228.804 198.061L227.027 201.667L230.857 203.555Z",
    fill: "black"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M225.124 200.73L226.902 197.124L223.071 195.236L221.294 198.842L225.124 200.73Z",
    fill: "black"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M219.392 197.905L221.169 194.299L217.338 192.411L215.561 196.017L219.392 197.905Z",
    fill: "black"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M213.659 195.079L215.436 191.473L211.606 189.586L209.829 193.192L213.659 195.079Z",
    fill: "black"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M207.926 192.254L209.704 188.648L205.873 186.76L204.096 190.366L207.926 192.254Z",
    fill: "black"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M202.194 189.429L203.971 185.823L200.14 183.935L198.363 187.541L202.194 189.429Z",
    fill: "black"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M196.461 186.604L198.238 182.998L194.408 181.11L192.631 184.716L196.461 186.604Z",
    fill: "black"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M190.728 183.778L192.506 180.172L188.675 178.285L186.898 181.891L190.728 183.778Z",
    fill: "black"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M184.996 180.953L186.773 177.347L182.942 175.459L181.165 179.065L184.996 180.953Z",
    fill: "black"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M179.263 178.128L181.04 174.522L177.21 172.634L175.433 176.24L179.263 178.128Z",
    fill: "black"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M173.53 175.303L175.308 171.697L171.477 169.809L169.7 173.415L173.53 175.303Z",
    fill: "black"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M167.798 172.477L169.575 168.871L165.745 166.984L163.967 170.59L167.798 172.477Z",
    fill: "black"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M162.065 169.652L163.842 166.046L160.012 164.158L158.235 167.764L162.065 169.652Z",
    fill: "black"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M156.333 166.827L158.11 163.221L154.279 161.333L152.502 164.939L156.333 166.827Z",
    fill: "black"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M150.6 164.002L152.377 160.396L148.547 158.508L146.769 162.114L150.6 164.002Z",
    fill: "black"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M144.867 161.177L146.644 157.571L142.814 155.683L141.037 159.289L144.867 161.177Z",
    fill: "black"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M139.135 158.351L140.912 154.745L137.081 152.858L135.304 156.464L139.135 158.351Z",
    fill: "black"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M133.402 155.526L135.179 151.92L131.349 150.032L129.571 153.638L133.402 155.526Z",
    fill: "black"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M127.669 152.701L129.446 149.095L125.616 147.207L123.839 150.813L127.669 152.701Z",
    fill: "black"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M121.937 149.876L123.714 146.27L119.883 144.382L118.106 147.988L121.937 149.876Z",
    fill: "black"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M116.204 147.05L117.981 143.444L114.151 141.557L112.373 145.163L116.204 147.05Z",
    fill: "black"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M225.381 207.673L227.244 203.892L223.228 201.912L221.364 205.693L225.381 207.673Z",
    fill: "black"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M219.648 204.847L221.512 201.066L217.495 199.087L215.632 202.868L219.648 204.847Z",
    fill: "black"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M213.916 202.022L215.779 198.241L211.763 196.262L209.899 200.043L213.916 202.022Z",
    fill: "black"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M208.183 199.197L210.046 195.416L206.03 193.436L204.166 197.217L208.183 199.197Z",
    fill: "black"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M202.45 196.372L204.314 192.591L200.297 190.611L198.434 194.392L202.45 196.372Z",
    fill: "black"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M196.718 193.546L198.581 189.765L194.565 187.786L192.701 191.567L196.718 193.546Z",
    fill: "black"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M190.985 190.721L192.848 186.94L188.832 184.961L186.968 188.742L190.985 190.721Z",
    fill: "black"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M185.252 187.896L187.116 184.115L183.099 182.135L181.236 185.917L185.252 187.896Z",
    fill: "black"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M179.52 185.071L181.383 181.29L177.367 179.31L175.503 183.091L179.52 185.071Z",
    fill: "black"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M173.787 182.245L175.65 178.464L171.634 176.485L169.771 180.266L173.787 182.245Z",
    fill: "black"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M168.054 179.42L169.918 175.639L165.901 173.66L164.038 177.441L168.054 179.42Z",
    fill: "black"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M162.322 176.595L164.185 172.814L160.169 170.834L158.305 174.616L162.322 176.595Z",
    fill: "black"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M156.589 173.77L158.453 169.989L154.436 168.009L152.573 171.79L156.589 173.77Z",
    fill: "black"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M150.856 170.945L152.72 167.163L148.703 165.184L146.84 168.965L150.856 170.945Z",
    fill: "black"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M145.124 168.119L146.987 164.338L142.971 162.359L141.107 166.14L145.124 168.119Z",
    fill: "black"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M139.391 165.294L141.255 161.513L137.238 159.533L135.375 163.315L139.391 165.294Z",
    fill: "black"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M133.658 162.469L135.522 158.688L131.505 156.708L129.642 160.489L133.658 162.469Z",
    fill: "black"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M127.926 159.644L129.789 155.862L125.773 153.883L123.909 157.664L127.926 159.644Z",
    fill: "black"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M122.193 156.818L124.057 153.037L120.04 151.058L118.177 154.839L122.193 156.818Z",
    fill: "black"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M116.46 153.993L118.324 150.212L114.307 148.232L112.444 152.014L116.46 153.993Z",
    fill: "black"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M110.728 151.168L112.591 147.387L108.575 145.407L106.711 149.188L110.728 151.168Z",
    fill: "black"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M225.634 214.608L227.579 210.662L223.388 208.596L221.443 212.542L225.634 214.608Z",
    fill: "black"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M219.902 211.782L221.847 207.836L217.655 205.771L215.71 209.717L219.902 211.782Z",
    fill: "black"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M214.169 208.957L216.114 205.011L211.922 202.945L209.978 206.891L214.169 208.957Z",
    fill: "black"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M208.437 206.132L210.381 202.186L206.19 200.12L204.245 204.066L208.437 206.132Z",
    fill: "black"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M202.704 203.307L204.649 199.361L200.457 197.295L198.512 201.241L202.704 203.307Z",
    fill: "black"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M196.971 200.481L198.916 196.535L194.724 194.47L192.78 198.416L196.971 200.481Z",
    fill: "black"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M191.239 197.656L193.183 193.71L188.992 191.644L187.047 195.59L191.239 197.656Z",
    fill: "black"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M185.506 194.831L187.451 190.885L183.259 188.819L181.314 192.765L185.506 194.831Z",
    fill: "black"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M179.773 192.006L181.718 188.06L177.526 185.994L175.582 189.94L179.773 192.006Z",
    fill: "black"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M174.041 189.18L175.985 185.234L171.794 183.169L169.849 187.115L174.041 189.18Z",
    fill: "black"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M168.308 186.355L170.253 182.409L166.061 180.343L164.116 184.289L168.308 186.355Z",
    fill: "black"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M162.575 183.53L164.52 179.584L160.328 177.518L158.384 181.464L162.575 183.53Z",
    fill: "black"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M156.843 180.705L158.787 176.759L154.596 174.693L152.651 178.639L156.843 180.705Z",
    fill: "black"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M151.11 177.879L153.055 173.933L148.863 171.868L146.918 175.814L151.11 177.879Z",
    fill: "black"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M145.377 175.054L147.322 171.108L143.13 169.042L141.186 172.988L145.377 175.054Z",
    fill: "black"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M139.645 172.229L141.589 168.283L137.398 166.217L135.453 170.163L139.645 172.229Z",
    fill: "black"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M133.912 169.404L135.857 165.458L131.665 163.392L129.72 167.338L133.912 169.404Z",
    fill: "black"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M128.179 166.578L130.124 162.632L125.932 160.567L123.988 164.513L128.179 166.578Z",
    fill: "black"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M122.447 163.753L124.391 159.807L120.2 157.741L118.255 161.687L122.447 163.753Z",
    fill: "black"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M116.714 160.928L118.659 156.982L114.467 154.916L112.522 158.862L116.714 160.928Z",
    fill: "black"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M110.981 158.103L112.926 154.157L108.734 152.091L106.79 156.037L110.981 158.103Z",
    fill: "black"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M220.158 218.725L222.189 214.604L217.812 212.447L215.781 216.568L220.158 218.725Z",
    fill: "black"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M214.426 215.9L216.457 211.779L212.079 209.621L210.048 213.742L214.426 215.9Z",
    fill: "black"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M208.693 213.075L210.724 208.953L206.346 206.796L204.315 210.917L208.693 213.075Z",
    fill: "black"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M202.96 210.249L204.991 206.128L200.614 203.971L198.583 208.092L202.96 210.249Z",
    fill: "black"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M197.228 207.424L199.259 203.303L194.881 201.146L192.85 205.267L197.228 207.424Z",
    fill: "black"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M191.495 204.599L193.526 200.478L189.148 198.32L187.117 202.441L191.495 204.599Z",
    fill: "black"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M185.762 201.774L187.793 197.653L183.416 195.495L181.385 199.616L185.762 201.774Z",
    fill: "black"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M180.03 198.948L182.061 194.827L177.683 192.67L175.652 196.791L180.03 198.948Z",
    fill: "black"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M174.297 196.123L176.328 192.002L171.95 189.845L169.919 193.966L174.297 196.123Z",
    fill: "black"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M168.564 193.298L170.595 189.177L166.218 187.019L164.187 191.14L168.564 193.298Z",
    fill: "black"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M162.832 190.473L164.863 186.352L160.485 184.194L158.454 188.315L162.832 190.473Z",
    fill: "black"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M157.099 187.647L159.13 183.526L154.752 181.369L152.721 185.49L157.099 187.647Z",
    fill: "black"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M151.366 184.822L153.398 180.701L149.02 178.544L146.989 182.665L151.366 184.822Z",
    fill: "black"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M145.634 181.997L147.665 177.876L143.287 175.718L141.256 179.84L145.634 181.997Z",
    fill: "black"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M139.901 179.172L141.932 175.051L137.555 172.893L135.523 177.014L139.901 179.172Z",
    fill: "black"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M134.169 176.346L136.2 172.225L131.822 170.068L129.791 174.189L134.169 176.346Z",
    fill: "black"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M128.436 173.521L130.467 169.4L126.089 167.243L124.058 171.364L128.436 173.521Z",
    fill: "black"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M122.703 170.696L124.734 166.575L120.357 164.417L118.326 168.539L122.703 170.696Z",
    fill: "black"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M116.971 167.871L119.002 163.75L114.624 161.592L112.593 165.713L116.971 167.871Z",
    fill: "black"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M111.238 165.046L113.269 160.924L108.891 158.767L106.86 162.888L111.238 165.046Z",
    fill: "black"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M105.505 162.22L107.536 158.099L103.159 155.942L101.128 160.063L105.505 162.22Z",
    fill: "black"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M380.565 114.685L380.905 113.995L380.172 113.633L379.832 114.324L380.565 114.685Z",
    fill: "black"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M374.833 111.86L375.173 111.169L374.439 110.808L374.099 111.498L374.833 111.86Z",
    fill: "black"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M369.1 109.034L369.44 108.344L368.707 107.983L368.367 108.673L369.1 109.034Z",
    fill: "black"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M363.367 106.209L363.707 105.519L362.974 105.158L362.634 105.848L363.367 106.209Z",
    fill: "black"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M357.635 103.384L357.975 102.694L357.241 102.332L356.901 103.023L357.635 103.384Z",
    fill: "black"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M351.902 100.559L352.242 99.8684L351.509 99.507L351.169 100.197L351.902 100.559Z",
    fill: "black"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M346.169 97.7335L346.509 97.0432L345.776 96.6818L345.436 97.3721L346.169 97.7335Z",
    fill: "black"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M340.437 94.9082L340.777 94.2179L340.044 93.8566L339.703 94.5469L340.437 94.9082Z",
    fill: "black"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M334.704 92.083L335.044 91.3927L334.311 91.0313L333.971 91.7216L334.704 92.083Z",
    fill: "black"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M328.971 89.2577L329.311 88.5675L328.578 88.2061L328.238 88.8964L328.971 89.2577Z",
    fill: "black"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M323.239 86.4325L323.579 85.7422L322.846 85.3808L322.505 86.0711L323.239 86.4325Z",
    fill: "black"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M317.506 83.6073L317.846 82.917L317.113 82.5556L316.773 83.2459L317.506 83.6073Z",
    fill: "black"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M311.773 80.782L312.114 80.0917L311.38 79.7304L311.04 80.4206L311.773 80.782Z",
    fill: "black"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M306.041 77.9568L306.381 77.2665L305.648 76.9051L305.307 77.5954L306.041 77.9568Z",
    fill: "black"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M300.308 75.1315L300.648 74.4412L299.915 74.0799L299.575 74.7702L300.308 75.1315Z",
    fill: "black"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M294.575 72.3063L294.916 71.616L294.182 71.2546L293.842 71.9449L294.575 72.3063Z",
    fill: "black"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M288.843 69.481L289.183 68.7908L288.45 68.4294L288.109 69.1197L288.843 69.481Z",
    fill: "black"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M283.11 66.6558L283.45 65.9655L282.717 65.6041L282.377 66.2944L283.11 66.6558Z",
    fill: "black"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M277.377 63.8306L277.718 63.1403L276.984 62.7789L276.644 63.4692L277.377 63.8306Z",
    fill: "black"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M380.819 121.62L381.24 120.765L380.332 120.317L379.91 121.172L380.819 121.62Z",
    fill: "black"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M375.086 118.795L375.508 117.939L374.599 117.492L374.178 118.347L375.086 118.795Z",
    fill: "black"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M369.353 115.969L369.775 115.114L368.867 114.667L368.445 115.522L369.353 115.969Z",
    fill: "black"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M363.621 113.144L364.042 112.289L363.134 111.841L362.712 112.696L363.621 113.144Z",
    fill: "black"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M357.888 110.319L358.31 109.464L357.401 109.016L356.98 109.871L357.888 110.319Z",
    fill: "black"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M352.155 107.494L352.577 106.638L351.669 106.191L351.247 107.046L352.155 107.494Z",
    fill: "black"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M346.423 104.668L346.844 103.813L345.936 103.366L345.514 104.221L346.423 104.668Z",
    fill: "black"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M340.69 101.843L341.112 100.988L340.203 100.54L339.782 101.395L340.69 101.843Z",
    fill: "black"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M334.958 99.0179L335.379 98.1628L334.471 97.7151L334.049 98.5702L334.958 99.0179Z",
    fill: "black"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M329.225 96.1927L329.646 95.3375L328.738 94.8899L328.316 95.745L329.225 96.1927Z",
    fill: "black"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M323.492 93.3674L323.914 92.5123L323.005 92.0646L322.584 92.9197L323.492 93.3674Z",
    fill: "black"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M317.76 90.5422L318.181 89.687L317.273 89.2394L316.851 90.0945L317.76 90.5422Z",
    fill: "black"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M312.027 87.7169L312.448 86.8618L311.54 86.4141L311.119 87.2693L312.027 87.7169Z",
    fill: "black"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M306.294 84.8917L306.716 84.0366L305.807 83.5889L305.386 84.444L306.294 84.8917Z",
    fill: "black"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M300.562 82.0664L300.983 81.2113L300.075 80.7636L299.653 81.6188L300.562 82.0664Z",
    fill: "black"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M294.829 79.2412L295.25 78.3861L294.342 77.9384L293.921 78.7935L294.829 79.2412Z",
    fill: "black"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M289.096 76.416L289.518 75.5608L288.609 75.1132L288.188 75.9683L289.096 76.416Z",
    fill: "black"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M283.364 73.5907L283.785 72.7356L282.877 72.2879L282.455 73.143L283.364 73.5907Z",
    fill: "black"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M277.631 70.7655L278.052 69.9103L277.144 69.4627L276.723 70.3178L277.631 70.7655Z",
    fill: "black"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M381.075 128.563L381.583 127.532L380.489 126.993L379.981 128.023L381.075 128.563Z",
    fill: "black"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M375.343 125.737L375.85 124.707L374.756 124.168L374.248 125.198L375.343 125.737Z",
    fill: "black"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M369.61 122.912L370.118 121.882L369.023 121.342L368.516 122.373L369.61 122.912Z",
    fill: "black"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M363.877 120.087L364.385 119.057L363.291 118.517L362.783 119.548L363.877 120.087Z",
    fill: "black"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M358.145 117.262L358.652 116.231L357.558 115.692L357.05 116.722L358.145 117.262Z",
    fill: "black"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M352.412 114.436L352.92 113.406L351.825 112.867L351.318 113.897L352.412 114.436Z",
    fill: "black"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M346.679 111.611L347.187 110.581L346.093 110.041L345.585 111.072L346.679 111.611Z",
    fill: "black"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M340.947 108.786L341.454 107.756L340.36 107.216L339.852 108.247L340.947 108.786Z",
    fill: "black"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M335.214 105.961L335.722 104.93L334.627 104.391L334.12 105.421L335.214 105.961Z",
    fill: "black"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M329.481 103.135L329.989 102.105L328.895 101.566L328.387 102.596L329.481 103.135Z",
    fill: "black"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M323.749 100.31L324.256 99.2799L323.162 98.7405L322.654 99.7708L323.749 100.31Z",
    fill: "black"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M318.016 97.4849L318.524 96.4547L317.429 95.9153L316.922 96.9456L318.016 97.4849Z",
    fill: "black"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M312.283 94.6597L312.791 93.6294L311.697 93.09L311.189 94.1203L312.283 94.6597Z",
    fill: "black"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M306.551 91.8345L307.058 90.8042L305.964 90.2648L305.456 91.2951L306.551 91.8345Z",
    fill: "black"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M300.818 89.0092L301.326 87.9789L300.231 87.4396L299.724 88.4698L300.818 89.0092Z",
    fill: "black"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M295.085 86.184L295.593 85.1537L294.499 84.6143L293.991 85.6446L295.085 86.184Z",
    fill: "black"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M289.353 83.3587L289.861 82.3284L288.766 81.7891L288.258 82.8194L289.353 83.3587Z",
    fill: "black"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M283.62 80.5335L284.128 79.5032L283.033 78.9638L282.526 79.9941L283.62 80.5335Z",
    fill: "black"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M277.887 77.7082L278.395 76.678L277.301 76.1386L276.793 77.1689L277.887 77.7082Z",
    fill: "black"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M272.155 74.883L272.663 73.8527L271.568 73.3134L271.06 74.3436L272.155 74.883Z",
    fill: "black"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M381.332 135.505L381.926 134.3L380.645 133.669L380.051 134.874L381.332 135.505Z",
    fill: "black"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M375.599 132.68L376.193 131.475L374.913 130.844L374.319 132.049L375.599 132.68Z",
    fill: "black"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M369.866 129.855L370.461 128.649L369.18 128.018L368.586 129.224L369.866 129.855Z",
    fill: "black"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M364.134 127.03L364.728 125.824L363.447 125.193L362.853 126.399L364.134 127.03Z",
    fill: "black"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M358.401 124.204L358.995 122.999L357.715 122.368L357.121 123.573L358.401 124.204Z",
    fill: "black"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M352.669 121.379L353.263 120.174L351.982 119.543L351.388 120.748L352.669 121.379Z",
    fill: "black"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M346.936 118.554L347.53 117.348L346.249 116.717L345.655 117.923L346.936 118.554Z",
    fill: "black"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M341.203 115.729L341.797 114.523L340.517 113.892L339.923 115.098L341.203 115.729Z",
    fill: "black"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M335.471 112.903L336.065 111.698L334.784 111.067L334.19 112.272L335.471 112.903Z",
    fill: "black"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M329.738 110.078L330.332 108.873L329.051 108.242L328.457 109.447L329.738 110.078Z",
    fill: "black"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M324.005 107.253L324.599 106.048L323.319 105.416L322.725 106.622L324.005 107.253Z",
    fill: "black"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M318.273 104.428L318.867 103.222L317.586 102.591L316.992 103.797L318.273 104.428Z",
    fill: "black"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M312.54 101.602L313.134 100.397L311.854 99.766L311.259 100.971L312.54 101.602Z",
    fill: "black"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M306.807 98.7772L307.401 97.5718L306.121 96.9407L305.527 98.1462L306.807 98.7772Z",
    fill: "black"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M301.075 95.952L301.669 94.7465L300.388 94.1155L299.794 95.3209L301.075 95.952Z",
    fill: "black"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M295.342 93.1267L295.936 91.9213L294.656 91.2902L294.061 92.4957L295.342 93.1267Z",
    fill: "black"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M289.609 90.3015L290.203 89.0961L288.923 88.465L288.329 89.6704L289.609 90.3015Z",
    fill: "black"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M283.877 87.4762L284.471 86.2708L283.19 85.6398L282.596 86.8452L283.877 87.4762Z",
    fill: "black"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M278.144 84.651L278.738 83.4456L277.458 82.8145L276.864 84.0199L278.144 84.651Z",
    fill: "black"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M272.411 81.8258L273.005 80.6203L271.725 79.9893L271.131 81.1947L272.411 81.8258Z",
    fill: "black"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M381.585 142.44L382.261 141.07L380.805 140.353L380.13 141.723L381.585 142.44Z",
    fill: "black"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M375.853 139.615L376.528 138.245L375.072 137.527L374.397 138.898L375.853 139.615Z",
    fill: "black"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M370.12 136.79L370.795 135.42L369.34 134.702L368.664 136.072L370.12 136.79Z",
    fill: "black"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M364.387 133.965L365.063 132.594L363.607 131.877L362.932 133.247L364.387 133.965Z",
    fill: "black"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M358.655 131.139L359.33 129.769L357.874 129.052L357.199 130.422L358.655 131.139Z",
    fill: "black"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M352.922 128.314L353.597 126.944L352.142 126.226L351.466 127.597L352.922 128.314Z",
    fill: "black"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M347.189 125.489L347.865 124.119L346.409 123.401L345.734 124.771L347.189 125.489Z",
    fill: "black"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M341.457 122.664L342.132 121.293L340.677 120.576L340.001 121.946L341.457 122.664Z",
    fill: "black"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M335.724 119.838L336.399 118.468L334.944 117.751L334.269 119.121L335.724 119.838Z",
    fill: "black"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M329.991 117.013L330.667 115.643L329.211 114.925L328.536 116.296L329.991 117.013Z",
    fill: "black"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M324.259 114.188L324.934 112.818L323.479 112.1L322.803 113.471L324.259 114.188Z",
    fill: "black"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M318.526 111.363L319.201 109.992L317.746 109.275L317.071 110.645L318.526 111.363Z",
    fill: "black"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M312.793 108.537L313.469 107.167L312.013 106.45L311.338 107.82L312.793 108.537Z",
    fill: "black"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M307.061 105.712L307.736 104.342L306.281 103.624L305.605 104.995L307.061 105.712Z",
    fill: "black"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M301.328 102.887L302.003 101.517L300.548 100.799L299.873 102.17L301.328 102.887Z",
    fill: "black"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M295.596 100.062L296.271 98.6914L294.815 97.974L294.14 99.3443L295.596 100.062Z",
    fill: "black"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M289.863 97.2364L290.538 95.8661L289.083 95.1488L288.407 96.5191L289.863 97.2364Z",
    fill: "black"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M284.13 94.4112L284.806 93.0409L283.35 92.3235L282.675 93.6938L284.13 94.4112Z",
    fill: "black"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M278.398 91.5859L279.073 90.2156L277.617 89.4983L276.942 90.8686L278.398 91.5859Z",
    fill: "black"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M272.665 88.7607L273.34 87.3904L271.885 86.6731L271.209 88.0433L272.665 88.7607Z",
    fill: "black"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M266.932 85.9354L267.608 84.5652L266.152 83.8478L265.477 85.2181L266.932 85.9354Z",
    fill: "black"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M381.842 149.383L382.603 147.838L380.962 147.029L380.2 148.574L381.842 149.383Z",
    fill: "black"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M376.109 146.558L376.871 145.012L375.229 144.203L374.468 145.749L376.109 146.558Z",
    fill: "black"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M370.377 143.733L371.138 142.187L369.497 141.378L368.735 142.924L370.377 143.733Z",
    fill: "black"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M364.644 140.907L365.406 139.362L363.764 138.553L363.002 140.098L364.644 140.907Z",
    fill: "black"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M358.911 138.082L359.673 136.537L358.031 135.728L357.27 137.273L358.911 138.082Z",
    fill: "black"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M353.179 135.257L353.94 133.711L352.299 132.902L351.537 134.448L353.179 135.257Z",
    fill: "black"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M347.446 132.432L348.208 130.886L346.566 130.077L345.804 131.623L347.446 132.432Z",
    fill: "black"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M341.713 129.606L342.475 128.061L340.833 127.252L340.072 128.797L341.713 129.606Z",
    fill: "black"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M335.981 126.781L336.742 125.236L335.101 124.427L334.339 125.972L335.981 126.781Z",
    fill: "black"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M330.248 123.956L331.01 122.41L329.368 121.601L328.606 123.147L330.248 123.956Z",
    fill: "black"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M324.515 121.131L325.277 119.585L323.635 118.776L322.874 120.322L324.515 121.131Z",
    fill: "black"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M318.783 118.305L319.544 116.76L317.903 115.951L317.141 117.496L318.783 118.305Z",
    fill: "black"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M313.05 115.48L313.812 113.935L312.17 113.126L311.408 114.671L313.05 115.48Z",
    fill: "black"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M307.317 112.655L308.079 111.109L306.437 110.3L305.676 111.846L307.317 112.655Z",
    fill: "black"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M301.585 109.83L302.346 108.284L300.705 107.475L299.943 109.021L301.585 109.83Z",
    fill: "black"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M295.852 107.004L296.614 105.459L294.972 104.65L294.21 106.195L295.852 107.004Z",
    fill: "black"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M290.119 104.179L290.881 102.634L289.239 101.825L288.478 103.37L290.119 104.179Z",
    fill: "black"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M284.387 101.354L285.148 99.8085L283.507 98.9995L282.745 100.545L284.387 101.354Z",
    fill: "black"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M278.654 98.5287L279.416 96.9833L277.774 96.1742L277.012 97.7196L278.654 98.5287Z",
    fill: "black"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M272.921 95.7034L273.683 94.158L272.041 93.349L271.28 94.8944L272.921 95.7034Z",
    fill: "black"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M267.189 92.8782L267.95 91.3328L266.309 90.5237L265.547 92.0692L267.189 92.8782Z",
    fill: "black"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M376.366 153.501L377.214 151.78L375.386 150.879L374.538 152.6L376.366 153.501Z",
    fill: "black"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M370.633 150.675L371.481 148.955L369.653 148.054L368.805 149.775L370.633 150.675Z",
    fill: "black"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M364.9 147.85L365.748 146.13L363.921 145.229L363.073 146.949L364.9 147.85Z",
    fill: "black"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M359.168 145.025L360.016 143.304L358.188 142.404L357.34 144.124L359.168 145.025Z",
    fill: "black"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M353.435 142.2L354.283 140.479L352.455 139.578L351.607 141.299L353.435 142.2Z",
    fill: "black"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M347.702 139.374L348.55 137.654L346.723 136.753L345.875 138.474L347.702 139.374Z",
    fill: "black"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M341.97 136.549L342.818 134.829L340.99 133.928L340.142 135.648L341.97 136.549Z",
    fill: "black"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M336.237 133.724L337.085 132.003L335.257 131.103L334.409 132.823L336.237 133.724Z",
    fill: "black"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M330.504 130.899L331.352 129.178L329.525 128.277L328.677 129.998L330.504 130.899Z",
    fill: "black"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M324.772 128.073L325.62 126.353L323.792 125.452L322.944 127.173L324.772 128.073Z",
    fill: "black"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M319.039 125.248L319.887 123.528L318.059 122.627L317.211 124.347L319.039 125.248Z",
    fill: "black"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M313.307 122.423L314.154 120.702L312.327 119.802L311.479 121.522L313.307 122.423Z",
    fill: "black"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M307.574 119.598L308.422 117.877L306.594 116.976L305.746 118.697L307.574 119.598Z",
    fill: "black"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M301.841 116.772L302.689 115.052L300.861 114.151L300.014 115.872L301.841 116.772Z",
    fill: "black"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M296.109 113.947L296.956 112.227L295.129 111.326L294.281 113.046L296.109 113.947Z",
    fill: "black"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M290.376 111.122L291.224 109.401L289.396 108.501L288.548 110.221L290.376 111.122Z",
    fill: "black"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M284.643 108.297L285.491 106.576L283.664 105.675L282.816 107.396L284.643 108.297Z",
    fill: "black"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M278.911 105.471L279.759 103.751L277.931 102.85L277.083 104.571L278.911 105.471Z",
    fill: "black"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M273.178 102.646L274.026 100.926L272.198 100.025L271.35 101.745L273.178 102.646Z",
    fill: "black"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M267.445 99.821L268.293 98.1004L266.466 97.1997L265.618 98.9202L267.445 99.821Z",
    fill: "black"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M261.713 96.9957L262.561 95.2751L260.733 94.3744L259.885 96.095L261.713 96.9957Z",
    fill: "black"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M376.619 160.435L377.548 158.55L375.546 157.563L374.617 159.448L376.619 160.435Z",
    fill: "black"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M370.887 157.61L371.816 155.725L369.813 154.738L368.884 156.623L370.887 157.61Z",
    fill: "black"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M365.154 154.785L366.083 152.9L364.08 151.913L363.151 153.798L365.154 154.785Z",
    fill: "black"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M359.421 151.96L360.351 150.074L358.348 149.087L357.419 150.973L359.421 151.96Z",
    fill: "black"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M353.689 149.135L354.618 147.249L352.615 146.262L351.686 148.147L353.689 149.135Z",
    fill: "black"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M347.956 146.309L348.885 144.424L346.882 143.437L345.953 145.322L347.956 146.309Z",
    fill: "black"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M342.223 143.484L343.153 141.599L341.15 140.612L340.221 142.497L342.223 143.484Z",
    fill: "black"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M336.491 140.659L337.42 138.773L335.417 137.786L334.488 139.672L336.491 140.659Z",
    fill: "black"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M330.758 137.834L331.687 135.948L329.684 134.961L328.755 136.847L330.758 137.834Z",
    fill: "black"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M325.025 135.008L325.955 133.123L323.952 132.136L323.023 134.021L325.025 135.008Z",
    fill: "black"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M319.293 132.183L320.222 130.298L318.219 129.311L317.29 131.196L319.293 132.183Z",
    fill: "black"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M313.56 129.358L314.489 127.472L312.486 126.485L311.557 128.371L313.56 129.358Z",
    fill: "black"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M307.827 126.533L308.757 124.647L306.754 123.66L305.825 125.546L307.827 126.533Z",
    fill: "black"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M302.095 123.707L303.024 121.822L301.021 120.835L300.092 122.72L302.095 123.707Z",
    fill: "black"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M296.362 120.882L297.291 118.997L295.289 118.01L294.359 119.895L296.362 120.882Z",
    fill: "black"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M290.629 118.057L291.559 116.171L289.556 115.184L288.627 117.07L290.629 118.057Z",
    fill: "black"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M284.897 115.232L285.826 113.346L283.823 112.359L282.894 114.245L284.897 115.232Z",
    fill: "black"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M279.164 112.406L280.093 110.521L278.091 109.534L277.161 111.419L279.164 112.406Z",
    fill: "black"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M273.431 109.581L274.361 107.696L272.358 106.709L271.429 108.594L273.431 109.581Z",
    fill: "black"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M267.699 106.756L268.628 104.87L266.625 103.883L265.696 105.769L267.699 106.756Z",
    fill: "black"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M261.966 103.931L262.895 102.045L260.893 101.058L259.963 102.944L261.966 103.931Z",
    fill: "black"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M371.143 164.553L372.159 162.492L369.97 161.414L368.954 163.474L371.143 164.553Z",
    fill: "black"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M365.41 161.728L366.426 159.667L364.237 158.588L363.222 160.649L365.41 161.728Z",
    fill: "black"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M359.678 158.903L360.693 156.842L358.505 155.763L357.489 157.824L359.678 158.903Z",
    fill: "black"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M353.945 156.077L354.961 154.017L352.772 152.938L351.756 154.999L353.945 156.077Z",
    fill: "black"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M348.213 153.252L349.228 151.191L347.039 150.113L346.024 152.173L348.213 153.252Z",
    fill: "black"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M342.48 150.427L343.495 148.366L341.307 147.287L340.291 149.348L342.48 150.427Z",
    fill: "black"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M336.747 147.602L337.763 145.541L335.574 144.462L334.558 146.523L336.747 147.602Z",
    fill: "black"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M331.015 144.776L332.03 142.716L329.841 141.637L328.826 143.698L331.015 144.776Z",
    fill: "black"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M325.282 141.951L326.297 139.891L324.109 138.812L323.093 140.872L325.282 141.951Z",
    fill: "black"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M319.549 139.126L320.565 137.065L318.376 135.987L317.36 138.047L319.549 139.126Z",
    fill: "black"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M313.817 136.301L314.832 134.24L312.643 133.161L311.628 135.222L313.817 136.301Z",
    fill: "black"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M308.084 133.475L309.099 131.415L306.911 130.336L305.895 132.397L308.084 133.475Z",
    fill: "black"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M302.351 130.65L303.367 128.59L301.178 127.511L300.162 129.571L302.351 130.65Z",
    fill: "black"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M296.619 127.825L297.634 125.764L295.445 124.686L294.43 126.746L296.619 127.825Z",
    fill: "black"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M290.886 125L291.901 122.939L289.713 121.86L288.697 123.921L290.886 125Z",
    fill: "black"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M285.153 122.174L286.169 120.114L283.98 119.035L282.964 121.096L285.153 122.174Z",
    fill: "black"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M279.421 119.349L280.436 117.289L278.247 116.21L277.232 118.27L279.421 119.349Z",
    fill: "black"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M273.688 116.524L274.704 114.463L272.515 113.385L271.499 115.445L273.688 116.524Z",
    fill: "black"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M267.955 113.699L268.971 111.638L266.782 110.559L265.767 112.62L267.955 113.699Z",
    fill: "black"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M262.223 110.873L263.238 108.813L261.049 107.734L260.034 109.795L262.223 110.873Z",
    fill: "black"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M256.49 108.048L257.506 105.988L255.317 104.909L254.301 106.969L256.49 108.048Z",
    fill: "black"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M371.4 171.496L372.501 169.26L370.127 168.09L369.025 170.325L371.4 171.496Z",
    fill: "black"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M365.667 168.671L366.769 166.435L364.394 165.264L363.292 167.5L365.667 168.671Z",
    fill: "black"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M359.934 165.845L361.036 163.61L358.661 162.439L357.559 164.675L359.934 165.845Z",
    fill: "black"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M354.202 163.02L355.304 160.784L352.929 159.614L351.827 161.85L354.202 163.02Z",
    fill: "black"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M348.469 160.195L349.571 157.959L347.196 156.789L346.094 159.024L348.469 160.195Z",
    fill: "black"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M342.736 157.37L343.838 155.134L341.463 153.963L340.361 156.199L342.736 157.37Z",
    fill: "black"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M337.004 154.544L338.106 152.309L335.731 151.138L334.629 153.374L337.004 154.544Z",
    fill: "black"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M331.271 151.719L332.373 149.483L329.998 148.313L328.896 150.549L331.271 151.719Z",
    fill: "black"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M325.538 148.894L326.64 146.658L324.265 145.488L323.164 147.723L325.538 148.894Z",
    fill: "black"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M319.806 146.069L320.908 143.833L318.533 142.662L317.431 144.898L319.806 146.069Z",
    fill: "black"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M314.073 143.243L315.175 141.008L312.8 139.837L311.698 142.073L314.073 143.243Z",
    fill: "black"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M308.34 140.418L309.442 138.182L307.067 137.012L305.966 139.248L308.34 140.418Z",
    fill: "black"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M302.608 137.593L303.71 135.357L301.335 134.187L300.233 136.422L302.608 137.593Z",
    fill: "black"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M296.875 134.768L297.977 132.532L295.602 131.361L294.5 133.597L296.875 134.768Z",
    fill: "black"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M291.142 131.942L292.244 129.707L289.869 128.536L288.768 130.772L291.142 131.942Z",
    fill: "black"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M285.41 129.117L286.512 126.881L284.137 125.711L283.035 127.947L285.41 129.117Z",
    fill: "black"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M279.677 126.292L280.779 124.056L278.404 122.886L277.302 125.121L279.677 126.292Z",
    fill: "black"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M273.945 123.467L275.046 121.231L272.671 120.061L271.57 122.296L273.945 123.467Z",
    fill: "black"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M268.212 120.641L269.314 118.406L266.939 117.235L265.837 119.471L268.212 120.641Z",
    fill: "black"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M262.479 117.816L263.581 115.58L261.206 114.41L260.104 116.646L262.479 117.816Z",
    fill: "black"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M256.747 114.991L257.848 112.755L255.474 111.585L254.372 113.821L256.747 114.991Z",
    fill: "black"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M365.921 175.605L367.104 173.205L364.554 171.948L363.371 174.349L365.921 175.605Z",
    fill: "black"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M360.188 172.78L361.371 170.38L358.821 169.123L357.638 171.523L360.188 172.78Z",
    fill: "black"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M354.455 169.955L355.638 167.554L353.088 166.298L351.905 168.698L354.455 169.955Z",
    fill: "black"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M348.723 167.13L349.906 164.729L347.356 163.472L346.173 165.873L348.723 167.13Z",
    fill: "black"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M342.99 164.304L344.173 161.904L341.623 160.647L340.44 163.048L342.99 164.304Z",
    fill: "black"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M337.257 161.479L338.44 159.079L335.89 157.822L334.707 160.223L337.257 161.479Z",
    fill: "black"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M331.525 158.654L332.708 156.253L330.158 154.997L328.975 157.397L331.525 158.654Z",
    fill: "black"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M325.792 155.829L326.975 153.428L324.425 152.171L323.242 154.572L325.792 155.829Z",
    fill: "black"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M320.059 153.004L321.242 150.603L318.692 149.346L317.509 151.747L320.059 153.004Z",
    fill: "black"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M314.327 150.178L315.51 147.778L312.96 146.521L311.777 148.922L314.327 150.178Z",
    fill: "black"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M308.594 147.353L309.777 144.952L307.227 143.696L306.044 146.096L308.594 147.353Z",
    fill: "black"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M302.861 144.528L304.044 142.127L301.494 140.87L300.311 143.271L302.861 144.528Z",
    fill: "black"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M297.129 141.703L298.312 139.302L295.762 138.045L294.579 140.446L297.129 141.703Z",
    fill: "black"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M291.396 138.877L292.579 136.477L290.029 135.22L288.846 137.621L291.396 138.877Z",
    fill: "black"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M285.663 136.052L286.846 133.651L284.296 132.395L283.113 134.795L285.663 136.052Z",
    fill: "black"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M279.931 133.227L281.114 130.826L278.564 129.57L277.381 131.97L279.931 133.227Z",
    fill: "black"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M274.198 130.402L275.381 128.001L272.831 126.744L271.648 129.145L274.198 130.402Z",
    fill: "black"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M268.465 127.576L269.649 125.176L267.099 123.919L265.915 126.32L268.465 127.576Z",
    fill: "black"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M262.733 124.751L263.916 122.351L261.366 121.094L260.183 123.494L262.733 124.751Z",
    fill: "black"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M257 121.926L258.183 119.525L255.633 118.269L254.45 120.669L257 121.926Z",
    fill: "black"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M251.267 119.101L252.451 116.7L249.901 115.443L248.717 117.844L251.267 119.101Z",
    fill: "black"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M366.177 182.548L367.446 179.972L364.71 178.624L363.441 181.2L366.177 182.548Z",
    fill: "black"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M360.444 179.723L361.714 177.147L358.978 175.799L357.708 178.375L360.444 179.723Z",
    fill: "black"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M354.712 176.898L355.981 174.322L353.245 172.974L351.976 175.549L354.712 176.898Z",
    fill: "black"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M348.979 174.072L350.249 171.497L347.512 170.148L346.243 172.724L348.979 174.072Z",
    fill: "black"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M343.246 171.247L344.516 168.672L341.78 167.323L340.51 169.899L343.246 171.247Z",
    fill: "black"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M337.514 168.422L338.783 165.846L336.047 164.498L334.778 167.074L337.514 168.422Z",
    fill: "black"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M331.781 165.597L333.051 163.021L330.315 161.673L329.045 164.248L331.781 165.597Z",
    fill: "black"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M326.049 162.772L327.318 160.196L324.582 158.847L323.312 161.423L326.049 162.772Z",
    fill: "black"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M320.316 159.946L321.585 157.371L318.849 156.022L317.58 158.598L320.316 159.946Z",
    fill: "black"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M314.583 157.121L315.853 154.545L313.117 153.197L311.847 155.773L314.583 157.121Z",
    fill: "black"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M308.851 154.296L310.12 151.72L307.384 150.372L306.114 152.947L308.851 154.296Z",
    fill: "black"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M303.118 151.471L304.387 148.895L301.651 147.546L300.382 150.122L303.118 151.471Z",
    fill: "black"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M297.385 148.645L298.655 146.07L295.919 144.721L294.649 147.297L297.385 148.645Z",
    fill: "black"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M291.653 145.82L292.922 143.244L290.186 141.896L288.917 144.472L291.653 145.82Z",
    fill: "black"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M285.92 142.995L287.189 140.419L284.453 139.071L283.184 141.646L285.92 142.995Z",
    fill: "black"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M280.187 140.17L281.457 137.594L278.721 136.245L277.451 138.821L280.187 140.17Z",
    fill: "black"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M274.455 137.344L275.724 134.769L272.988 133.42L271.719 135.996L274.455 137.344Z",
    fill: "black"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M268.722 134.519L269.991 131.943L267.255 130.595L265.986 133.171L268.722 134.519Z",
    fill: "black"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M262.989 131.694L264.259 129.118L261.523 127.77L260.253 130.345L262.989 131.694Z",
    fill: "black"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M257.257 128.869L258.526 126.293L255.79 124.944L254.521 127.52L257.257 128.869Z",
    fill: "black"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M251.524 126.043L252.793 123.468L250.057 122.119L248.788 124.695L251.524 126.043Z",
    fill: "black"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M360.701 186.666L362.057 183.915L359.135 182.475L357.779 185.226L360.701 186.666Z",
    fill: "black"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M354.968 183.84L356.324 181.09L353.402 179.65L352.046 182.4L354.968 183.84Z",
    fill: "black"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M349.236 181.015L350.591 178.264L347.669 176.824L346.314 179.575L349.236 181.015Z",
    fill: "black"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M343.503 178.19L344.859 175.439L341.937 173.999L340.581 176.75L343.503 178.19Z",
    fill: "black"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M337.77 175.365L339.126 172.614L336.204 171.174L334.848 173.925L337.77 175.365Z",
    fill: "black"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M332.038 172.54L333.393 169.789L330.471 168.349L329.116 171.099L332.038 172.54Z",
    fill: "black"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M326.305 169.714L327.661 166.963L324.739 165.523L323.383 168.274L326.305 169.714Z",
    fill: "black"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M320.572 166.889L321.928 164.138L319.006 162.698L317.65 165.449L320.572 166.889Z",
    fill: "black"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M314.84 164.064L316.195 161.313L313.273 159.873L311.918 162.624L314.84 164.064Z",
    fill: "black"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M309.107 161.239L310.463 158.488L307.541 157.048L306.185 159.798L309.107 161.239Z",
    fill: "black"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M303.374 158.413L304.73 155.662L301.808 154.222L300.452 156.973L303.374 158.413Z",
    fill: "black"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M297.642 155.588L298.997 152.837L296.075 151.397L294.72 154.148L297.642 155.588Z",
    fill: "black"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M291.909 152.763L293.265 150.012L290.343 148.572L288.987 151.323L291.909 152.763Z",
    fill: "black"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M286.176 149.938L287.532 147.187L284.61 145.747L283.254 148.497L286.176 149.938Z",
    fill: "black"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M280.444 147.112L281.799 144.361L278.877 142.921L277.522 145.672L280.444 147.112Z",
    fill: "black"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M274.711 144.287L276.067 141.536L273.145 140.096L271.789 142.847L274.711 144.287Z",
    fill: "black"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M268.978 141.462L270.334 138.711L267.412 137.271L266.056 140.022L268.978 141.462Z",
    fill: "black"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M263.246 138.637L264.602 135.886L261.679 134.446L260.324 137.197L263.246 138.637Z",
    fill: "black"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M257.513 135.811L258.869 133.061L255.947 131.62L254.591 134.371L257.513 135.811Z",
    fill: "black"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M251.78 132.986L253.136 130.235L250.214 128.795L248.858 131.546L251.78 132.986Z",
    fill: "black"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M246.048 130.161L247.404 127.41L244.481 125.97L243.126 128.721L246.048 130.161Z",
    fill: "black"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M360.955 193.601L362.391 190.685L359.294 189.159L357.857 192.074L360.955 193.601Z",
    fill: "black"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M355.222 190.775L356.659 187.86L353.562 186.333L352.125 189.249L355.222 190.775Z",
    fill: "black"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M349.489 187.95L350.926 185.034L347.829 183.508L346.392 186.424L349.489 187.95Z",
    fill: "black"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M343.757 185.125L345.194 182.209L342.096 180.683L340.659 183.599L343.757 185.125Z",
    fill: "black"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M338.024 182.3L339.461 179.384L336.364 177.858L334.927 180.773L338.024 182.3Z",
    fill: "black"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M332.291 179.474L333.728 176.559L330.631 175.032L329.194 177.948L332.291 179.474Z",
    fill: "black"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M326.559 176.649L327.996 173.733L324.898 172.207L323.461 175.123L326.559 176.649Z",
    fill: "black"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M320.826 173.824L322.263 170.908L319.166 169.382L317.729 172.298L320.826 173.824Z",
    fill: "black"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M315.093 170.999L316.53 168.083L313.433 166.557L311.996 169.472L315.093 170.999Z",
    fill: "black"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M309.361 168.173L310.798 165.258L307.7 163.731L306.263 166.647L309.361 168.173Z",
    fill: "black"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M303.628 165.348L305.065 162.433L301.968 160.906L300.531 163.822L303.628 165.348Z",
    fill: "black"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M297.895 162.523L299.332 159.607L296.235 158.081L294.798 160.997L297.895 162.523Z",
    fill: "black"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M292.163 159.698L293.6 156.782L290.502 155.256L289.065 158.171L292.163 159.698Z",
    fill: "black"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M286.43 156.872L287.867 153.957L284.77 152.43L283.333 155.346L286.43 156.872Z",
    fill: "black"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M280.697 154.047L282.134 151.132L279.037 149.605L277.6 152.521L280.697 154.047Z",
    fill: "black"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M274.965 151.222L276.402 148.306L273.304 146.78L271.867 149.696L274.965 151.222Z",
    fill: "black"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M269.232 148.397L270.669 145.481L267.572 143.955L266.135 146.87L269.232 148.397Z",
    fill: "black"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M263.499 145.572L264.936 142.656L261.839 141.129L260.402 144.045L263.499 145.572Z",
    fill: "black"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M257.767 142.746L259.204 139.831L256.106 138.304L254.67 141.22L257.767 142.746Z",
    fill: "black"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M252.034 139.921L253.471 137.005L250.374 135.479L248.937 138.395L252.034 139.921Z",
    fill: "black"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M246.301 137.096L247.738 134.18L244.641 132.654L243.204 135.569L246.301 137.096Z",
    fill: "black"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M355.478 197.718L357.002 194.627L353.718 193.009L352.195 196.1L355.478 197.718Z",
    fill: "black"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M349.746 194.893L351.269 191.802L347.986 190.184L346.462 193.275L349.746 194.893Z",
    fill: "black"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M344.013 192.068L345.536 188.977L342.253 187.359L340.73 190.45L344.013 192.068Z",
    fill: "black"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M338.28 189.242L339.804 186.152L336.52 184.533L334.997 187.624L338.28 189.242Z",
    fill: "black"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M332.548 186.417L334.071 183.326L330.788 181.708L329.265 184.799L332.548 186.417Z",
    fill: "black"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M326.815 183.592L328.338 180.501L325.055 178.883L323.532 181.974L326.815 183.592Z",
    fill: "black"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M321.082 180.767L322.606 177.676L319.322 176.058L317.799 179.149L321.082 180.767Z",
    fill: "black"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M315.35 177.941L316.873 174.851L313.59 173.233L312.067 176.323L315.35 177.941Z",
    fill: "black"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M309.617 175.116L311.14 172.025L307.857 170.407L306.334 173.498L309.617 175.116Z",
    fill: "black"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M303.884 172.291L305.408 169.2L302.125 167.582L300.601 170.673L303.884 172.291Z",
    fill: "black"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M298.152 169.466L299.675 166.375L296.392 164.757L294.869 167.848L298.152 169.466Z",
    fill: "black"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M292.419 166.64L293.942 163.55L290.659 161.932L289.136 165.022L292.419 166.64Z",
    fill: "black"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M286.687 163.815L288.21 160.724L284.927 159.106L283.403 162.197L286.687 163.815Z",
    fill: "black"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M280.954 160.99L282.477 157.899L279.194 156.281L277.671 159.372L280.954 160.99Z",
    fill: "black"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M275.221 158.165L276.744 155.074L273.461 153.456L271.938 156.547L275.221 158.165Z",
    fill: "black"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M269.489 155.34L271.012 152.249L267.729 150.631L266.205 153.721L269.489 155.34Z",
    fill: "black"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M263.756 152.514L265.279 149.423L261.996 147.805L260.473 150.896L263.756 152.514Z",
    fill: "black"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M258.023 149.689L259.547 146.598L256.263 144.98L254.74 148.071L258.023 149.689Z",
    fill: "black"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M252.291 146.864L253.814 143.773L250.531 142.155L249.007 145.246L252.291 146.864Z",
    fill: "black"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M246.558 144.039L248.081 140.948L244.798 139.33L243.275 142.42L246.558 144.039Z",
    fill: "black"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M240.825 141.213L242.349 138.122L239.065 136.504L237.542 139.595L240.825 141.213Z",
    fill: "black"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M355.735 204.661L357.344 201.395L353.875 199.685L352.266 202.951L355.735 204.661Z",
    fill: "black"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M350.002 201.836L351.612 198.57L348.143 196.86L346.533 200.126L350.002 201.836Z",
    fill: "black"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M344.27 199.01L345.879 195.744L342.41 194.035L340.8 197.301L344.27 199.01Z",
    fill: "black"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M338.537 196.185L340.147 192.919L336.677 191.209L335.068 194.475L338.537 196.185Z",
    fill: "black"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M332.804 193.36L334.414 190.094L330.945 188.384L329.335 191.65L332.804 193.36Z",
    fill: "black"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M327.072 190.535L328.681 187.269L325.212 185.559L323.602 188.825L327.072 190.535Z",
    fill: "black"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M321.339 187.709L322.949 184.443L319.479 182.734L317.87 186L321.339 187.709Z",
    fill: "black"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M315.606 184.884L317.216 181.618L313.747 179.908L312.137 183.174L315.606 184.884Z",
    fill: "black"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M309.874 182.059L311.483 178.793L308.014 177.083L306.404 180.349L309.874 182.059Z",
    fill: "black"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M304.141 179.234L305.751 175.968L302.281 174.258L300.672 177.524L304.141 179.234Z",
    fill: "black"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M298.408 176.408L300.018 173.143L296.549 171.433L294.939 174.699L298.408 176.408Z",
    fill: "black"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M292.676 173.583L294.285 170.317L290.816 168.607L289.206 171.873L292.676 173.583Z",
    fill: "black"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M286.943 170.758L288.553 167.492L285.083 165.782L283.474 169.048L286.943 170.758Z",
    fill: "black"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M281.21 167.933L282.82 164.667L279.351 162.957L277.741 166.223L281.21 167.933Z",
    fill: "black"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M275.478 165.108L277.087 161.842L273.618 160.132L272.008 163.398L275.478 165.108Z",
    fill: "black"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M269.745 162.282L271.355 159.016L267.885 157.307L266.276 160.573L269.745 162.282Z",
    fill: "black"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M264.012 159.457L265.622 156.191L262.153 154.481L260.543 157.747L264.012 159.457Z",
    fill: "black"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M258.28 156.632L259.889 153.366L256.42 151.656L254.81 154.922L258.28 156.632Z",
    fill: "black"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M252.547 153.807L254.157 150.541L250.687 148.831L249.078 152.097L252.547 153.807Z",
    fill: "black"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M246.814 150.981L248.424 147.715L244.955 146.006L243.345 149.272L246.814 150.981Z",
    fill: "black"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M241.082 148.156L242.691 144.89L239.222 143.18L237.612 146.446L241.082 148.156Z",
    fill: "black"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M350.256 208.771L351.947 205.34L348.302 203.544L346.611 206.975L350.256 208.771Z",
    fill: "black"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M344.523 205.945L346.214 202.515L342.57 200.718L340.879 204.149L344.523 205.945Z",
    fill: "black"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M338.791 203.12L340.481 199.689L336.837 197.893L335.146 201.324L338.791 203.12Z",
    fill: "black"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M333.058 200.295L334.749 196.864L331.104 195.068L329.413 198.499L333.058 200.295Z",
    fill: "black"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M327.325 197.47L329.016 194.039L325.372 192.243L323.681 195.674L327.325 197.47Z",
    fill: "black"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M321.593 194.644L323.283 191.214L319.639 189.417L317.948 192.848L321.593 194.644Z",
    fill: "black"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M315.86 191.819L317.551 188.388L313.906 186.592L312.215 190.023L315.86 191.819Z",
    fill: "black"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M310.127 188.994L311.818 185.563L308.174 183.767L306.483 187.198L310.127 188.994Z",
    fill: "black"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M304.395 186.169L306.085 182.738L302.441 180.942L300.75 184.373L304.395 186.169Z",
    fill: "black"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M298.662 183.343L300.353 179.913L296.708 178.116L295.018 181.547L298.662 183.343Z",
    fill: "black"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M292.929 180.518L294.62 177.087L290.976 175.291L289.285 178.722L292.929 180.518Z",
    fill: "black"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M287.197 177.693L288.887 174.262L285.243 172.466L283.552 175.897L287.197 177.693Z",
    fill: "black"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M281.464 174.868L283.155 171.437L279.51 169.641L277.82 173.072L281.464 174.868Z",
    fill: "black"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M275.731 172.042L277.422 168.612L273.778 166.816L272.087 170.246L275.731 172.042Z",
    fill: "black"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M269.999 169.217L271.689 165.786L268.045 163.99L266.354 167.421L269.999 169.217Z",
    fill: "black"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M264.266 166.392L265.957 162.961L262.312 161.165L260.622 164.596L264.266 166.392Z",
    fill: "black"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M258.533 163.567L260.224 160.136L256.58 158.34L254.889 161.771L258.533 163.567Z",
    fill: "black"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M252.801 160.741L254.492 157.311L250.847 155.515L249.156 158.945L252.801 160.741Z",
    fill: "black"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M247.068 157.916L248.759 154.485L245.114 152.689L243.424 156.12L247.068 157.916Z",
    fill: "black"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M241.335 155.091L243.026 151.66L239.382 149.864L237.691 153.295L241.335 155.091Z",
    fill: "black"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M235.603 152.266L237.294 148.835L233.649 147.039L231.958 150.47L235.603 152.266Z",
    fill: "black"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M350.512 215.713L352.289 212.107L348.459 210.22L346.682 213.826L350.512 215.713Z",
    fill: "black"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M344.78 212.888L346.557 209.282L342.726 207.394L340.949 211L344.78 212.888Z",
    fill: "black"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M339.047 210.063L340.824 206.457L336.994 204.569L335.217 208.175L339.047 210.063Z",
    fill: "black"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M333.314 207.238L335.092 203.632L331.261 201.744L329.484 205.35L333.314 207.238Z",
    fill: "black"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M327.582 204.412L329.359 200.806L325.528 198.919L323.751 202.525L327.582 204.412Z",
    fill: "black"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M321.849 201.587L323.626 197.981L319.796 196.093L318.019 199.699L321.849 201.587Z",
    fill: "black"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M316.116 198.762L317.894 195.156L314.063 193.268L312.286 196.874L316.116 198.762Z",
    fill: "black"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M310.384 195.937L312.161 192.331L308.33 190.443L306.553 194.049L310.384 195.937Z",
    fill: "black"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M304.651 193.111L306.428 189.505L302.598 187.618L300.821 191.224L304.651 193.111Z",
    fill: "black"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M298.918 190.286L300.696 186.68L296.865 184.792L295.088 188.398L298.918 190.286Z",
    fill: "black"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M293.186 187.461L294.963 183.855L291.132 181.967L289.355 185.573L293.186 187.461Z",
    fill: "black"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M287.453 184.636L289.23 181.03L285.4 179.142L283.623 182.748L287.453 184.636Z",
    fill: "black"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M281.72 181.81L283.498 178.204L279.667 176.317L277.89 179.923L281.72 181.81Z",
    fill: "black"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M275.988 178.985L277.765 175.379L273.935 173.491L272.157 177.097L275.988 178.985Z",
    fill: "black"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M270.255 176.16L272.032 172.554L268.202 170.666L266.425 174.272L270.255 176.16Z",
    fill: "black"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M264.522 173.335L266.3 169.729L262.469 167.841L260.692 171.447L264.522 173.335Z",
    fill: "black"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M258.79 170.509L260.567 166.903L256.737 165.016L254.959 168.622L258.79 170.509Z",
    fill: "black"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M253.057 167.684L254.834 164.078L251.004 162.19L249.227 165.796L253.057 167.684Z",
    fill: "black"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M247.325 164.859L249.102 161.253L245.271 159.365L243.494 162.971L247.325 164.859Z",
    fill: "black"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M241.592 162.034L243.369 158.428L239.539 156.54L237.761 160.146L241.592 162.034Z",
    fill: "black"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M235.859 159.209L237.636 155.603L233.806 153.715L232.029 157.321L235.859 159.209Z",
    fill: "black"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 219.831L346.9 216.05L342.883 214.07L341.02 217.851L345.036 219.831Z",
    fill: "black"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M339.304 217.006L341.167 213.224L337.15 211.245L335.287 215.026L339.304 217.006Z",
    fill: "black"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M333.571 214.18L335.434 210.399L331.418 208.42L329.554 212.201L333.571 214.18Z",
    fill: "black"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M327.838 211.355L329.702 207.574L325.685 205.595L323.822 209.376L327.838 211.355Z",
    fill: "black"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M322.106 208.53L323.969 204.749L319.953 202.769L318.089 206.55L322.106 208.53Z",
    fill: "black"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M316.373 205.705L318.236 201.924L314.22 199.944L312.356 203.725L316.373 205.705Z",
    fill: "black"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M310.64 202.879L312.504 199.098L308.487 197.119L306.624 200.9L310.64 202.879Z",
    fill: "black"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M304.908 200.054L306.771 196.273L302.755 194.294L300.891 198.075L304.908 200.054Z",
    fill: "black"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M299.175 197.229L301.038 193.448L297.022 191.468L295.158 195.249L299.175 197.229Z",
    fill: "black"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M293.442 194.404L295.306 190.623L291.289 188.643L289.426 192.424L293.442 194.404Z",
    fill: "black"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M287.71 191.578L289.573 187.797L285.557 185.818L283.693 189.599L287.71 191.578Z",
    fill: "black"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M281.977 188.753L283.84 184.972L279.824 182.993L277.96 186.774L281.977 188.753Z",
    fill: "black"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M276.244 185.928L278.108 182.147L274.091 180.167L272.228 183.949L276.244 185.928Z",
    fill: "black"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M270.512 183.103L272.375 179.322L268.359 177.342L266.495 181.123L270.512 183.103Z",
    fill: "black"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M264.779 180.277L266.642 176.496L262.626 174.517L260.762 178.298L264.779 180.277Z",
    fill: "black"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M259.046 177.452L260.91 173.671L256.893 171.692L255.03 175.473L259.046 177.452Z",
    fill: "black"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M253.314 174.627L255.177 170.846L251.161 168.866L249.297 172.648L253.314 174.627Z",
    fill: "black"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M247.581 171.802L249.445 168.021L245.428 166.041L243.565 169.822L247.581 171.802Z",
    fill: "black"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M241.848 168.977L243.712 165.195L239.695 163.216L237.832 166.997L241.848 168.977Z",
    fill: "black"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M236.116 166.151L237.979 162.37L233.963 160.391L232.099 164.172L236.116 166.151Z",
    fill: "black"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M230.383 163.326L232.247 159.545L228.23 157.565L226.367 161.347L230.383 163.326Z",
    fill: "black"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M345.29 226.766L347.234 222.82L343.043 220.754L341.098 224.7L345.29 226.766Z",
    fill: "black"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M339.557 223.941L341.502 219.995L337.31 217.929L335.365 221.875L339.557 223.941Z",
    fill: "black"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M333.824 221.115L335.769 217.169L331.578 215.104L329.633 219.05L333.824 221.115Z",
    fill: "black"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M328.092 218.29L330.036 214.344L325.845 212.278L323.9 216.224L328.092 218.29Z",
    fill: "black"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M322.359 215.465L324.304 211.519L320.112 209.453L318.168 213.399L322.359 215.465Z",
    fill: "black"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M316.626 212.64L318.571 208.694L314.38 206.628L312.435 210.574L316.626 212.64Z",
    fill: "black"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M310.894 209.814L312.839 205.868L308.647 203.803L306.702 207.749L310.894 209.814Z",
    fill: "black"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M305.161 206.989L307.106 203.043L302.914 200.977L300.97 204.923L305.161 206.989Z",
    fill: "black"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M299.429 204.164L301.373 200.218L297.182 198.152L295.237 202.098L299.429 204.164Z",
    fill: "black"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M293.696 201.339L295.641 197.393L291.449 195.327L289.504 199.273L293.696 201.339Z",
    fill: "black"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M287.963 198.513L289.908 194.567L285.716 192.502L283.772 196.448L287.963 198.513Z",
    fill: "black"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M282.231 195.688L284.175 191.742L279.984 189.676L278.039 193.622L282.231 195.688Z",
    fill: "black"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M276.498 192.863L278.443 188.917L274.251 186.851L272.306 190.797L276.498 192.863Z",
    fill: "black"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M270.765 190.038L272.71 186.092L268.518 184.026L266.574 187.972L270.765 190.038Z",
    fill: "black"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M265.033 187.212L266.977 183.266L262.786 181.201L260.841 185.147L265.033 187.212Z",
    fill: "black"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M259.3 184.387L261.245 180.441L257.053 178.375L255.108 182.321L259.3 184.387Z",
    fill: "black"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M253.567 181.562L255.512 177.616L251.32 175.55L249.376 179.496L253.567 181.562Z",
    fill: "black"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M247.835 178.737L249.779 174.791L245.588 172.725L243.643 176.671L247.835 178.737Z",
    fill: "black"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M242.102 175.911L244.047 171.965L239.855 169.9L237.91 173.846L242.102 175.911Z",
    fill: "black"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M236.369 173.086L238.314 169.14L234.122 167.074L232.178 171.02L236.369 173.086Z",
    fill: "black"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M230.637 170.261L232.581 166.315L228.39 164.249L226.445 168.195L230.637 170.261Z",
    fill: "black"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M339.814 230.883L341.845 226.762L337.467 224.605L335.436 228.726L339.814 230.883Z",
    fill: "black"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M334.081 228.058L336.112 223.937L331.734 221.779L329.703 225.901L334.081 228.058Z",
    fill: "black"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M328.348 225.233L330.379 221.112L326.002 218.954L323.971 223.075L328.348 225.233Z",
    fill: "black"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M322.616 222.408L324.647 218.286L320.269 216.129L318.238 220.25L322.616 222.408Z",
    fill: "black"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M316.883 219.582L318.914 215.461L314.536 213.304L312.505 217.425L316.883 219.582Z",
    fill: "black"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M311.15 216.757L313.181 212.636L308.804 210.479L306.773 214.6L311.15 216.757Z",
    fill: "black"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M305.418 213.932L307.449 209.811L303.071 207.653L301.04 211.774L305.418 213.932Z",
    fill: "black"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M299.685 211.107L301.716 206.985L297.338 204.828L295.307 208.949L299.685 211.107Z",
    fill: "black"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M293.952 208.281L295.983 204.16L291.606 202.003L289.575 206.124L293.952 208.281Z",
    fill: "black"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M288.22 205.456L290.251 201.335L285.873 199.178L283.842 203.299L288.22 205.456Z",
    fill: "black"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M282.487 202.631L284.518 198.51L280.14 196.352L278.109 200.473L282.487 202.631Z",
    fill: "black"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M276.754 199.806L278.785 195.685L274.408 193.527L272.377 197.648L276.754 199.806Z",
    fill: "black"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M271.022 196.98L273.053 192.859L268.675 190.702L266.644 194.823L271.022 196.98Z",
    fill: "black"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M265.289 194.155L267.32 190.034L262.942 187.877L260.911 191.998L265.289 194.155Z",
    fill: "black"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M259.556 191.33L261.587 187.209L257.21 185.051L255.179 189.172L259.556 191.33Z",
    fill: "black"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M253.824 188.505L255.855 184.384L251.477 182.226L249.446 186.347L253.824 188.505Z",
    fill: "black"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M248.091 185.679L250.122 181.558L245.744 179.401L243.713 183.522L248.091 185.679Z",
    fill: "black"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M242.358 182.854L244.389 178.733L240.012 176.576L237.981 180.697L242.358 182.854Z",
    fill: "black"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M236.626 180.029L238.657 175.908L234.279 173.75L232.248 177.871L236.626 180.029Z",
    fill: "black"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M230.893 177.204L232.924 173.083L228.547 170.925L226.515 175.046L230.893 177.204Z",
    fill: "black"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M225.161 174.378L227.192 170.257L222.814 168.1L220.783 172.221L225.161 174.378Z",
    fill: "black"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M467.228 111.392L467.568 110.702L466.835 110.34L466.495 111.031L467.228 111.392Z",
    fill: "black"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M461.496 108.567L461.836 107.876L461.103 107.515L460.762 108.205L461.496 108.567Z",
    fill: "black"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M455.763 105.741L456.103 105.051L455.37 104.69L455.03 105.38L455.763 105.741Z",
    fill: "black"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M450.03 102.916L450.37 102.226L449.637 101.865L449.297 102.555L450.03 102.916Z",
    fill: "black"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M444.298 100.091L444.638 99.4007L443.905 99.0393L443.564 99.7296L444.298 100.091Z",
    fill: "black"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M438.565 97.2657L438.905 96.5755L438.172 96.2141L437.832 96.9044L438.565 97.2657Z",
    fill: "black"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M432.832 94.4405L433.173 93.7502L432.439 93.3888L432.099 94.0791L432.832 94.4405Z",
    fill: "black"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M427.1 91.6153L427.44 90.925L426.707 90.5636L426.366 91.2539L427.1 91.6153Z",
    fill: "black"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M421.367 88.79L421.707 88.0997L420.974 87.7384L420.634 88.4286L421.367 88.79Z",
    fill: "black"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M415.634 85.9648L415.975 85.2745L415.241 84.9131L414.901 85.6034L415.634 85.9648Z",
    fill: "black"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M409.902 83.1395L410.242 82.4492L409.509 82.0879L409.168 82.7782L409.902 83.1395Z",
    fill: "black"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M404.169 80.3143L404.509 79.624L403.776 79.2626L403.436 79.9529L404.169 80.3143Z",
    fill: "black"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M398.436 77.489L398.777 76.7988L398.043 76.4374L397.703 77.1277L398.436 77.489Z",
    fill: "black"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M392.704 74.6638L393.044 73.9735L392.311 73.6121L391.97 74.3024L392.704 74.6638Z",
    fill: "black"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M386.971 71.8386L387.311 71.1483L386.578 70.7869L386.238 71.4772L386.971 71.8386Z",
    fill: "black"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M381.238 69.0133L381.579 68.323L380.845 67.9617L380.505 68.6519L381.238 69.0133Z",
    fill: "black"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M375.506 66.1881L375.846 65.4978L375.113 65.1364L374.773 65.8267L375.506 66.1881Z",
    fill: "black"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M369.773 63.3628L370.113 62.6725L369.38 62.3112L369.04 63.0015L369.773 63.3628Z",
    fill: "black"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M364.04 60.5376L364.381 59.8473L363.647 59.4859L363.307 60.1762L364.04 60.5376Z",
    fill: "black"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M467.482 118.327L467.903 117.472L466.995 117.024L466.573 117.879L467.482 118.327Z",
    fill: "black"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M461.749 115.502L462.171 114.646L461.262 114.199L460.841 115.054L461.749 115.502Z",
    fill: "black"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M456.017 112.676L456.438 111.821L455.53 111.374L455.108 112.229L456.017 112.676Z",
    fill: "black"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M450.284 109.851L450.705 108.996L449.797 108.548L449.375 109.403L450.284 109.851Z",
    fill: "black"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M444.551 107.026L444.973 106.171L444.064 105.723L443.643 106.578L444.551 107.026Z",
    fill: "black"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M438.819 104.201L439.24 103.346L438.332 102.898L437.91 103.753L438.819 104.201Z",
    fill: "black"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M433.086 101.375L433.507 100.52L432.599 100.073L432.178 100.928L433.086 101.375Z",
    fill: "black"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M427.353 98.5502L427.775 97.695L426.866 97.2474L426.445 98.1025L427.353 98.5502Z",
    fill: "black"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M421.621 95.7249L422.042 94.8698L421.134 94.4221L420.712 95.2773L421.621 95.7249Z",
    fill: "black"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M415.888 92.8997L416.309 92.0446L415.401 91.5969L414.98 92.452L415.888 92.8997Z",
    fill: "black"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M410.155 90.0744L410.577 89.2193L409.668 88.7716L409.247 89.6268L410.155 90.0744Z",
    fill: "black"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M404.423 87.2492L404.844 86.3941L403.936 85.9464L403.514 86.8015L404.423 87.2492Z",
    fill: "black"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M398.69 84.424L399.111 83.5688L398.203 83.1212L397.782 83.9763L398.69 84.424Z",
    fill: "black"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M392.957 81.5987L393.379 80.7436L392.47 80.2959L392.049 81.151L392.957 81.5987Z",
    fill: "black"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M387.225 78.7735L387.646 77.9183L386.738 77.4707L386.316 78.3258L387.225 78.7735Z",
    fill: "black"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M381.492 75.9482L381.913 75.0931L381.005 74.6454L380.584 75.5006L381.492 75.9482Z",
    fill: "black"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M375.759 73.123L376.181 72.2679L375.272 71.8202L374.851 72.6753L375.759 73.123Z",
    fill: "black"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M370.027 70.2978L370.448 69.4426L369.54 68.9949L369.118 69.8501L370.027 70.2978Z",
    fill: "black"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M364.294 67.4725L364.715 66.6174L363.807 66.1697L363.386 67.0248L364.294 67.4725Z",
    fill: "black"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M467.738 125.27L468.246 124.239L467.152 123.7L466.644 124.73L467.738 125.27Z",
    fill: "black"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M462.006 122.444L462.513 121.414L461.419 120.875L460.911 121.905L462.006 122.444Z",
    fill: "black"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M456.273 119.619L456.781 118.589L455.686 118.05L455.179 119.08L456.273 119.619Z",
    fill: "black"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M450.54 116.794L451.048 115.764L449.954 115.224L449.446 116.255L450.54 116.794Z",
    fill: "black"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M444.808 113.969L445.315 112.938L444.221 112.399L443.713 113.429L444.808 113.969Z",
    fill: "black"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M439.075 111.143L439.583 110.113L438.488 109.574L437.981 110.604L439.075 111.143Z",
    fill: "black"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M433.342 108.318L433.85 107.288L432.756 106.749L432.248 107.779L433.342 108.318Z",
    fill: "black"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M427.61 105.493L428.118 104.463L427.023 103.923L426.515 104.954L427.61 105.493Z",
    fill: "black"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M421.877 102.668L422.385 101.637L421.29 101.098L420.783 102.128L421.877 102.668Z",
    fill: "black"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M416.144 99.8425L416.652 98.8122L415.558 98.2728L415.05 99.3031L416.144 99.8425Z",
    fill: "black"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M410.412 97.0172L410.92 95.9869L409.825 95.4476L409.317 96.4778L410.412 97.0172Z",
    fill: "black"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M404.679 94.192L405.187 93.1617L404.092 92.6223L403.585 93.6526L404.679 94.192Z",
    fill: "black"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M398.946 91.3667L399.454 90.3364L398.36 89.7971L397.852 90.8274L398.946 91.3667Z",
    fill: "black"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M393.214 88.5415L393.722 87.5112L392.627 86.9718L392.119 88.0021L393.214 88.5415Z",
    fill: "black"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M387.481 85.7162L387.989 84.686L386.895 84.1466L386.387 85.1769L387.481 85.7162Z",
    fill: "black"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M381.749 82.891L382.256 81.8607L381.162 81.3214L380.654 82.3516L381.749 82.891Z",
    fill: "black"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M376.016 80.0658L376.524 79.0355L375.429 78.4961L374.921 79.5264L376.016 80.0658Z",
    fill: "black"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M370.283 77.2405L370.791 76.2102L369.697 75.6709L369.189 76.7012L370.283 77.2405Z",
    fill: "black"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M364.551 74.4153L365.058 73.385L363.964 72.8456L363.456 73.8759L364.551 74.4153Z",
    fill: "black"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M358.818 71.59L359.326 70.5597L358.231 70.0204L357.723 71.0507L358.818 71.59Z",
    fill: "black"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M467.995 132.212L468.589 131.007L467.308 130.376L466.714 131.581L467.995 132.212Z",
    fill: "black"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M462.262 129.387L462.856 128.182L461.576 127.551L460.982 128.756L462.262 129.387Z",
    fill: "black"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M456.53 126.562L457.124 125.356L455.843 124.725L455.249 125.931L456.53 126.562Z",
    fill: "black"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M450.797 123.737L451.391 122.531L450.11 121.9L449.516 123.106L450.797 123.737Z",
    fill: "black"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M445.064 120.911L445.658 119.706L444.378 119.075L443.784 120.28L445.064 120.911Z",
    fill: "black"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M439.332 118.086L439.926 116.881L438.645 116.25L438.051 117.455L439.332 118.086Z",
    fill: "black"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M433.599 115.261L434.193 114.056L432.913 113.424L432.318 114.63L433.599 115.261Z",
    fill: "black"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M427.866 112.436L428.46 111.23L427.18 110.599L426.586 111.805L427.866 112.436Z",
    fill: "black"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M422.134 109.61L422.728 108.405L421.447 107.774L420.853 108.979L422.134 109.61Z",
    fill: "black"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M416.401 106.785L416.995 105.58L415.715 104.949L415.12 106.154L416.401 106.785Z",
    fill: "black"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M410.668 103.96L411.262 102.755L409.982 102.123L409.388 103.329L410.668 103.96Z",
    fill: "black"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M404.936 101.135L405.53 99.9293L404.249 99.2982L403.655 100.504L404.936 101.135Z",
    fill: "black"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M399.203 98.3095L399.797 97.1041L398.517 96.473L397.923 97.6784L399.203 98.3095Z",
    fill: "black"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M393.47 95.4842L394.064 94.2788L392.784 93.6478L392.19 94.8532L393.47 95.4842Z",
    fill: "black"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M387.738 92.659L388.332 91.4536L387.051 90.8225L386.457 92.0279L387.738 92.659Z",
    fill: "black"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M382.005 89.8338L382.599 88.6283L381.319 87.9973L380.725 89.2027L382.005 89.8338Z",
    fill: "black"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M376.272 87.0085L376.866 85.8031L375.586 85.172L374.992 86.3775L376.272 87.0085Z",
    fill: "black"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M370.54 84.1833L371.134 82.9778L369.853 82.3468L369.259 83.5522L370.54 84.1833Z",
    fill: "black"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M364.807 81.358L365.401 80.1526L364.121 79.5215L363.527 80.727L364.807 81.358Z",
    fill: "black"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M359.074 78.5328L359.668 77.3274L358.388 76.6963L357.794 77.9017L359.074 78.5328Z",
    fill: "black"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M468.248 139.147L468.924 137.777L467.468 137.06L466.793 138.43L468.248 139.147Z",
    fill: "black"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M462.516 136.322L463.191 134.952L461.736 134.234L461.06 135.605L462.516 136.322Z",
    fill: "black"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M456.783 133.497L457.458 132.127L456.003 131.409L455.328 132.779L456.783 133.497Z",
    fill: "black"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M451.05 130.672L451.726 129.301L450.27 128.584L449.595 129.954L451.05 130.672Z",
    fill: "black"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M445.318 127.846L445.993 126.476L444.538 125.759L443.862 127.129L445.318 127.846Z",
    fill: "black"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M439.585 125.021L440.26 123.651L438.805 122.933L438.13 124.304L439.585 125.021Z",
    fill: "black"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M433.853 122.196L434.528 120.826L433.072 120.108L432.397 121.479L433.853 122.196Z",
    fill: "black"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M428.12 119.371L428.795 118L427.34 117.283L426.664 118.653L428.12 119.371Z",
    fill: "black"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M422.387 116.545L423.063 115.175L421.607 114.458L420.932 115.828L422.387 116.545Z",
    fill: "black"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M416.655 113.72L417.33 112.35L415.874 111.633L415.199 113.003L416.655 113.72Z",
    fill: "black"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M410.922 110.895L411.597 109.525L410.142 108.807L409.466 110.178L410.922 110.895Z",
    fill: "black"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M405.189 108.07L405.865 106.699L404.409 105.982L403.734 107.352L405.189 108.07Z",
    fill: "black"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M399.457 105.244L400.132 103.874L398.676 103.157L398.001 104.527L399.457 105.244Z",
    fill: "black"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M393.724 102.419L394.399 101.049L392.944 100.332L392.268 101.702L393.724 102.419Z",
    fill: "black"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M387.991 99.5939L388.667 98.2236L387.211 97.5063L386.536 98.8766L387.991 99.5939Z",
    fill: "black"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M382.259 96.7687L382.934 95.3984L381.478 94.681L380.803 96.0513L382.259 96.7687Z",
    fill: "black"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M376.526 93.9434L377.201 92.5732L375.746 91.8558L375.07 93.2261L376.526 93.9434Z",
    fill: "black"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M370.793 91.1182L371.469 89.7479L370.013 89.0306L369.338 90.4008L370.793 91.1182Z",
    fill: "black"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M365.061 88.293L365.736 86.9227L364.28 86.2053L363.605 87.5756L365.061 88.293Z",
    fill: "black"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M359.328 85.4677L360.003 84.0974L358.548 83.3801L357.872 84.7504L359.328 85.4677Z",
    fill: "black"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M353.595 82.6425L354.271 81.2722L352.815 80.5548L352.14 81.9251L353.595 82.6425Z",
    fill: "black"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M468.505 146.09L469.267 144.545L467.625 143.736L466.863 145.281L468.505 146.09Z",
    fill: "black"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M462.772 143.265L463.534 141.719L461.892 140.91L461.131 142.456L462.772 143.265Z",
    fill: "black"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M457.04 140.44L457.801 138.894L456.16 138.085L455.398 139.631L457.04 140.44Z",
    fill: "black"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M451.307 137.614L452.069 136.069L450.427 135.26L449.665 136.805L451.307 137.614Z",
    fill: "black"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M445.574 134.789L446.336 133.244L444.694 132.435L443.933 133.98L445.574 134.789Z",
    fill: "black"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M439.842 131.964L440.603 130.418L438.962 129.609L438.2 131.155L439.842 131.964Z",
    fill: "black"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M434.109 129.139L434.871 127.593L433.229 126.784L432.467 128.33L434.109 129.139Z",
    fill: "black"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M428.376 126.313L429.138 124.768L427.496 123.959L426.735 125.504L428.376 126.313Z",
    fill: "black"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M422.644 123.488L423.405 121.943L421.764 121.134L421.002 122.679L422.644 123.488Z",
    fill: "black"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M416.911 120.663L417.673 119.117L416.031 118.308L415.269 119.854L416.911 120.663Z",
    fill: "black"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M411.178 117.838L411.94 116.292L410.298 115.483L409.537 117.029L411.178 117.838Z",
    fill: "black"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M405.446 115.012L406.207 113.467L404.566 112.658L403.804 114.203L405.446 115.012Z",
    fill: "black"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M399.713 112.187L400.475 110.642L398.833 109.833L398.071 111.378L399.713 112.187Z",
    fill: "black"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M393.98 109.362L394.742 107.817L393.1 107.007L392.339 108.553L393.98 109.362Z",
    fill: "black"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M388.248 106.537L389.009 104.991L387.368 104.182L386.606 105.728L388.248 106.537Z",
    fill: "black"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M382.515 103.711L383.277 102.166L381.635 101.357L380.873 102.902L382.515 103.711Z",
    fill: "black"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M376.782 100.886L377.544 99.3408L375.902 98.5317L375.141 100.077L376.782 100.886Z",
    fill: "black"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M371.05 98.061L371.811 96.5155L370.17 95.7065L369.408 97.2519L371.05 98.061Z",
    fill: "black"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M365.317 95.2357L366.079 93.6903L364.437 92.8812L363.676 94.4267L365.317 95.2357Z",
    fill: "black"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M359.584 92.4105L360.346 90.865L358.704 90.056L357.943 91.6014L359.584 92.4105Z",
    fill: "black"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M353.852 89.5852L354.613 88.0398L352.972 87.2308L352.21 88.7762L353.852 89.5852Z",
    fill: "black"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M463.029 150.208L463.877 148.487L462.049 147.586L461.201 149.307L463.029 150.208Z",
    fill: "black"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M457.296 147.382L458.144 145.662L456.316 144.761L455.468 146.482L457.296 147.382Z",
    fill: "black"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M451.563 144.557L452.411 142.837L450.584 141.936L449.736 143.656L451.563 144.557Z",
    fill: "black"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M445.831 141.732L446.679 140.011L444.851 139.111L444.003 140.831L445.831 141.732Z",
    fill: "black"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M440.098 138.907L440.946 137.186L439.118 136.285L438.271 138.006L440.098 138.907Z",
    fill: "black"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M434.366 136.081L435.213 134.361L433.386 133.46L432.538 135.181L434.366 136.081Z",
    fill: "black"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M428.633 133.256L429.481 131.536L427.653 130.635L426.805 132.355L428.633 133.256Z",
    fill: "black"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M422.9 130.431L423.748 128.71L421.92 127.81L421.073 129.53L422.9 130.431Z",
    fill: "black"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M417.168 127.606L418.016 125.885L416.188 124.984L415.34 126.705L417.168 127.606Z",
    fill: "black"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M411.435 124.78L412.283 123.06L410.455 122.159L409.607 123.88L411.435 124.78Z",
    fill: "black"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M405.702 121.955L406.55 120.235L404.723 119.334L403.875 121.054L405.702 121.955Z",
    fill: "black"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M399.97 119.13L400.818 117.409L398.99 116.509L398.142 118.229L399.97 119.13Z",
    fill: "black"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M394.237 116.305L395.085 114.584L393.257 113.683L392.409 115.404L394.237 116.305Z",
    fill: "black"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M388.504 113.479L389.352 111.759L387.525 110.858L386.677 112.579L388.504 113.479Z",
    fill: "black"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M382.772 110.654L383.62 108.934L381.792 108.033L380.944 109.753L382.772 110.654Z",
    fill: "black"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M377.039 107.829L377.887 106.108L376.059 105.208L375.211 106.928L377.039 107.829Z",
    fill: "black"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M371.306 105.004L372.154 103.283L370.327 102.382L369.479 104.103L371.306 105.004Z",
    fill: "black"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M365.574 102.178L366.422 100.458L364.594 99.5572L363.746 101.278L365.574 102.178Z",
    fill: "black"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M359.841 99.3532L360.689 97.6327L358.861 96.7319L358.013 98.4525L359.841 99.3532Z",
    fill: "black"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M354.108 96.528L354.956 94.8074L353.129 93.9067L352.281 95.6273L354.108 96.528Z",
    fill: "black"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M348.376 93.7028L349.224 91.9822L347.396 91.0814L346.548 92.802L348.376 93.7028Z",
    fill: "black"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M463.282 157.143L464.212 155.257L462.209 154.27L461.28 156.155L463.282 157.143Z",
    fill: "black"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M457.55 154.317L458.479 152.432L456.476 151.445L455.547 153.33L457.55 154.317Z",
    fill: "black"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M451.817 151.492L452.746 149.607L450.743 148.62L449.814 150.505L451.817 151.492Z",
    fill: "black"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M446.084 148.667L447.014 146.781L445.011 145.794L444.082 147.68L446.084 148.667Z",
    fill: "black"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M440.352 145.842L441.281 143.956L439.278 142.969L438.349 144.855L440.352 145.842Z",
    fill: "black"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M434.619 143.016L435.548 141.131L433.546 140.144L432.616 142.029L434.619 143.016Z",
    fill: "black"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M428.886 140.191L429.816 138.306L427.813 137.319L426.884 139.204L428.886 140.191Z",
    fill: "black"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M423.154 137.366L424.083 135.48L422.08 134.493L421.151 136.379L423.154 137.366Z",
    fill: "black"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M417.421 134.541L418.35 132.655L416.348 131.668L415.418 133.554L417.421 134.541Z",
    fill: "black"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M411.688 131.715L412.618 129.83L410.615 128.843L409.686 130.728L411.688 131.715Z",
    fill: "black"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M405.956 128.89L406.885 127.005L404.882 126.018L403.953 127.903L405.956 128.89Z",
    fill: "black"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M400.223 126.065L401.152 124.179L399.15 123.192L398.22 125.078L400.223 126.065Z",
    fill: "black"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M394.491 123.24L395.42 121.354L393.417 120.367L392.488 122.253L394.491 123.24Z",
    fill: "black"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M388.758 120.414L389.687 118.529L387.684 117.542L386.755 119.427L388.758 120.414Z",
    fill: "black"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M383.025 117.589L383.954 115.704L381.952 114.717L381.022 116.602L383.025 117.589Z",
    fill: "black"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M377.293 114.764L378.222 112.878L376.219 111.891L375.29 113.777L377.293 114.764Z",
    fill: "black"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M371.56 111.939L372.489 110.053L370.486 109.066L369.557 110.952L371.56 111.939Z",
    fill: "black"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M365.827 109.113L366.756 107.228L364.754 106.241L363.824 108.126L365.827 109.113Z",
    fill: "black"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M360.095 106.288L361.024 104.403L359.021 103.416L358.092 105.301L360.095 106.288Z",
    fill: "black"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M354.362 103.463L355.291 101.577L353.288 100.59L352.359 102.476L354.362 103.463Z",
    fill: "black"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M348.629 100.638L349.558 98.7523L347.556 97.7652L346.626 99.6506L348.629 100.638Z",
    fill: "black"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M457.806 161.26L458.822 159.199L456.633 158.121L455.617 160.181L457.806 161.26Z",
    fill: "black"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M452.074 158.435L453.089 156.374L450.9 155.295L449.885 157.356L452.074 158.435Z",
    fill: "black"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M446.341 155.61L447.356 153.549L445.168 152.47L444.152 154.531L446.341 155.61Z",
    fill: "black"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M440.608 152.784L441.624 150.724L439.435 149.645L438.419 151.706L440.608 152.784Z",
    fill: "black"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M434.876 149.959L435.891 147.898L433.702 146.82L432.687 148.88L434.876 149.959Z",
    fill: "black"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M429.143 147.134L430.158 145.073L427.97 143.995L426.954 146.055L429.143 147.134Z",
    fill: "black"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M423.41 144.309L424.426 142.248L422.237 141.169L421.221 143.23L423.41 144.309Z",
    fill: "black"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M417.678 141.483L418.693 139.423L416.504 138.344L415.489 140.405L417.678 141.483Z",
    fill: "black"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M411.945 138.658L412.961 136.598L410.772 135.519L409.756 137.579L411.945 138.658Z",
    fill: "black"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M406.212 135.833L407.228 133.772L405.039 132.694L404.024 134.754L406.212 135.833Z",
    fill: "black"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M400.48 133.008L401.495 130.947L399.306 129.868L398.291 131.929L400.48 133.008Z",
    fill: "black"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M394.747 130.182L395.763 128.122L393.574 127.043L392.558 129.104L394.747 130.182Z",
    fill: "black"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M389.014 127.357L390.03 125.297L387.841 124.218L386.826 126.278L389.014 127.357Z",
    fill: "black"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M383.282 124.532L384.297 122.471L382.108 121.393L381.093 123.453L383.282 124.532Z",
    fill: "black"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M377.549 121.707L378.565 119.646L376.376 118.567L375.36 120.628L377.549 121.707Z",
    fill: "black"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M371.816 118.881L372.832 116.821L370.643 115.742L369.628 117.803L371.816 118.881Z",
    fill: "black"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M366.084 116.056L367.099 113.996L364.91 112.917L363.895 114.977L366.084 116.056Z",
    fill: "black"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M360.351 113.231L361.367 111.17L359.178 110.092L358.162 112.152L360.351 113.231Z",
    fill: "black"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M354.618 110.406L355.634 108.345L353.445 107.266L352.43 109.327L354.618 110.406Z",
    fill: "black"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M348.886 107.58L349.901 105.52L347.712 104.441L346.697 106.502L348.886 107.58Z",
    fill: "black"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M343.153 104.755L344.169 102.695L341.98 101.616L340.964 103.676L343.153 104.755Z",
    fill: "black"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M458.063 168.203L459.165 165.967L456.79 164.797L455.688 167.032L458.063 168.203Z",
    fill: "black"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M452.33 165.378L453.432 163.142L451.057 161.971L449.955 164.207L452.33 165.378Z",
    fill: "black"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M446.597 162.552L447.699 160.317L445.324 159.146L444.223 161.382L446.597 162.552Z",
    fill: "black"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M440.865 159.727L441.967 157.491L439.592 156.321L438.49 158.557L440.865 159.727Z",
    fill: "black"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M435.132 156.902L436.234 154.666L433.859 153.496L432.757 155.731L435.132 156.902Z",
    fill: "black"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M429.399 154.077L430.501 151.841L428.126 150.67L427.025 152.906L429.399 154.077Z",
    fill: "black"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M423.667 151.251L424.769 149.016L422.394 147.845L421.292 150.081L423.667 151.251Z",
    fill: "black"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M417.934 148.426L419.036 146.19L416.661 145.02L415.559 147.256L417.934 148.426Z",
    fill: "black"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M412.201 145.601L413.303 143.365L410.928 142.195L409.827 144.43L412.201 145.601Z",
    fill: "black"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M406.469 142.776L407.571 140.54L405.196 139.369L404.094 141.605L406.469 142.776Z",
    fill: "black"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M400.736 139.95L401.838 137.715L399.463 136.544L398.361 138.78L400.736 139.95Z",
    fill: "black"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M395.004 137.125L396.105 134.889L393.73 133.719L392.629 135.955L395.004 137.125Z",
    fill: "black"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M389.271 134.3L390.373 132.064L387.998 130.894L386.896 133.129L389.271 134.3Z",
    fill: "black"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M383.538 131.475L384.64 129.239L382.265 128.069L381.163 130.304L383.538 131.475Z",
    fill: "black"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M377.806 128.649L378.907 126.414L376.533 125.243L375.431 127.479L377.806 128.649Z",
    fill: "black"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M372.073 125.824L373.175 123.588L370.8 122.418L369.698 124.654L372.073 125.824Z",
    fill: "black"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M366.34 122.999L367.442 120.763L365.067 119.593L363.965 121.829L366.34 122.999Z",
    fill: "black"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M360.608 120.174L361.709 117.938L359.335 116.768L358.233 119.003L360.608 120.174Z",
    fill: "black"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M354.875 117.348L355.977 115.113L353.602 113.942L352.5 116.178L354.875 117.348Z",
    fill: "black"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M349.142 114.523L350.244 112.287L347.869 111.117L346.767 113.353L349.142 114.523Z",
    fill: "black"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M343.41 111.698L344.511 109.462L342.137 108.292L341.035 110.528L343.41 111.698Z",
    fill: "black"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M452.584 172.312L453.767 169.912L451.217 168.655L450.034 171.056L452.584 172.312Z",
    fill: "black"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M446.851 169.487L448.034 167.087L445.484 165.83L444.301 168.231L446.851 169.487Z",
    fill: "black"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M441.118 166.662L442.301 164.261L439.751 163.005L438.568 165.405L441.118 166.662Z",
    fill: "black"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M435.386 163.837L436.569 161.436L434.019 160.179L432.836 162.58L435.386 163.837Z",
    fill: "black"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M429.653 161.012L430.836 158.611L428.286 157.354L427.103 159.755L429.653 161.012Z",
    fill: "black"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M423.92 158.186L425.103 155.786L422.553 154.529L421.37 156.93L423.92 158.186Z",
    fill: "black"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M418.188 155.361L419.371 152.96L416.821 151.704L415.638 154.104L418.188 155.361Z",
    fill: "black"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M412.455 152.536L413.638 150.135L411.088 148.878L409.905 151.279L412.455 152.536Z",
    fill: "black"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M406.722 149.711L407.905 147.31L405.356 146.053L404.172 148.454L406.722 149.711Z",
    fill: "black"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M400.99 146.885L402.173 144.485L399.623 143.228L398.44 145.629L400.99 146.885Z",
    fill: "black"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M395.257 144.06L396.44 141.659L393.89 140.403L392.707 142.803L395.257 144.06Z",
    fill: "black"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M389.524 141.235L390.708 138.834L388.158 137.578L386.974 139.978L389.524 141.235Z",
    fill: "black"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M383.792 138.41L384.975 136.009L382.425 134.752L381.242 137.153L383.792 138.41Z",
    fill: "black"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M378.059 135.584L379.242 133.184L376.692 131.927L375.509 134.328L378.059 135.584Z",
    fill: "black"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M372.326 132.759L373.51 130.359L370.96 129.102L369.776 131.502L372.326 132.759Z",
    fill: "black"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M366.594 129.934L367.777 127.533L365.227 126.277L364.044 128.677L366.594 129.934Z",
    fill: "black"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M360.861 127.109L362.044 124.708L359.494 123.451L358.311 125.852L360.861 127.109Z",
    fill: "black"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M355.129 124.283L356.312 121.883L353.762 120.626L352.579 123.027L355.129 124.283Z",
    fill: "black"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M349.396 121.458L350.579 119.058L348.029 117.801L346.846 120.201L349.396 121.458Z",
    fill: "black"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M343.663 118.633L344.846 116.232L342.296 114.976L341.113 117.376L343.663 118.633Z",
    fill: "black"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M337.931 115.808L339.114 113.407L336.564 112.15L335.381 114.551L337.931 115.808Z",
    fill: "black"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M452.84 179.255L454.11 176.68L451.374 175.331L450.104 177.907L452.84 179.255Z",
    fill: "black"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M447.108 176.43L448.377 173.854L445.641 172.506L444.371 175.082L447.108 176.43Z",
    fill: "black"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M441.375 173.605L442.644 171.029L439.908 169.681L438.639 172.256L441.375 173.605Z",
    fill: "black"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M435.642 170.78L436.912 168.204L434.176 166.855L432.906 169.431L435.642 170.78Z",
    fill: "black"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M429.91 167.954L431.179 165.379L428.443 164.03L427.174 166.606L429.91 167.954Z",
    fill: "black"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M424.177 165.129L425.446 162.553L422.71 161.205L421.441 163.781L424.177 165.129Z",
    fill: "black"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M418.444 162.304L419.714 159.728L416.978 158.38L415.708 160.955L418.444 162.304Z",
    fill: "black"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M412.712 159.479L413.981 156.903L411.245 155.554L409.976 158.13L412.712 159.479Z",
    fill: "black"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M406.979 156.653L408.248 154.078L405.512 152.729L404.243 155.305L406.979 156.653Z",
    fill: "black"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M401.246 153.828L402.516 151.252L399.78 149.904L398.51 152.48L401.246 153.828Z",
    fill: "black"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M395.514 151.003L396.783 148.427L394.047 147.079L392.778 149.654L395.514 151.003Z",
    fill: "black"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M389.781 148.178L391.05 145.602L388.314 144.253L387.045 146.829L389.781 148.178Z",
    fill: "black"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M384.048 145.352L385.318 142.777L382.582 141.428L381.312 144.004L384.048 145.352Z",
    fill: "black"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M378.316 142.527L379.585 139.951L376.849 138.603L375.58 141.179L378.316 142.527Z",
    fill: "black"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M372.583 139.702L373.852 137.126L371.116 135.778L369.847 138.353L372.583 139.702Z",
    fill: "black"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M366.85 136.877L368.12 134.301L365.384 132.952L364.114 135.528L366.85 136.877Z",
    fill: "black"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M361.118 134.051L362.387 131.476L359.651 130.127L358.382 132.703L361.118 134.051Z",
    fill: "black"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M355.385 131.226L356.654 128.65L353.918 127.302L352.649 129.878L355.385 131.226Z",
    fill: "black"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M349.652 128.401L350.922 125.825L348.186 124.477L346.916 127.052L349.652 128.401Z",
    fill: "black"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M343.92 125.576L345.189 123L342.453 121.652L341.184 124.227L343.92 125.576Z",
    fill: "black"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M338.187 122.75L339.456 120.175L336.72 118.826L335.451 121.402L338.187 122.75Z",
    fill: "black"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M447.364 183.373L448.72 180.622L445.798 179.182L444.442 181.933L447.364 183.373Z",
    fill: "black"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M441.631 180.548L442.987 177.797L440.065 176.357L438.709 179.107L441.631 180.548Z",
    fill: "black"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M435.899 177.722L437.254 174.971L434.332 173.531L432.977 176.282L435.899 177.722Z",
    fill: "black"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M430.166 174.897L431.522 172.146L428.6 170.706L427.244 173.457L430.166 174.897Z",
    fill: "black"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M424.433 172.072L425.789 169.321L422.867 167.881L421.511 170.632L424.433 172.072Z",
    fill: "black"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M418.701 169.247L420.056 166.496L417.134 165.056L415.779 167.806L418.701 169.247Z",
    fill: "black"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M412.968 166.421L414.324 163.67L411.402 162.23L410.046 164.981L412.968 166.421Z",
    fill: "black"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M407.235 163.596L408.591 160.845L405.669 159.405L404.313 162.156L407.235 163.596Z",
    fill: "black"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M401.503 160.771L402.858 158.02L399.936 156.58L398.581 159.331L401.503 160.771Z",
    fill: "black"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M395.77 157.946L397.126 155.195L394.204 153.755L392.848 156.505L395.77 157.946Z",
    fill: "black"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M390.037 155.12L391.393 152.369L388.471 150.929L387.115 153.68L390.037 155.12Z",
    fill: "black"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M384.305 152.295L385.661 149.544L382.738 148.104L381.383 150.855L384.305 152.295Z",
    fill: "black"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M378.572 149.47L379.928 146.719L377.006 145.279L375.65 148.03L378.572 149.47Z",
    fill: "black"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M372.84 146.645L374.195 143.894L371.273 142.454L369.917 145.205L372.84 146.645Z",
    fill: "black"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M367.107 143.819L368.463 141.069L365.54 139.628L364.185 142.379L367.107 143.819Z",
    fill: "black"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M361.374 140.994L362.73 138.243L359.808 136.803L358.452 139.554L361.374 140.994Z",
    fill: "black"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M355.642 138.169L356.997 135.418L354.075 133.978L352.719 136.729L355.642 138.169Z",
    fill: "black"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M349.909 135.344L351.265 132.593L348.343 131.153L346.987 133.904L349.909 135.344Z",
    fill: "black"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M344.176 132.518L345.532 129.768L342.61 128.327L341.254 131.078L344.176 132.518Z",
    fill: "black"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M338.444 129.693L339.799 126.942L336.877 125.502L335.521 128.253L338.444 129.693Z",
    fill: "black"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M332.711 126.868L334.067 124.117L331.145 122.677L329.789 125.428L332.711 126.868Z",
    fill: "black"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M447.618 190.308L449.055 187.392L445.957 185.866L444.52 188.781L447.618 190.308Z",
    fill: "black"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M441.885 187.482L443.322 184.567L440.225 183.04L438.788 185.956L441.885 187.482Z",
    fill: "black"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M436.152 184.657L437.589 181.741L434.492 180.215L433.055 183.131L436.152 184.657Z",
    fill: "black"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M430.42 181.832L431.857 178.916L428.759 177.39L427.322 180.306L430.42 181.832Z",
    fill: "black"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M424.687 179.007L426.124 176.091L423.027 174.565L421.59 177.48L424.687 179.007Z",
    fill: "black"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M418.954 176.181L420.391 173.266L417.294 171.739L415.857 174.655L418.954 176.181Z",
    fill: "black"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M413.222 173.356L414.659 170.441L411.561 168.914L410.124 171.83L413.222 173.356Z",
    fill: "black"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M407.489 170.531L408.926 167.615L405.829 166.089L404.392 169.005L407.489 170.531Z",
    fill: "black"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M401.756 167.706L403.193 164.79L400.096 163.264L398.659 166.179L401.756 167.706Z",
    fill: "black"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M396.024 164.88L397.461 161.965L394.363 160.438L392.927 163.354L396.024 164.88Z",
    fill: "black"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M390.291 162.055L391.728 159.14L388.631 157.613L387.194 160.529L390.291 162.055Z",
    fill: "black"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M384.558 159.23L385.995 156.314L382.898 154.788L381.461 157.704L384.558 159.23Z",
    fill: "black"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M378.826 156.405L380.263 153.489L377.166 151.963L375.729 154.878L378.826 156.405Z",
    fill: "black"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M373.093 153.58L374.53 150.664L371.433 149.137L369.996 152.053L373.093 153.58Z",
    fill: "black"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M367.36 150.754L368.797 147.839L365.7 146.312L364.263 149.228L367.36 150.754Z",
    fill: "black"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M361.628 147.929L363.065 145.013L359.968 143.487L358.531 146.403L361.628 147.929Z",
    fill: "black"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M355.895 145.104L357.332 142.188L354.235 140.662L352.798 143.577L355.895 145.104Z",
    fill: "black"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M350.162 142.279L351.599 139.363L348.502 137.836L347.065 140.752L350.162 142.279Z",
    fill: "black"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M344.43 139.453L345.867 136.538L342.77 135.011L341.333 137.927L344.43 139.453Z",
    fill: "black"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M338.697 136.628L340.134 133.712L337.037 132.186L335.6 135.102L338.697 136.628Z",
    fill: "black"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M332.965 133.803L334.401 130.887L331.304 129.361L329.867 132.276L332.965 133.803Z",
    fill: "black"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M442.141 194.425L443.665 191.334L440.382 189.716L438.858 192.807L442.141 194.425Z",
    fill: "black"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M436.409 191.6L437.932 188.509L434.649 186.891L433.126 189.982L436.409 191.6Z",
    fill: "black"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M430.676 188.775L432.199 185.684L428.916 184.066L427.393 187.157L430.676 188.775Z",
    fill: "black"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M424.944 185.949L426.467 182.859L423.184 181.241L421.66 184.331L424.944 185.949Z",
    fill: "black"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M419.211 183.124L420.734 180.033L417.451 178.415L415.928 181.506L419.211 183.124Z",
    fill: "black"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M413.478 180.299L415.001 177.208L411.718 175.59L410.195 178.681L413.478 180.299Z",
    fill: "black"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M407.746 177.474L409.269 174.383L405.986 172.765L404.462 175.856L407.746 177.474Z",
    fill: "black"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M402.013 174.648L403.536 171.558L400.253 169.94L398.73 173.03L402.013 174.648Z",
    fill: "black"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M396.28 171.823L397.804 168.732L394.52 167.114L392.997 170.205L396.28 171.823Z",
    fill: "black"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M390.548 168.998L392.071 165.907L388.788 164.289L387.264 167.38L390.548 168.998Z",
    fill: "black"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M384.815 166.173L386.338 163.082L383.055 161.464L381.532 164.555L384.815 166.173Z",
    fill: "black"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M379.082 163.348L380.606 160.257L377.322 158.639L375.799 161.729L379.082 163.348Z",
    fill: "black"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M373.35 160.522L374.873 157.431L371.59 155.813L370.066 158.904L373.35 160.522Z",
    fill: "black"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M367.617 157.697L369.14 154.606L365.857 152.988L364.334 156.079L367.617 157.697Z",
    fill: "black"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M361.884 154.872L363.408 151.781L360.124 150.163L358.601 153.254L361.884 154.872Z",
    fill: "black"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M356.152 152.047L357.675 148.956L354.392 147.338L352.868 150.428L356.152 152.047Z",
    fill: "black"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M350.419 149.221L351.942 146.13L348.659 144.512L347.136 147.603L350.419 149.221Z",
    fill: "black"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M344.686 146.396L346.21 143.305L342.926 141.687L341.403 144.778L344.686 146.396Z",
    fill: "black"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M338.954 143.571L340.477 140.48L337.194 138.862L335.67 141.953L338.954 143.571Z",
    fill: "black"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M333.221 140.746L334.744 137.655L331.461 136.037L329.938 139.127L333.221 140.746Z",
    fill: "black"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M327.488 137.92L329.012 134.829L325.728 133.211L324.205 136.302L327.488 137.92Z",
    fill: "black"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M442.398 201.368L444.008 198.102L440.538 196.392L438.929 199.658L442.398 201.368Z",
    fill: "black"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M436.665 198.543L438.275 195.277L434.806 193.567L433.196 196.833L436.665 198.543Z",
    fill: "black"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M430.933 195.717L432.542 192.451L429.073 190.742L427.463 194.008L430.933 195.717Z",
    fill: "black"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M425.2 192.892L426.81 189.626L423.34 187.916L421.731 191.182L425.2 192.892Z",
    fill: "black"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M419.467 190.067L421.077 186.801L417.608 185.091L415.998 188.357L419.467 190.067Z",
    fill: "black"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M413.735 187.242L415.344 183.976L411.875 182.266L410.265 185.532L413.735 187.242Z",
    fill: "black"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M408.002 184.416L409.612 181.151L406.142 179.441L404.533 182.707L408.002 184.416Z",
    fill: "black"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M402.269 181.591L403.879 178.325L400.41 176.615L398.8 179.881L402.269 181.591Z",
    fill: "black"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M396.537 178.766L398.146 175.5L394.677 173.79L393.067 177.056L396.537 178.766Z",
    fill: "black"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M390.804 175.941L392.414 172.675L388.944 170.965L387.335 174.231L390.804 175.941Z",
    fill: "black"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M385.071 173.116L386.681 169.85L383.212 168.14L381.602 171.406L385.071 173.116Z",
    fill: "black"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M379.339 170.29L380.948 167.024L377.479 165.315L375.869 168.581L379.339 170.29Z",
    fill: "black"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M373.606 167.465L375.216 164.199L371.746 162.489L370.137 165.755L373.606 167.465Z",
    fill: "black"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M367.873 164.64L369.483 161.374L366.014 159.664L364.404 162.93L367.873 164.64Z",
    fill: "black"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M362.141 161.815L363.75 158.549L360.281 156.839L358.671 160.105L362.141 161.815Z",
    fill: "black"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M356.408 158.989L358.018 155.723L354.548 154.014L352.939 157.28L356.408 158.989Z",
    fill: "black"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M350.675 156.164L352.285 152.898L348.816 151.188L347.206 154.454L350.675 156.164Z",
    fill: "black"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M344.943 153.339L346.552 150.073L343.083 148.363L341.474 151.629L344.943 153.339Z",
    fill: "black"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M339.21 150.514L340.82 147.248L337.35 145.538L335.741 148.804L339.21 150.514Z",
    fill: "black"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M333.478 147.688L335.087 144.422L331.618 142.713L330.008 145.979L333.478 147.688Z",
    fill: "black"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M327.745 144.863L329.354 141.597L325.885 139.887L324.276 143.153L327.745 144.863Z",
    fill: "black"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M436.919 205.478L438.61 202.047L434.965 200.251L433.274 203.682L436.919 205.478Z",
    fill: "black"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M431.186 202.652L432.877 199.222L429.233 197.425L427.542 200.856L431.186 202.652Z",
    fill: "black"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M425.454 199.827L427.144 196.396L423.5 194.6L421.809 198.031L425.454 199.827Z",
    fill: "black"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M419.721 197.002L421.412 193.571L417.767 191.775L416.077 195.206L419.721 197.002Z",
    fill: "black"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M413.988 194.177L415.679 190.746L412.035 188.95L410.344 192.381L413.988 194.177Z",
    fill: "black"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M408.256 191.351L409.946 187.921L406.302 186.124L404.611 189.555L408.256 191.351Z",
    fill: "black"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M402.523 188.526L404.214 185.095L400.569 183.299L398.879 186.73L402.523 188.526Z",
    fill: "black"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M396.79 185.701L398.481 182.27L394.837 180.474L393.146 183.905L396.79 185.701Z",
    fill: "black"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M391.058 182.876L392.748 179.445L389.104 177.649L387.413 181.08L391.058 182.876Z",
    fill: "black"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M385.325 180.05L387.016 176.62L383.371 174.824L381.681 178.254L385.325 180.05Z",
    fill: "black"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M379.592 177.225L381.283 173.794L377.639 171.998L375.948 175.429L379.592 177.225Z",
    fill: "black"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M373.86 174.4L375.551 170.969L371.906 169.173L370.215 172.604L373.86 174.4Z",
    fill: "black"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M368.127 171.575L369.818 168.144L366.173 166.348L364.483 169.779L368.127 171.575Z",
    fill: "black"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M362.394 168.749L364.085 165.319L360.441 163.523L358.75 166.953L362.394 168.749Z",
    fill: "black"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M356.662 165.924L358.353 162.493L354.708 160.697L353.017 164.128L356.662 165.924Z",
    fill: "black"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M350.929 163.099L352.62 159.668L348.975 157.872L347.285 161.303L350.929 163.099Z",
    fill: "black"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M345.196 160.274L346.887 156.843L343.243 155.047L341.552 158.478L345.196 160.274Z",
    fill: "black"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M339.464 157.449L341.155 154.018L337.51 152.222L335.819 155.652L339.464 157.449Z",
    fill: "black"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M333.731 154.623L335.422 151.192L331.778 149.396L330.087 152.827L333.731 154.623Z",
    fill: "black"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M327.998 151.798L329.689 148.367L326.045 146.571L324.354 150.002L327.998 151.798Z",
    fill: "black"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M322.266 148.973L323.957 145.542L320.312 143.746L318.621 147.177L322.266 148.973Z",
    fill: "black"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M437.175 212.42L438.953 208.814L435.122 206.927L433.345 210.533L437.175 212.42Z",
    fill: "black"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M431.443 209.595L433.22 205.989L429.389 204.101L427.612 207.707L431.443 209.595Z",
    fill: "black"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M425.71 206.77L427.487 203.164L423.657 201.276L421.88 204.882L425.71 206.77Z",
    fill: "black"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M419.977 203.945L421.755 200.339L417.924 198.451L416.147 202.057L419.977 203.945Z",
    fill: "black"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M414.245 201.119L416.022 197.513L412.191 195.626L410.414 199.232L414.245 201.119Z",
    fill: "black"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M408.512 198.294L410.289 194.688L406.459 192.8L404.682 196.406L408.512 198.294Z",
    fill: "black"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M402.779 195.469L404.557 191.863L400.726 189.975L398.949 193.581L402.779 195.469Z",
    fill: "black"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M397.047 192.644L398.824 189.038L394.994 187.15L393.216 190.756L397.047 192.644Z",
    fill: "black"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M391.314 189.818L393.091 186.212L389.261 184.325L387.484 187.931L391.314 189.818Z",
    fill: "black"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M385.582 186.993L387.359 183.387L383.528 181.499L381.751 185.105L385.582 186.993Z",
    fill: "black"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M379.849 184.168L381.626 180.562L377.796 178.674L376.018 182.28L379.849 184.168Z",
    fill: "black"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M374.116 181.343L375.893 177.737L372.063 175.849L370.286 179.455L374.116 181.343Z",
    fill: "black"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M368.384 178.517L370.161 174.911L366.33 173.024L364.553 176.63L368.384 178.517Z",
    fill: "black"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M362.651 175.692L364.428 172.086L360.598 170.198L358.82 173.804L362.651 175.692Z",
    fill: "black"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M356.918 172.867L358.695 169.261L354.865 167.373L353.088 170.979L356.918 172.867Z",
    fill: "black"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M351.186 170.042L352.963 166.436L349.132 164.548L347.355 168.154L351.186 170.042Z",
    fill: "black"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M345.453 167.217L347.23 163.611L343.4 161.723L341.622 165.329L345.453 167.217Z",
    fill: "black"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M339.72 164.391L341.497 160.785L337.667 158.898L335.89 162.503L339.72 164.391Z",
    fill: "black"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M333.988 161.566L335.765 157.96L331.934 156.072L330.157 159.678L333.988 161.566Z",
    fill: "black"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M328.255 158.741L330.032 155.135L326.202 153.247L324.424 156.853L328.255 158.741Z",
    fill: "black"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M322.522 155.916L324.299 152.31L320.469 150.422L318.692 154.028L322.522 155.916Z",
    fill: "black"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M431.699 216.538L433.563 212.757L429.546 210.777L427.683 214.558L431.699 216.538Z",
    fill: "black"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M425.967 213.713L427.83 209.932L423.814 207.952L421.95 211.733L425.967 213.713Z",
    fill: "black"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M420.234 210.887L422.097 207.106L418.081 205.127L416.217 208.908L420.234 210.887Z",
    fill: "black"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M414.501 208.062L416.365 204.281L412.348 202.302L410.485 206.083L414.501 208.062Z",
    fill: "black"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M408.769 205.237L410.632 201.456L406.616 199.476L404.752 203.257L408.769 205.237Z",
    fill: "black"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M403.036 202.412L404.899 198.631L400.883 196.651L399.019 200.432L403.036 202.412Z",
    fill: "black"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M397.303 199.586L399.167 195.805L395.15 193.826L393.287 197.607L397.303 199.586Z",
    fill: "black"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M391.571 196.761L393.434 192.98L389.418 191.001L387.554 194.782L391.571 196.761Z",
    fill: "black"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M385.838 193.936L387.701 190.155L383.685 188.175L381.822 191.957L385.838 193.936Z",
    fill: "black"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M380.105 191.111L381.969 187.33L377.952 185.35L376.089 189.131L380.105 191.111Z",
    fill: "black"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M374.373 188.285L376.236 184.504L372.22 182.525L370.356 186.306L374.373 188.285Z",
    fill: "black"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M368.64 185.46L370.504 181.679L366.487 179.7L364.624 183.481L368.64 185.46Z",
    fill: "black"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M362.907 182.635L364.771 178.854L360.754 176.874L358.891 180.656L362.907 182.635Z",
    fill: "black"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M357.175 179.81L359.038 176.029L355.022 174.049L353.158 177.83L357.175 179.81Z",
    fill: "black"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M351.442 176.985L353.306 173.203L349.289 171.224L347.426 175.005L351.442 176.985Z",
    fill: "black"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M345.709 174.159L347.573 170.378L343.556 168.399L341.693 172.18L345.709 174.159Z",
    fill: "black"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M339.977 171.334L341.84 167.553L337.824 165.573L335.96 169.355L339.977 171.334Z",
    fill: "black"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M334.244 168.509L336.108 164.728L332.091 162.748L330.228 166.529L334.244 168.509Z",
    fill: "black"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M328.511 165.684L330.375 161.902L326.358 159.923L324.495 163.704L328.511 165.684Z",
    fill: "black"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M322.779 162.858L324.642 159.077L320.626 157.098L318.762 160.879L322.779 162.858Z",
    fill: "black"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M317.046 160.033L318.91 156.252L314.893 154.272L313.03 158.054L317.046 160.033Z",
    fill: "black"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M431.953 223.473L433.898 219.527L429.706 217.461L427.761 221.407L431.953 223.473Z",
    fill: "black"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M426.22 220.648L428.165 216.702L423.973 214.636L422.029 218.582L426.22 220.648Z",
    fill: "black"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M420.488 217.822L422.432 213.876L418.241 211.811L416.296 215.757L420.488 217.822Z",
    fill: "black"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M414.755 214.997L416.7 211.051L412.508 208.985L410.563 212.931L414.755 214.997Z",
    fill: "black"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M409.022 212.172L410.967 208.226L406.775 206.16L404.831 210.106L409.022 212.172Z",
    fill: "black"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M403.29 209.347L405.234 205.401L401.043 203.335L399.098 207.281L403.29 209.347Z",
    fill: "black"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M397.557 206.521L399.502 202.575L395.31 200.51L393.365 204.456L397.557 206.521Z",
    fill: "black"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M391.824 203.696L393.769 199.75L389.577 197.684L387.633 201.63L391.824 203.696Z",
    fill: "black"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M386.092 200.871L388.036 196.925L383.845 194.859L381.9 198.805L386.092 200.871Z",
    fill: "black"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M380.359 198.046L382.304 194.1L378.112 192.034L376.167 195.98L380.359 198.046Z",
    fill: "black"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M374.626 195.22L376.571 191.274L372.379 189.209L370.435 193.155L374.626 195.22Z",
    fill: "black"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M368.894 192.395L370.838 188.449L366.647 186.383L364.702 190.329L368.894 192.395Z",
    fill: "black"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M363.161 189.57L365.106 185.624L360.914 183.558L358.969 187.504L363.161 189.57Z",
    fill: "black"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M357.428 186.745L359.373 182.799L355.181 180.733L353.237 184.679L357.428 186.745Z",
    fill: "black"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M351.696 183.919L353.64 179.973L349.449 177.908L347.504 181.854L351.696 183.919Z",
    fill: "black"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M345.963 181.094L347.908 177.148L343.716 175.082L341.771 179.028L345.963 181.094Z",
    fill: "black"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M340.23 178.269L342.175 174.323L337.983 172.257L336.039 176.203L340.23 178.269Z",
    fill: "black"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M334.498 175.444L336.442 171.498L332.251 169.432L330.306 173.378L334.498 175.444Z",
    fill: "black"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M328.765 172.618L330.71 168.672L326.518 166.607L324.573 170.553L328.765 172.618Z",
    fill: "black"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M323.032 169.793L324.977 165.847L320.785 163.781L318.841 167.727L323.032 169.793Z",
    fill: "black"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M317.3 166.968L319.244 163.022L315.053 160.956L313.108 164.902L317.3 166.968Z",
    fill: "black"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M426.477 227.59L428.508 223.469L424.13 221.312L422.099 225.433L426.477 227.59Z",
    fill: "black"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M420.744 224.765L422.775 220.644L418.397 218.487L416.366 222.608L420.744 224.765Z",
    fill: "black"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M415.011 221.94L417.042 217.819L412.665 215.661L410.634 219.782L415.011 221.94Z",
    fill: "black"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M409.279 219.115L411.31 214.993L406.932 212.836L404.901 216.957L409.279 219.115Z",
    fill: "black"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M403.546 216.289L405.577 212.168L401.199 210.011L399.168 214.132L403.546 216.289Z",
    fill: "black"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M397.813 213.464L399.844 209.343L395.467 207.186L393.436 211.307L397.813 213.464Z",
    fill: "black"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M392.081 210.639L394.112 206.518L389.734 204.36L387.703 208.481L392.081 210.639Z",
    fill: "black"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M386.348 207.814L388.379 203.693L384.001 201.535L381.97 205.656L386.348 207.814Z",
    fill: "black"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M380.615 204.988L382.646 200.867L378.269 198.71L376.238 202.831L380.615 204.988Z",
    fill: "black"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M374.883 202.163L376.914 198.042L372.536 195.885L370.505 200.006L374.883 202.163Z",
    fill: "black"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M369.15 199.338L371.181 195.217L366.804 193.059L364.772 197.18L369.15 199.338Z",
    fill: "black"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M363.417 196.513L365.449 192.392L361.071 190.234L359.04 194.355L363.417 196.513Z",
    fill: "black"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M357.685 193.687L359.716 189.566L355.338 187.409L353.307 191.53L357.685 193.687Z",
    fill: "black"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M351.952 190.862L353.983 186.741L349.606 184.584L347.575 188.705L351.952 190.862Z",
    fill: "black"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M346.22 188.037L348.251 183.916L343.873 181.758L341.842 185.879L346.22 188.037Z",
    fill: "black"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M340.487 185.212L342.518 181.091L338.14 178.933L336.109 183.054L340.487 185.212Z",
    fill: "black"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M334.754 182.386L336.785 178.265L332.408 176.108L330.377 180.229L334.754 182.386Z",
    fill: "black"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M329.022 179.561L331.053 175.44L326.675 173.283L324.644 177.404L329.022 179.561Z",
    fill: "black"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M323.289 176.736L325.32 172.615L320.942 170.457L318.911 174.579L323.289 176.736Z",
    fill: "black"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M317.556 173.911L319.587 169.79L315.21 167.632L313.179 171.753L317.556 173.911Z",
    fill: "black"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M311.824 171.086L313.855 166.964L309.477 164.807L307.446 168.928L311.824 171.086Z",
    fill: "black"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M594.92 103.143L595.26 102.453L594.527 102.091L594.186 102.782L594.92 103.143Z",
    fill: "black"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M589.187 100.318L589.527 99.6274L588.794 99.266L588.454 99.9563L589.187 100.318Z",
    fill: "black"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M583.454 97.4924L583.795 96.8022L583.061 96.4408L582.721 97.1311L583.454 97.4924Z",
    fill: "black"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M577.722 94.6672L578.062 93.9769L577.329 93.6155L576.988 94.3058L577.722 94.6672Z",
    fill: "black"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M571.989 91.842L572.329 91.1517L571.596 90.7903L571.256 91.4806L571.989 91.842Z",
    fill: "black"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M566.256 89.0167L566.597 88.3264L565.863 87.9651L565.523 88.6553L566.256 89.0167Z",
    fill: "black"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M560.524 86.1915L560.864 85.5012L560.131 85.1398L559.79 85.8301L560.524 86.1915Z",
    fill: "black"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M554.791 83.3662L555.131 82.6759L554.398 82.3146L554.058 83.0049L554.791 83.3662Z",
    fill: "black"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M549.058 80.541L549.399 79.8507L548.665 79.4893L548.325 80.1796L549.058 80.541Z",
    fill: "black"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M543.326 77.7157L543.666 77.0255L542.933 76.6641L542.593 77.3544L543.326 77.7157Z",
    fill: "black"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M537.593 74.8905L537.933 74.2002L537.2 73.8388L536.86 74.5291L537.593 74.8905Z",
    fill: "black"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M531.86 72.0653L532.201 71.375L531.467 71.0136L531.127 71.7039L531.86 72.0653Z",
    fill: "black"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M526.128 69.24L526.468 68.5497L525.735 68.1884L525.395 68.8786L526.128 69.24Z",
    fill: "black"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M520.395 66.4148L520.735 65.7245L520.002 65.3631L519.662 66.0534L520.395 66.4148Z",
    fill: "black"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M514.662 63.5895L515.003 62.8993L514.269 62.5379L513.929 63.2282L514.662 63.5895Z",
    fill: "black"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M508.93 60.7643L509.27 60.074L508.537 59.7126L508.197 60.4029L508.93 60.7643Z",
    fill: "black"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M503.197 57.9391L503.537 57.2488L502.804 56.8874L502.464 57.5777L503.197 57.9391Z",
    fill: "black"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M497.465 55.1138L497.805 54.4235L497.071 54.0621L496.731 54.7524L497.465 55.1138Z",
    fill: "black"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M491.732 52.2886L492.072 51.5983L491.339 51.2369L490.999 51.9272L491.732 52.2886Z",
    fill: "black"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M595.173 110.078L595.595 109.223L594.686 108.775L594.265 109.63L595.173 110.078Z",
    fill: "black"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M589.441 107.253L589.862 106.397L588.954 105.95L588.532 106.805L589.441 107.253Z",
    fill: "black"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M583.708 104.427L584.129 103.572L583.221 103.125L582.8 103.98L583.708 104.427Z",
    fill: "black"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M577.975 101.602L578.397 100.747L577.488 100.299L577.067 101.154L577.975 101.602Z",
    fill: "black"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M572.243 98.7769L572.664 97.9217L571.756 97.4741L571.334 98.3292L572.243 98.7769Z",
    fill: "black"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M566.51 95.9516L566.931 95.0965L566.023 94.6488L565.602 95.504L566.51 95.9516Z",
    fill: "black"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M560.777 93.1264L561.199 92.2713L560.29 91.8236L559.869 92.6787L560.777 93.1264Z",
    fill: "black"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M555.045 90.3012L555.466 89.446L554.558 88.9983L554.136 89.8535L555.045 90.3012Z",
    fill: "black"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M549.312 87.4759L549.733 86.6208L548.825 86.1731L548.404 87.0282L549.312 87.4759Z",
    fill: "black"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M543.579 84.6507L544.001 83.7955L543.092 83.3479L542.671 84.203L543.579 84.6507Z",
    fill: "black"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M537.847 81.8254L538.268 80.9703L537.36 80.5226L536.938 81.3778L537.847 81.8254Z",
    fill: "black"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M532.114 79.0002L532.535 78.145L531.627 77.6974L531.206 78.5525L532.114 79.0002Z",
    fill: "black"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M526.381 76.1749L526.803 75.3198L525.894 74.8721L525.473 75.7273L526.381 76.1749Z",
    fill: "black"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M520.649 73.3497L521.07 72.4946L520.162 72.0469L519.74 72.902L520.649 73.3497Z",
    fill: "black"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M514.916 70.5245L515.338 69.6693L514.429 69.2216L514.008 70.0768L514.916 70.5245Z",
    fill: "black"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M509.183 67.6992L509.605 66.8441L508.696 66.3964L508.275 67.2515L509.183 67.6992Z",
    fill: "black"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M503.451 64.874L503.872 64.0188L502.964 63.5712L502.542 64.4263L503.451 64.874Z",
    fill: "black"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M497.718 62.0487L498.14 61.1936L497.231 60.7459L496.81 61.6011L497.718 62.0487Z",
    fill: "black"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M491.985 59.2235L492.407 58.3684L491.499 57.9207L491.077 58.7758L491.985 59.2235Z",
    fill: "black"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M595.43 117.021L595.938 115.99L594.843 115.451L594.335 116.481L595.43 117.021Z",
    fill: "black"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M589.697 114.195L590.205 113.165L589.11 112.626L588.603 113.656L589.697 114.195Z",
    fill: "black"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M583.964 111.37L584.472 110.34L583.378 109.8L582.87 110.831L583.964 111.37Z",
    fill: "black"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M578.232 108.545L578.74 107.515L577.645 106.975L577.137 108.006L578.232 108.545Z",
    fill: "black"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M572.499 105.72L573.007 104.689L571.912 104.15L571.405 105.18L572.499 105.72Z",
    fill: "black"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M566.766 102.894L567.274 101.864L566.18 101.325L565.672 102.355L566.766 102.894Z",
    fill: "black"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M561.034 100.069L561.542 99.0389L560.447 98.4995L559.939 99.5298L561.034 100.069Z",
    fill: "black"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M555.301 97.2439L555.809 96.2136L554.715 95.6743L554.207 96.7046L555.301 97.2439Z",
    fill: "black"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M549.569 94.4187L550.076 93.3884L548.982 92.849L548.474 93.8793L549.569 94.4187Z",
    fill: "black"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M543.836 91.5934L544.344 90.5631L543.249 90.0238L542.741 91.0541L543.836 91.5934Z",
    fill: "black"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M538.103 88.7682L538.611 87.7379L537.517 87.1985L537.009 88.2288L538.103 88.7682Z",
    fill: "black"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M532.371 85.9429L532.878 84.9127L531.784 84.3733L531.276 85.4036L532.371 85.9429Z",
    fill: "black"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M526.638 83.1177L527.146 82.0874L526.051 81.5481L525.543 82.5783L526.638 83.1177Z",
    fill: "black"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M520.905 80.2925L521.413 79.2622L520.319 78.7228L519.811 79.7531L520.905 80.2925Z",
    fill: "black"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M515.173 77.4672L515.68 76.4369L514.586 75.8976L514.078 76.9279L515.173 77.4672Z",
    fill: "black"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M509.44 74.642L509.948 73.6117L508.853 73.0723L508.346 74.1026L509.44 74.642Z",
    fill: "black"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M503.707 71.8167L504.215 70.7865L503.121 70.2471L502.613 71.2774L503.707 71.8167Z",
    fill: "black"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M497.975 68.9915L498.482 67.9612L497.388 67.4218L496.88 68.4521L497.975 68.9915Z",
    fill: "black"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M492.242 66.1663L492.75 65.136L491.655 64.5966L491.148 65.6269L492.242 66.1663Z",
    fill: "black"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M486.509 63.341L487.017 62.3107L485.923 61.7714L485.415 62.8016L486.509 63.341Z",
    fill: "black"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M595.686 123.963L596.28 122.758L595 122.127L594.406 123.332L595.686 123.963Z",
    fill: "black"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M589.954 121.138L590.548 119.933L589.267 119.302L588.673 120.507L589.954 121.138Z",
    fill: "black"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M584.221 118.313L584.815 117.107L583.535 116.476L582.94 117.682L584.221 118.313Z",
    fill: "black"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M578.488 115.488L579.082 114.282L577.802 113.651L577.208 114.857L578.488 115.488Z",
    fill: "black"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M572.756 112.662L573.35 111.457L572.069 110.826L571.475 112.031L572.756 112.662Z",
    fill: "black"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M567.023 109.837L567.617 108.632L566.337 108.001L565.743 109.206L567.023 109.837Z",
    fill: "black"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M561.29 107.012L561.884 105.806L560.604 105.175L560.01 106.381L561.29 107.012Z",
    fill: "black"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M555.558 104.187L556.152 102.981L554.871 102.35L554.277 103.556L555.558 104.187Z",
    fill: "black"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M549.825 101.361L550.419 100.156L549.139 99.5249L548.545 100.73L549.825 101.361Z",
    fill: "black"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M544.092 98.5362L544.686 97.3308L543.406 96.6997L542.812 97.9051L544.092 98.5362Z",
    fill: "black"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M538.36 95.7109L538.954 94.5055L537.673 93.8745L537.079 95.0799L538.36 95.7109Z",
    fill: "black"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M532.627 92.8857L533.221 91.6803L531.941 91.0492L531.347 92.2547L532.627 92.8857Z",
    fill: "black"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M526.894 90.0605L527.488 88.855L526.208 88.224L525.614 89.4294L526.894 90.0605Z",
    fill: "black"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M521.162 87.2352L521.756 86.0298L520.475 85.3987L519.881 86.6042L521.162 87.2352Z",
    fill: "black"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M515.429 84.41L516.023 83.2046L514.743 82.5735L514.149 83.7789L515.429 84.41Z",
    fill: "black"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M509.696 81.5847L510.291 80.3793L509.01 79.7483L508.416 80.9537L509.696 81.5847Z",
    fill: "black"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M503.964 78.7595L504.558 77.5541L503.277 76.923L502.683 78.1284L503.964 78.7595Z",
    fill: "black"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M498.231 75.9343L498.825 74.7288L497.545 74.0978L496.951 75.3032L498.231 75.9343Z",
    fill: "black"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M492.498 73.109L493.093 71.9036L491.812 71.2725L491.218 72.478L492.498 73.109Z",
    fill: "black"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M486.766 70.2838L487.36 69.0783L486.079 68.4473L485.485 69.6527L486.766 70.2838Z",
    fill: "black"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M595.94 130.898L596.615 129.528L595.16 128.811L594.484 130.181L595.94 130.898Z",
    fill: "black"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M590.207 128.073L590.883 126.703L589.427 125.985L588.752 127.356L590.207 128.073Z",
    fill: "black"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M584.475 125.248L585.15 123.878L583.694 123.16L583.019 124.53L584.475 125.248Z",
    fill: "black"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M578.742 122.423L579.417 121.052L577.962 120.335L577.286 121.705L578.742 122.423Z",
    fill: "black"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M573.009 119.597L573.685 118.227L572.229 117.51L571.554 118.88L573.009 119.597Z",
    fill: "black"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M567.277 116.772L567.952 115.402L566.496 114.684L565.821 116.055L567.277 116.772Z",
    fill: "black"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M561.544 113.947L562.219 112.577L560.764 111.859L560.088 113.229L561.544 113.947Z",
    fill: "black"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M555.811 111.122L556.487 109.751L555.031 109.034L554.356 110.404L555.811 111.122Z",
    fill: "black"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M550.079 108.296L550.754 106.926L549.298 106.209L548.623 107.579L550.079 108.296Z",
    fill: "black"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M544.346 105.471L545.021 104.101L543.566 103.383L542.89 104.754L544.346 105.471Z",
    fill: "black"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M538.613 102.646L539.289 101.276L537.833 100.558L537.158 101.929L538.613 102.646Z",
    fill: "black"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M532.881 99.8206L533.556 98.4503L532.1 97.733L531.425 99.1033L532.881 99.8206Z",
    fill: "black"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M527.148 96.9954L527.823 95.6251L526.368 94.9078L525.692 96.278L527.148 96.9954Z",
    fill: "black"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M521.415 94.1701L522.091 92.7999L520.635 92.0825L519.96 93.4528L521.415 94.1701Z",
    fill: "black"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M515.683 91.3449L516.358 89.9746L514.902 89.2573L514.227 90.6275L515.683 91.3449Z",
    fill: "black"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M509.95 88.5197L510.625 87.1494L509.17 86.432L508.494 87.8023L509.95 88.5197Z",
    fill: "black"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M504.217 85.6944L504.893 84.3241L503.437 83.6068L502.762 84.9771L504.217 85.6944Z",
    fill: "black"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M498.485 82.8692L499.16 81.4989L497.704 80.7815L497.029 82.1518L498.485 82.8692Z",
    fill: "black"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M492.752 80.0439L493.427 78.6737L491.972 77.9563L491.296 79.3266L492.752 80.0439Z",
    fill: "black"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M487.019 77.2187L487.695 75.8484L486.239 75.1311L485.564 76.5013L487.019 77.2187Z",
    fill: "black"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M481.287 74.3934L481.962 73.0232L480.506 72.3058L479.831 73.6761L481.287 74.3934Z",
    fill: "black"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M596.196 137.841L596.958 136.296L595.316 135.487L594.555 137.032L596.196 137.841Z",
    fill: "black"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M590.464 135.016L591.225 133.47L589.584 132.661L588.822 134.207L590.464 135.016Z",
    fill: "black"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M584.731 132.191L585.493 130.645L583.851 129.836L583.089 131.382L584.731 132.191Z",
    fill: "black"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M578.998 129.365L579.76 127.82L578.118 127.011L577.357 128.556L578.998 129.365Z",
    fill: "black"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M573.266 126.54L574.027 124.995L572.386 124.186L571.624 125.731L573.266 126.54Z",
    fill: "black"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M567.533 123.715L568.295 122.169L566.653 121.36L565.891 122.906L567.533 123.715Z",
    fill: "black"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M561.8 120.89L562.562 119.344L560.92 118.535L560.159 120.081L561.8 120.89Z",
    fill: "black"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M556.068 118.064L556.829 116.519L555.188 115.71L554.426 117.255L556.068 118.064Z",
    fill: "black"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M550.335 115.239L551.097 113.694L549.455 112.885L548.693 114.43L550.335 115.239Z",
    fill: "black"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M544.602 112.414L545.364 110.868L543.722 110.059L542.961 111.605L544.602 112.414Z",
    fill: "black"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M538.87 109.589L539.631 108.043L537.99 107.234L537.228 108.78L538.87 109.589Z",
    fill: "black"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M533.137 106.763L533.899 105.218L532.257 104.409L531.496 105.954L533.137 106.763Z",
    fill: "black"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M527.404 103.938L528.166 102.393L526.525 101.584L525.763 103.129L527.404 103.938Z",
    fill: "black"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M521.672 101.113L522.433 99.5675L520.792 98.7584L520.03 100.304L521.672 101.113Z",
    fill: "black"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M515.939 98.2877L516.701 96.7422L515.059 95.9332L514.298 97.4786L515.939 98.2877Z",
    fill: "black"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M510.207 95.4624L510.968 93.917L509.327 93.108L508.565 94.6534L510.207 95.4624Z",
    fill: "black"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M504.474 92.6372L505.235 91.0918L503.594 90.2827L502.832 91.8281L504.474 92.6372Z",
    fill: "black"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M498.741 89.8119L499.503 88.2665L497.861 87.4575L497.1 89.0029L498.741 89.8119Z",
    fill: "black"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M493.009 86.9867L493.77 85.4413L492.129 84.6322L491.367 86.1776L493.009 86.9867Z",
    fill: "black"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M487.276 84.1614L488.038 82.616L486.396 81.807L485.634 83.3524L487.276 84.1614Z",
    fill: "black"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M481.543 81.3362L482.305 79.7908L480.663 78.9817L479.902 80.5272L481.543 81.3362Z",
    fill: "black"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M590.72 141.959L591.568 140.238L589.74 139.337L588.893 141.058L590.72 141.959Z",
    fill: "black"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M584.988 139.133L585.836 137.413L584.008 136.512L583.16 138.233L584.988 139.133Z",
    fill: "black"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M579.255 136.308L580.103 134.588L578.275 133.687L577.427 135.407L579.255 136.308Z",
    fill: "black"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M573.522 133.483L574.37 131.762L572.543 130.862L571.695 132.582L573.522 133.483Z",
    fill: "black"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M567.79 130.658L568.638 128.937L566.81 128.036L565.962 129.757L567.79 130.658Z",
    fill: "black"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M562.057 127.832L562.905 126.112L561.077 125.211L560.229 126.932L562.057 127.832Z",
    fill: "black"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M556.324 125.007L557.172 123.287L555.345 122.386L554.497 124.106L556.324 125.007Z",
    fill: "black"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M550.592 122.182L551.44 120.461L549.612 119.561L548.764 121.281L550.592 122.182Z",
    fill: "black"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M544.859 119.357L545.707 117.636L543.879 116.735L543.031 118.456L544.859 119.357Z",
    fill: "black"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M539.126 116.531L539.974 114.811L538.147 113.91L537.299 115.631L539.126 116.531Z",
    fill: "black"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M533.394 113.706L534.242 111.986L532.414 111.085L531.566 112.805L533.394 113.706Z",
    fill: "black"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M527.661 110.881L528.509 109.16L526.681 108.26L525.833 109.98L527.661 110.881Z",
    fill: "black"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M521.928 108.056L522.776 106.335L520.949 105.434L520.101 107.155L521.928 108.056Z",
    fill: "black"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M516.196 105.23L517.044 103.51L515.216 102.609L514.368 104.33L516.196 105.23Z",
    fill: "black"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M510.463 102.405L511.311 100.685L509.483 99.7839L508.635 101.504L510.463 102.405Z",
    fill: "black"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M504.73 99.5799L505.578 97.8594L503.751 96.9586L502.903 98.6792L504.73 99.5799Z",
    fill: "black"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M498.998 96.7547L499.846 95.0341L498.018 94.1334L497.17 95.854L498.998 96.7547Z",
    fill: "black"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M493.265 93.9295L494.113 92.2089L492.285 91.3081L491.437 93.0287L493.265 93.9295Z",
    fill: "black"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M487.532 91.1042L488.38 89.3836L486.553 88.4829L485.705 90.2035L487.532 91.1042Z",
    fill: "black"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M481.8 88.279L482.648 86.5584L480.82 85.6577L479.972 87.3782L481.8 88.279Z",
    fill: "black"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M476.067 85.4537L476.915 83.7332L475.087 82.8324L474.239 84.553L476.067 85.4537Z",
    fill: "black"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M590.974 148.893L591.903 147.008L589.9 146.021L588.971 147.906L590.974 148.893Z",
    fill: "black"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M585.241 146.068L586.17 144.183L584.168 143.196L583.238 145.081L585.241 146.068Z",
    fill: "black"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M579.508 143.243L580.438 141.358L578.435 140.371L577.506 142.256L579.508 143.243Z",
    fill: "black"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M573.776 140.418L574.705 138.532L572.702 137.545L571.773 139.431L573.776 140.418Z",
    fill: "black"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M568.043 137.593L568.972 135.707L566.97 134.72L566.04 136.605L568.043 137.593Z",
    fill: "black"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M562.311 134.767L563.24 132.882L561.237 131.895L560.308 133.78L562.311 134.767Z",
    fill: "black"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M556.578 131.942L557.507 130.057L555.504 129.07L554.575 130.955L556.578 131.942Z",
    fill: "black"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M550.845 129.117L551.774 127.231L549.772 126.244L548.842 128.13L550.845 129.117Z",
    fill: "black"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M545.113 126.292L546.042 124.406L544.039 123.419L543.11 125.305L545.113 126.292Z",
    fill: "black"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M539.38 123.466L540.309 121.581L538.306 120.594L537.377 122.479L539.38 123.466Z",
    fill: "black"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M533.647 120.641L534.576 118.756L532.574 117.769L531.644 119.654L533.647 120.641Z",
    fill: "black"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M527.915 117.816L528.844 115.93L526.841 114.943L525.912 116.829L527.915 117.816Z",
    fill: "black"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M522.182 114.991L523.111 113.105L521.108 112.118L520.179 114.004L522.182 114.991Z",
    fill: "black"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M516.449 112.165L517.378 110.28L515.376 109.293L514.446 111.178L516.449 112.165Z",
    fill: "black"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M510.717 109.34L511.646 107.455L509.643 106.468L508.714 108.353L510.717 109.34Z",
    fill: "black"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M504.984 106.515L505.913 104.629L503.91 103.642L502.981 105.528L504.984 106.515Z",
    fill: "black"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M499.251 103.69L500.18 101.804L498.178 100.817L497.249 102.703L499.251 103.69Z",
    fill: "black"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M493.519 100.864L494.448 98.979L492.445 97.9919L491.516 99.8773L493.519 100.864Z",
    fill: "black"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M487.786 98.0391L488.715 96.1537L486.712 95.1667L485.783 97.0521L487.786 98.0391Z",
    fill: "black"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M482.053 95.2139L482.983 93.3285L480.98 92.3414L480.051 94.2269L482.053 95.2139Z",
    fill: "black"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M476.321 92.3886L477.25 90.5032L475.247 89.5162L474.318 91.4016L476.321 92.3886Z",
    fill: "black"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M585.498 153.011L586.513 150.95L584.324 149.872L583.309 151.932L585.498 153.011Z",
    fill: "black"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M579.765 150.186L580.781 148.125L578.592 147.046L577.576 149.107L579.765 150.186Z",
    fill: "black"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M574.032 147.361L575.048 145.3L572.859 144.221L571.844 146.282L574.032 147.361Z",
    fill: "black"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M568.3 144.535L569.315 142.475L567.126 141.396L566.111 143.457L568.3 144.535Z",
    fill: "black"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M562.567 141.71L563.583 139.649L561.394 138.571L560.378 140.631L562.567 141.71Z",
    fill: "black"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M556.834 138.885L557.85 136.824L555.661 135.746L554.646 137.806L556.834 138.885Z",
    fill: "black"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M551.102 136.06L552.117 133.999L549.928 132.92L548.913 134.981L551.102 136.06Z",
    fill: "black"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M545.369 133.234L546.385 131.174L544.196 130.095L543.18 132.156L545.369 133.234Z",
    fill: "black"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M539.636 130.409L540.652 128.349L538.463 127.27L537.448 129.33L539.636 130.409Z",
    fill: "black"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M533.904 127.584L534.919 125.523L532.73 124.445L531.715 126.505L533.904 127.584Z",
    fill: "black"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M528.171 124.759L529.187 122.698L526.998 121.619L525.982 123.68L528.171 124.759Z",
    fill: "black"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M522.438 121.933L523.454 119.873L521.265 118.794L520.25 120.855L522.438 121.933Z",
    fill: "black"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M516.706 119.108L517.721 117.048L515.532 115.969L514.517 118.029L516.706 119.108Z",
    fill: "black"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M510.973 116.283L511.989 114.222L509.8 113.144L508.784 115.204L510.973 116.283Z",
    fill: "black"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M505.24 113.458L506.256 111.397L504.067 110.318L503.052 112.379L505.24 113.458Z",
    fill: "black"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M499.508 110.632L500.523 108.572L498.334 107.493L497.319 109.554L499.508 110.632Z",
    fill: "black"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M493.775 107.807L494.791 105.747L492.602 104.668L491.586 106.728L493.775 107.807Z",
    fill: "black"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M488.042 104.982L489.058 102.921L486.869 101.843L485.854 103.903L488.042 104.982Z",
    fill: "black"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M482.31 102.157L483.325 100.096L481.137 99.0174L480.121 101.078L482.31 102.157Z",
    fill: "black"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M476.577 99.3314L477.593 97.2708L475.404 96.1921L474.388 98.2527L476.577 99.3314Z",
    fill: "black"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M470.845 96.5062L471.86 94.4456L469.671 93.3669L468.656 95.4274L470.845 96.5062Z",
    fill: "black"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M585.754 159.954L586.856 157.718L584.481 156.548L583.379 158.783L585.754 159.954Z",
    fill: "black"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M580.021 157.129L581.123 154.893L578.748 153.722L577.647 155.958L580.021 157.129Z",
    fill: "black"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M574.289 154.303L575.391 152.068L573.016 150.897L571.914 153.133L574.289 154.303Z",
    fill: "black"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M568.556 151.478L569.658 149.242L567.283 148.072L566.181 150.308L568.556 151.478Z",
    fill: "black"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M562.824 148.653L563.925 146.417L561.55 145.247L560.449 147.482L562.824 148.653Z",
    fill: "black"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M557.091 145.828L558.193 143.592L555.818 142.421L554.716 144.657L557.091 145.828Z",
    fill: "black"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M551.358 143.002L552.46 140.767L550.085 139.596L548.983 141.832L551.358 143.002Z",
    fill: "black"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M545.626 140.177L546.727 137.941L544.353 136.771L543.251 139.007L545.626 140.177Z",
    fill: "black"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M539.893 137.352L540.995 135.116L538.62 133.946L537.518 136.181L539.893 137.352Z",
    fill: "black"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M534.16 134.527L535.262 132.291L532.887 131.12L531.785 133.356L534.16 134.527Z",
    fill: "black"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M528.428 131.701L529.529 129.466L527.155 128.295L526.053 130.531L528.428 131.701Z",
    fill: "black"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M522.695 128.876L523.797 126.64L521.422 125.47L520.32 127.706L522.695 128.876Z",
    fill: "black"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M516.962 126.051L518.064 123.815L515.689 122.645L514.587 124.88L516.962 126.051Z",
    fill: "black"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M511.23 123.226L512.331 120.99L509.957 119.819L508.855 122.055L511.23 123.226Z",
    fill: "black"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M505.497 120.4L506.599 118.165L504.224 116.994L503.122 119.23L505.497 120.4Z",
    fill: "black"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M499.764 117.575L500.866 115.339L498.491 114.169L497.389 116.405L499.764 117.575Z",
    fill: "black"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M494.032 114.75L495.133 112.514L492.759 111.344L491.657 113.579L494.032 114.75Z",
    fill: "black"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M488.299 111.925L489.401 109.689L487.026 108.519L485.924 110.754L488.299 111.925Z",
    fill: "black"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M482.566 109.099L483.668 106.864L481.293 105.693L480.191 107.929L482.566 109.099Z",
    fill: "black"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M476.834 106.274L477.936 104.038L475.561 102.868L474.459 105.104L476.834 106.274Z",
    fill: "black"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M471.101 103.449L472.203 101.213L469.828 100.043L468.726 102.279L471.101 103.449Z",
    fill: "black"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M580.275 164.063L581.458 161.663L578.908 160.406L577.725 162.807L580.275 164.063Z",
    fill: "black"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M574.542 161.238L575.725 158.838L573.176 157.581L571.992 159.981L574.542 161.238Z",
    fill: "black"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M568.81 158.413L569.993 156.012L567.443 154.756L566.26 157.156L568.81 158.413Z",
    fill: "black"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M563.077 155.588L564.26 153.187L561.71 151.93L560.527 154.331L563.077 155.588Z",
    fill: "black"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M557.344 152.762L558.528 150.362L555.978 149.105L554.794 151.506L557.344 152.762Z",
    fill: "black"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M551.612 149.937L552.795 147.537L550.245 146.28L549.062 148.681L551.612 149.937Z",
    fill: "black"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M545.879 147.112L547.062 144.711L544.512 143.455L543.329 145.855L545.879 147.112Z",
    fill: "black"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M540.146 144.287L541.33 141.886L538.78 140.629L537.596 143.03L540.146 144.287Z",
    fill: "black"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M534.414 141.462L535.597 139.061L533.047 137.804L531.864 140.205L534.414 141.462Z",
    fill: "black"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M528.681 138.636L529.864 136.236L527.314 134.979L526.131 137.38L528.681 138.636Z",
    fill: "black"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M522.949 135.811L524.132 133.41L521.582 132.154L520.399 134.554L522.949 135.811Z",
    fill: "black"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M517.216 132.986L518.399 130.585L515.849 129.329L514.666 131.729L517.216 132.986Z",
    fill: "black"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M511.483 130.161L512.666 127.76L510.116 126.503L508.933 128.904L511.483 130.161Z",
    fill: "black"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M505.751 127.335L506.934 124.935L504.384 123.678L503.201 126.079L505.751 127.335Z",
    fill: "black"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M500.018 124.51L501.201 122.109L498.651 120.853L497.468 123.253L500.018 124.51Z",
    fill: "black"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M494.285 121.685L495.468 119.284L492.918 118.028L491.735 120.428L494.285 121.685Z",
    fill: "black"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M488.553 118.86L489.736 116.459L487.186 115.202L486.003 117.603L488.553 118.86Z",
    fill: "black"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M482.82 116.034L484.003 113.634L481.453 112.377L480.27 114.778L482.82 116.034Z",
    fill: "black"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M477.087 113.209L478.27 110.809L475.72 109.552L474.537 111.952L477.087 113.209Z",
    fill: "black"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M471.355 110.384L472.538 107.983L469.988 106.727L468.805 109.127L471.355 110.384Z",
    fill: "black"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M465.622 107.559L466.805 105.158L464.255 103.901L463.072 106.302L465.622 107.559Z",
    fill: "black"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M580.532 171.006L581.801 168.43L579.065 167.082L577.796 169.658L580.532 171.006Z",
    fill: "black"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M574.799 168.181L576.068 165.605L573.332 164.257L572.063 166.833L574.799 168.181Z",
    fill: "black"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M569.066 165.356L570.336 162.78L567.6 161.432L566.33 164.007L569.066 165.356Z",
    fill: "black"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M563.334 162.53L564.603 159.955L561.867 158.606L560.598 161.182L563.334 162.53Z",
    fill: "black"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M557.601 159.705L558.87 157.13L556.134 155.781L554.865 158.357L557.601 159.705Z",
    fill: "black"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M551.868 156.88L553.138 154.304L550.402 152.956L549.132 155.532L551.868 156.88Z",
    fill: "black"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M546.136 154.055L547.405 151.479L544.669 150.131L543.4 152.706L546.136 154.055Z",
    fill: "black"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M540.403 151.23L541.672 148.654L538.936 147.305L537.667 149.881L540.403 151.23Z",
    fill: "black"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M534.67 148.404L535.94 145.829L533.204 144.48L531.934 147.056L534.67 148.404Z",
    fill: "black"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M528.938 145.579L530.207 143.003L527.471 141.655L526.202 144.231L528.938 145.579Z",
    fill: "black"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M523.205 142.754L524.474 140.178L521.738 138.83L520.469 141.405L523.205 142.754Z",
    fill: "black"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M517.472 139.929L518.742 137.353L516.006 136.004L514.736 138.58L517.472 139.929Z",
    fill: "black"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M511.74 137.103L513.009 134.528L510.273 133.179L509.004 135.755L511.74 137.103Z",
    fill: "black"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M506.007 134.278L507.276 131.702L504.54 130.354L503.271 132.93L506.007 134.278Z",
    fill: "black"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M500.274 131.453L501.544 128.877L498.808 127.529L497.538 130.104L500.274 131.453Z",
    fill: "black"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M494.542 128.628L495.811 126.052L493.075 124.703L491.806 127.279L494.542 128.628Z",
    fill: "black"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M488.809 125.802L490.078 123.227L487.342 121.878L486.073 124.454L488.809 125.802Z",
    fill: "black"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M483.076 122.977L484.346 120.401L481.61 119.053L480.34 121.629L483.076 122.977Z",
    fill: "black"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M477.344 120.152L478.613 117.576L475.877 116.228L474.608 118.803L477.344 120.152Z",
    fill: "black"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M471.611 117.327L472.881 114.751L470.144 113.402L468.875 115.978L471.611 117.327Z",
    fill: "black"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M465.878 114.501L467.148 111.926L464.412 110.577L463.142 113.153L465.878 114.501Z",
    fill: "black"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M575.055 175.124L576.411 172.373L573.489 170.933L572.133 173.684L575.055 175.124Z",
    fill: "black"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M569.323 172.298L570.679 169.548L567.756 168.108L566.401 170.858L569.323 172.298Z",
    fill: "black"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M563.59 169.473L564.946 166.722L562.024 165.282L560.668 168.033L563.59 169.473Z",
    fill: "black"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M557.857 166.648L559.213 163.897L556.291 162.457L554.935 165.208L557.857 166.648Z",
    fill: "black"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M552.125 163.823L553.481 161.072L550.558 159.632L549.203 162.383L552.125 163.823Z",
    fill: "black"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M546.392 160.998L547.748 158.247L544.826 156.807L543.47 159.557L546.392 160.998Z",
    fill: "black"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M540.66 158.172L542.015 155.421L539.093 153.981L537.737 156.732L540.66 158.172Z",
    fill: "black"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M534.927 155.347L536.283 152.596L533.36 151.156L532.005 153.907L534.927 155.347Z",
    fill: "black"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M529.194 152.522L530.55 149.771L527.628 148.331L526.272 151.082L529.194 152.522Z",
    fill: "black"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M523.462 149.697L524.817 146.946L521.895 145.506L520.539 148.256L523.462 149.697Z",
    fill: "black"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M517.729 146.871L519.085 144.12L516.163 142.68L514.807 145.431L517.729 146.871Z",
    fill: "black"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M511.996 144.046L513.352 141.295L510.43 139.855L509.074 142.606L511.996 144.046Z",
    fill: "black"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M506.264 141.221L507.619 138.47L504.697 137.03L503.341 139.781L506.264 141.221Z",
    fill: "black"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M500.531 138.396L501.887 135.645L498.965 134.205L497.609 136.955L500.531 138.396Z",
    fill: "black"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M494.798 135.57L496.154 132.819L493.232 131.379L491.876 134.13L494.798 135.57Z",
    fill: "black"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M489.066 132.745L490.421 129.994L487.499 128.554L486.144 131.305L489.066 132.745Z",
    fill: "black"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M483.333 129.92L484.689 127.169L481.767 125.729L480.411 128.48L483.333 129.92Z",
    fill: "black"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M477.6 127.095L478.956 124.344L476.034 122.904L474.678 125.655L477.6 127.095Z",
    fill: "black"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M471.868 124.269L473.223 121.519L470.301 120.078L468.946 122.829L471.868 124.269Z",
    fill: "black"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M466.135 121.444L467.491 118.693L464.569 117.253L463.213 120.004L466.135 121.444Z",
    fill: "black"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M460.402 118.619L461.758 115.868L458.836 114.428L457.48 117.179L460.402 118.619Z",
    fill: "black"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M575.309 182.059L576.746 179.143L573.649 177.617L572.212 180.532L575.309 182.059Z",
    fill: "black"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M569.576 179.233L571.013 176.318L567.916 174.791L566.479 177.707L569.576 179.233Z",
    fill: "black"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M563.844 176.408L565.281 173.492L562.183 171.966L560.747 174.882L563.844 176.408Z",
    fill: "black"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M558.111 173.583L559.548 170.667L556.451 169.141L555.014 172.057L558.111 173.583Z",
    fill: "black"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M552.378 170.758L553.815 167.842L550.718 166.316L549.281 169.231L552.378 170.758Z",
    fill: "black"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M546.646 167.932L548.083 165.017L544.985 163.49L543.549 166.406L546.646 167.932Z",
    fill: "black"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M540.913 165.107L542.35 162.191L539.253 160.665L537.816 163.581L540.913 165.107Z",
    fill: "black"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M535.18 162.282L536.617 159.366L533.52 157.84L532.083 160.756L535.18 162.282Z",
    fill: "black"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M529.448 159.457L530.885 156.541L527.788 155.015L526.351 157.93L529.448 159.457Z",
    fill: "black"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M523.715 156.631L525.152 153.716L522.055 152.189L520.618 155.105L523.715 156.631Z",
    fill: "black"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M517.982 153.806L519.419 150.891L516.322 149.364L514.885 152.28L517.982 153.806Z",
    fill: "black"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M512.25 150.981L513.687 148.065L510.59 146.539L509.153 149.455L512.25 150.981Z",
    fill: "black"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M506.517 148.156L507.954 145.24L504.857 143.714L503.42 146.629L506.517 148.156Z",
    fill: "black"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M500.784 145.33L502.221 142.415L499.124 140.888L497.687 143.804L500.784 145.33Z",
    fill: "black"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M495.052 142.505L496.489 139.59L493.392 138.063L491.955 140.979L495.052 142.505Z",
    fill: "black"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M489.319 139.68L490.756 136.764L487.659 135.238L486.222 138.154L489.319 139.68Z",
    fill: "black"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M483.587 136.855L485.023 133.939L481.926 132.413L480.489 135.328L483.587 136.855Z",
    fill: "black"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M477.854 134.03L479.291 131.114L476.194 129.587L474.757 132.503L477.854 134.03Z",
    fill: "black"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M472.121 131.204L473.558 128.289L470.461 126.762L469.024 129.678L472.121 131.204Z",
    fill: "black"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M466.389 128.379L467.826 125.463L464.728 123.937L463.291 126.853L466.389 128.379Z",
    fill: "black"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M460.656 125.554L462.093 122.638L458.996 121.112L457.559 124.027L460.656 125.554Z",
    fill: "black"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M569.833 186.176L571.356 183.085L568.073 181.467L566.55 184.558L569.833 186.176Z",
    fill: "black"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M564.1 183.351L565.623 180.26L562.34 178.642L560.817 181.733L564.1 183.351Z",
    fill: "black"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M558.368 180.526L559.891 177.435L556.608 175.817L555.084 178.908L558.368 180.526Z",
    fill: "black"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M552.635 177.7L554.158 174.61L550.875 172.991L549.352 176.082L552.635 177.7Z",
    fill: "black"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M546.902 174.875L548.426 171.784L545.142 170.166L543.619 173.257L546.902 174.875Z",
    fill: "black"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M541.17 172.05L542.693 168.959L539.41 167.341L537.886 170.432L541.17 172.05Z",
    fill: "black"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M535.437 169.225L536.96 166.134L533.677 164.516L532.154 167.607L535.437 169.225Z",
    fill: "black"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M529.704 166.399L531.228 163.309L527.944 161.691L526.421 164.781L529.704 166.399Z",
    fill: "black"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M523.972 163.574L525.495 160.483L522.212 158.865L520.688 161.956L523.972 163.574Z",
    fill: "black"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M518.239 160.749L519.762 157.658L516.479 156.04L514.956 159.131L518.239 160.749Z",
    fill: "black"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M512.506 157.924L514.03 154.833L510.746 153.215L509.223 156.306L512.506 157.924Z",
    fill: "black"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M506.774 155.098L508.297 152.008L505.014 150.39L503.49 153.48L506.774 155.098Z",
    fill: "black"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M501.041 152.273L502.564 149.182L499.281 147.564L497.758 150.655L501.041 152.273Z",
    fill: "black"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M495.308 149.448L496.832 146.357L493.548 144.739L492.025 147.83L495.308 149.448Z",
    fill: "black"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M489.576 146.623L491.099 143.532L487.816 141.914L486.292 145.005L489.576 146.623Z",
    fill: "black"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M483.843 143.798L485.366 140.707L482.083 139.089L480.56 142.179L483.843 143.798Z",
    fill: "black"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M478.11 140.972L479.634 137.881L476.35 136.263L474.827 139.354L478.11 140.972Z",
    fill: "black"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M472.378 138.147L473.901 135.056L470.618 133.438L469.094 136.529L472.378 138.147Z",
    fill: "black"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M466.645 135.322L468.168 132.231L464.885 130.613L463.362 133.704L466.645 135.322Z",
    fill: "black"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M460.912 132.497L462.436 129.406L459.152 127.788L457.629 130.878L460.912 132.497Z",
    fill: "black"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M455.18 129.671L456.703 126.58L453.42 124.962L451.897 128.053L455.18 129.671Z",
    fill: "black"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M570.089 193.119L571.699 189.853L568.23 188.143L566.62 191.409L570.089 193.119Z",
    fill: "black"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M564.357 190.294L565.966 187.028L562.497 185.318L560.887 188.584L564.357 190.294Z",
    fill: "black"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M558.624 187.468L560.234 184.202L556.764 182.493L555.155 185.759L558.624 187.468Z",
    fill: "black"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M552.891 184.643L554.501 181.377L551.032 179.667L549.422 182.933L552.891 184.643Z",
    fill: "black"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M547.159 181.818L548.768 178.552L545.299 176.842L543.689 180.108L547.159 181.818Z",
    fill: "black"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M541.426 178.993L543.036 175.727L539.566 174.017L537.957 177.283L541.426 178.993Z",
    fill: "black"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M535.693 176.167L537.303 172.901L533.834 171.192L532.224 174.458L535.693 176.167Z",
    fill: "black"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M529.961 173.342L531.57 170.076L528.101 168.366L526.491 171.632L529.961 173.342Z",
    fill: "black"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M524.228 170.517L525.838 167.251L522.368 165.541L520.759 168.807L524.228 170.517Z",
    fill: "black"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M518.495 167.692L520.105 164.426L516.636 162.716L515.026 165.982L518.495 167.692Z",
    fill: "black"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M512.763 164.867L514.372 161.601L510.903 159.891L509.294 163.157L512.763 164.867Z",
    fill: "black"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M507.03 162.041L508.64 158.775L505.17 157.065L503.561 160.331L507.03 162.041Z",
    fill: "black"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M501.298 159.216L502.907 155.95L499.438 154.24L497.828 157.506L501.298 159.216Z",
    fill: "black"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M495.565 156.391L497.174 153.125L493.705 151.415L492.096 154.681L495.565 156.391Z",
    fill: "black"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M489.832 153.566L491.442 150.3L487.972 148.59L486.363 151.856L489.832 153.566Z",
    fill: "black"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M484.1 150.74L485.709 147.474L482.24 145.765L480.63 149.031L484.1 150.74Z",
    fill: "black"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M478.367 147.915L479.976 144.649L476.507 142.939L474.898 146.205L478.367 147.915Z",
    fill: "black"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M472.634 145.09L474.244 141.824L470.775 140.114L469.165 143.38L472.634 145.09Z",
    fill: "black"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M466.902 142.265L468.511 138.999L465.042 137.289L463.432 140.555L466.902 142.265Z",
    fill: "black"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M461.169 139.439L462.779 136.173L459.309 134.464L457.7 137.73L461.169 139.439Z",
    fill: "black"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M455.436 136.614L457.046 133.348L453.577 131.638L451.967 134.904L455.436 136.614Z",
    fill: "black"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M564.61 197.229L566.301 193.798L562.657 192.002L560.966 195.433L564.61 197.229Z",
    fill: "black"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M558.878 194.403L560.568 190.973L556.924 189.176L555.233 192.607L558.878 194.403Z",
    fill: "black"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M553.145 191.578L554.836 188.147L551.191 186.351L549.501 189.782L553.145 191.578Z",
    fill: "black"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M547.412 188.753L549.103 185.322L545.459 183.526L543.768 186.957L547.412 188.753Z",
    fill: "black"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M541.68 185.928L543.371 182.497L539.726 180.701L538.035 184.132L541.68 185.928Z",
    fill: "black"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M535.947 183.102L537.638 179.672L533.993 177.875L532.303 181.306L535.947 183.102Z",
    fill: "black"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M530.214 180.277L531.905 176.846L528.261 175.05L526.57 178.481L530.214 180.277Z",
    fill: "black"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M524.482 177.452L526.173 174.021L522.528 172.225L520.837 175.656L524.482 177.452Z",
    fill: "black"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M518.749 174.627L520.44 171.196L516.795 169.4L515.105 172.831L518.749 174.627Z",
    fill: "black"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M513.016 171.801L514.707 168.371L511.063 166.574L509.372 170.005L513.016 171.801Z",
    fill: "black"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M507.284 168.976L508.975 165.545L505.33 163.749L503.639 167.18L507.284 168.976Z",
    fill: "black"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M501.551 166.151L503.242 162.72L499.598 160.924L497.907 164.355L501.551 166.151Z",
    fill: "black"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M495.818 163.326L497.509 159.895L493.865 158.099L492.174 161.53L495.818 163.326Z",
    fill: "black"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M490.086 160.5L491.777 157.07L488.132 155.274L486.441 158.704L490.086 160.5Z",
    fill: "black"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M484.353 157.675L486.044 154.244L482.4 152.448L480.709 155.879L484.353 157.675Z",
    fill: "black"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M478.62 154.85L480.311 151.419L476.667 149.623L474.976 153.054L478.62 154.85Z",
    fill: "black"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M472.888 152.025L474.579 148.594L470.934 146.798L469.243 150.229L472.888 152.025Z",
    fill: "black"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M467.155 149.199L468.846 145.769L465.202 143.973L463.511 147.403L467.155 149.199Z",
    fill: "black"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M461.423 146.374L463.113 142.943L459.469 141.147L457.778 144.578L461.423 146.374Z",
    fill: "black"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M455.69 143.549L457.381 140.118L453.736 138.322L452.045 141.753L455.69 143.549Z",
    fill: "black"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M449.957 140.724L451.648 137.293L448.004 135.497L446.313 138.928L449.957 140.724Z",
    fill: "black"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M564.867 204.171L566.644 200.565L562.814 198.678L561.036 202.284L564.867 204.171Z",
    fill: "black"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M559.134 201.346L560.911 197.74L557.081 195.852L555.304 199.458L559.134 201.346Z",
    fill: "black"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M553.401 198.521L555.179 194.915L551.348 193.027L549.571 196.633L553.401 198.521Z",
    fill: "black"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M547.669 195.696L549.446 192.09L545.616 190.202L543.838 193.808L547.669 195.696Z",
    fill: "black"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M541.936 192.87L543.713 189.264L539.883 187.377L538.106 190.983L541.936 192.87Z",
    fill: "black"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M536.204 190.045L537.981 186.439L534.15 184.551L532.373 188.157L536.204 190.045Z",
    fill: "black"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M530.471 187.22L532.248 183.614L528.418 181.726L526.64 185.332L530.471 187.22Z",
    fill: "black"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M524.738 184.395L526.515 180.789L522.685 178.901L520.908 182.507L524.738 184.395Z",
    fill: "black"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M519.006 181.569L520.783 177.963L516.952 176.076L515.175 179.682L519.006 181.569Z",
    fill: "black"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M513.273 178.744L515.05 175.138L511.22 173.25L509.442 176.856L513.273 178.744Z",
    fill: "black"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M507.54 175.919L509.317 172.313L505.487 170.425L503.71 174.031L507.54 175.919Z",
    fill: "black"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M501.808 173.094L503.585 169.488L499.754 167.6L497.977 171.206L501.808 173.094Z",
    fill: "black"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M496.075 170.268L497.852 166.662L494.022 164.775L492.244 168.381L496.075 170.268Z",
    fill: "black"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M490.342 167.443L492.119 163.837L488.289 161.949L486.512 165.555L490.342 167.443Z",
    fill: "black"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M484.61 164.618L486.387 161.012L482.556 159.124L480.779 162.73L484.61 164.618Z",
    fill: "black"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M478.877 161.793L480.654 158.187L476.824 156.299L475.047 159.905L478.877 161.793Z",
    fill: "black"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M473.144 158.967L474.921 155.361L471.091 153.474L469.314 157.08L473.144 158.967Z",
    fill: "black"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M467.412 156.142L469.189 152.536L465.358 150.648L463.581 154.254L467.412 156.142Z",
    fill: "black"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M461.679 153.317L463.456 149.711L459.626 147.823L457.849 151.429L461.679 153.317Z",
    fill: "black"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M455.946 150.492L457.724 146.886L453.893 144.998L452.116 148.604L455.946 150.492Z",
    fill: "black"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M450.214 147.667L451.991 144.061L448.16 142.173L446.383 145.779L450.214 147.667Z",
    fill: "black"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M559.391 208.289L561.254 204.508L557.238 202.528L555.374 206.309L559.391 208.289Z",
    fill: "black"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M553.658 205.464L555.521 201.683L551.505 199.703L549.642 203.484L553.658 205.464Z",
    fill: "black"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M547.925 202.638L549.789 198.857L545.772 196.878L543.909 200.659L547.925 202.638Z",
    fill: "black"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M542.193 199.813L544.056 196.032L540.04 194.053L538.176 197.834L542.193 199.813Z",
    fill: "black"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M536.46 196.988L538.324 193.207L534.307 191.227L532.444 195.008L536.46 196.988Z",
    fill: "black"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M530.727 194.163L532.591 190.382L528.574 188.402L526.711 192.183L530.727 194.163Z",
    fill: "black"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M524.995 191.337L526.858 187.556L522.842 185.577L520.978 189.358L524.995 191.337Z",
    fill: "black"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M519.262 188.512L521.126 184.731L517.109 182.752L515.246 186.533L519.262 188.512Z",
    fill: "black"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M513.529 185.687L515.393 181.906L511.376 179.926L509.513 183.707L513.529 185.687Z",
    fill: "black"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M507.797 182.862L509.66 179.081L505.644 177.101L503.78 180.882L507.797 182.862Z",
    fill: "black"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M502.064 180.036L503.928 176.255L499.911 174.276L498.048 178.057L502.064 180.036Z",
    fill: "black"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M496.331 177.211L498.195 173.43L494.178 171.451L492.315 175.232L496.331 177.211Z",
    fill: "black"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M490.599 174.386L492.462 170.605L488.446 168.625L486.582 172.407L490.599 174.386Z",
    fill: "black"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M484.866 171.561L486.73 167.78L482.713 165.8L480.85 169.581L484.866 171.561Z",
    fill: "black"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M479.133 168.735L480.997 164.954L476.98 162.975L475.117 166.756L479.133 168.735Z",
    fill: "black"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M473.401 165.91L475.264 162.129L471.248 160.15L469.384 163.931L473.401 165.91Z",
    fill: "black"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M467.668 163.085L469.532 159.304L465.515 157.324L463.652 161.106L467.668 163.085Z",
    fill: "black"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M461.936 160.26L463.799 156.479L459.782 154.499L457.919 158.28L461.936 160.26Z",
    fill: "black"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M456.203 157.435L458.066 153.653L454.05 151.674L452.186 155.455L456.203 157.435Z",
    fill: "black"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M450.47 154.609L452.334 150.828L448.317 148.849L446.454 152.63L450.47 154.609Z",
    fill: "black"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M444.738 151.784L446.601 148.003L442.585 146.023L440.721 149.805L444.738 151.784Z",
    fill: "black"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M559.644 215.224L561.589 211.278L557.397 209.212L555.453 213.158L559.644 215.224Z",
    fill: "black"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M553.912 212.399L555.856 208.453L551.665 206.387L549.72 210.333L553.912 212.399Z",
    fill: "black"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M548.179 209.573L550.124 205.627L545.932 203.562L543.987 207.508L548.179 209.573Z",
    fill: "black"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M542.446 206.748L544.391 202.802L540.199 200.736L538.255 204.682L542.446 206.748Z",
    fill: "black"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M536.714 203.923L538.658 199.977L534.467 197.911L532.522 201.857L536.714 203.923Z",
    fill: "black"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M530.981 201.098L532.926 197.152L528.734 195.086L526.789 199.032L530.981 201.098Z",
    fill: "black"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M525.248 198.272L527.193 194.326L523.001 192.261L521.057 196.207L525.248 198.272Z",
    fill: "black"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M519.516 195.447L521.46 191.501L517.269 189.435L515.324 193.381L519.516 195.447Z",
    fill: "black"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M513.783 192.622L515.728 188.676L511.536 186.61L509.591 190.556L513.783 192.622Z",
    fill: "black"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M508.05 189.797L509.995 185.851L505.803 183.785L503.859 187.731L508.05 189.797Z",
    fill: "black"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M502.318 186.971L504.262 183.025L500.071 180.96L498.126 184.906L502.318 186.971Z",
    fill: "black"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M496.585 184.146L498.53 180.2L494.338 178.134L492.393 182.08L496.585 184.146Z",
    fill: "black"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M490.852 181.321L492.797 177.375L488.605 175.309L486.661 179.255L490.852 181.321Z",
    fill: "black"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M485.12 178.496L487.064 174.55L482.873 172.484L480.928 176.43L485.12 178.496Z",
    fill: "black"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M479.387 175.67L481.332 171.724L477.14 169.659L475.195 173.605L479.387 175.67Z",
    fill: "black"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M473.654 172.845L475.599 168.899L471.408 166.833L469.463 170.779L473.654 172.845Z",
    fill: "black"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M467.922 170.02L469.866 166.074L465.675 164.008L463.73 167.954L467.922 170.02Z",
    fill: "black"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M462.189 167.195L464.134 163.249L459.942 161.183L457.997 165.129L462.189 167.195Z",
    fill: "black"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M456.456 164.369L458.401 160.423L454.21 158.358L452.265 162.304L456.456 164.369Z",
    fill: "black"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M450.724 161.544L452.668 157.598L448.477 155.532L446.532 159.478L450.724 161.544Z",
    fill: "black"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M444.991 158.719L446.936 154.773L442.744 152.707L440.8 156.653L444.991 158.719Z",
    fill: "black"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M554.168 219.341L556.199 215.22L551.821 213.063L549.79 217.184L554.168 219.341Z",
    fill: "black"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M548.435 216.516L550.466 212.395L546.089 210.237L544.058 214.359L548.435 216.516Z",
    fill: "black"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M542.703 213.691L544.734 209.57L540.356 207.412L538.325 211.533L542.703 213.691Z",
    fill: "black"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M536.97 210.866L539.001 206.744L534.624 204.587L532.592 208.708L536.97 210.866Z",
    fill: "black"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M531.237 208.04L533.269 203.919L528.891 201.762L526.86 205.883L531.237 208.04Z",
    fill: "black"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M525.505 205.215L527.536 201.094L523.158 198.937L521.127 203.058L525.505 205.215Z",
    fill: "black"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M519.772 202.39L521.803 198.269L517.426 196.111L515.395 200.232L519.772 202.39Z",
    fill: "black"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M514.04 199.565L516.071 195.443L511.693 193.286L509.662 197.407L514.04 199.565Z",
    fill: "black"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M508.307 196.739L510.338 192.618L505.96 190.461L503.929 194.582L508.307 196.739Z",
    fill: "black"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M502.574 193.914L504.605 189.793L500.228 187.636L498.197 191.757L502.574 193.914Z",
    fill: "black"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M496.842 191.089L498.873 186.968L494.495 184.81L492.464 188.931L496.842 191.089Z",
    fill: "black"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M491.109 188.264L493.14 184.143L488.762 181.985L486.731 186.106L491.109 188.264Z",
    fill: "black"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M485.376 185.438L487.407 181.317L483.03 179.16L480.999 183.281L485.376 185.438Z",
    fill: "black"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M479.644 182.613L481.675 178.492L477.297 176.335L475.266 180.456L479.644 182.613Z",
    fill: "black"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M473.911 179.788L475.942 175.667L471.564 173.509L469.533 177.63L473.911 179.788Z",
    fill: "black"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M468.178 176.963L470.209 172.842L465.832 170.684L463.801 174.805L468.178 176.963Z",
    fill: "black"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M462.446 174.137L464.477 170.016L460.099 167.859L458.068 171.98L462.446 174.137Z",
    fill: "black"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M456.713 171.312L458.744 167.191L454.366 165.034L452.335 169.155L456.713 171.312Z",
    fill: "black"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M450.98 168.487L453.011 164.366L448.634 162.208L446.603 166.33L450.98 168.487Z",
    fill: "black"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M445.248 165.662L447.279 161.541L442.901 159.383L440.87 163.504L445.248 165.662Z",
    fill: "black"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M439.515 162.836L441.546 158.715L437.168 156.558L435.137 160.679L439.515 162.836Z",
    fill: "black"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M172.779 145.505L240.18 390.618C240.18 390.618 240.957 460.04 162.056 429.077L172.779 145.505Z",
    fill: "url(#paint0_linear_208_3329)"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M203.441 250.21C203.441 250.21 190.237 264.828 168.313 271.086L173.296 145.505L203.441 250.21Z",
    fill: "black"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M188.559 160.372L229.004 233.737C229.004 233.737 188.017 269.877 155.969 253.005L139.985 107.353L141.672 108.517C161.106 121.939 177.156 139.691 188.559 160.372Z",
    fill: "#ED1B2F"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M157.148 75.0086L150.623 96.424L148.211 91.812C148.211 91.812 143.003 105.46 135.062 106.501L130.37 99.6768C130.37 99.6768 123.741 113.261 114.526 120.769L107.384 98.6242H103.546C103.546 98.6242 99.2767 89.2578 103.546 79.2475L98.8799 81.1293L103.546 58.9893L157.148 75.0086Z",
    fill: "#2C665B"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M103.546 79.2436L98.8799 81.1254L103.546 58.9854",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M150.616 96.4215L148.205 91.8096C148.205 91.8096 143.244 104.961 135.056 106.498",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M165.891 76.4741C171.955 76.4741 176.871 71.5583 176.871 65.4944C176.871 59.4304 171.955 54.5146 165.891 54.5146C159.827 54.5146 154.911 59.4304 154.911 65.4944C154.911 71.5583 159.827 76.4741 165.891 76.4741Z",
    fill: "url(#paint1_linear_208_3329)"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5674 48.0061C92.5674 54.0698 97.4834 58.9858 103.547 58.9858C109.611 58.9858 114.527 54.0698 114.527 48.0061C114.527 41.9424 109.611 37.0264 103.547 37.0264C97.4834 37.024 92.5674 41.94 92.5674 48.0061Z",
    fill: "url(#paint2_linear_208_3329)"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5373 118.157L-78.742 214.064C-107.333 234.952 -100.376 279.415 -66.7715 290.568L-22.8739 305.141C-27.1722 309.218 -27.7876 315.847 -24.3138 320.647L-23.8481 321.291C-29.8025 323.921 -31.6059 331.505 -27.4715 336.533L-24.9506 339.598C-24.9506 339.598 12.8358 349.863 25.3101 317.838L52.5373 118.157Z",
    fill: "url(#paint3_linear_208_3329)"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M-22.042 199.258C-22.042 199.258 -3.23789 238.075 45.4735 238.508C94.185 238.938 55.8212 137.442 55.8212 137.442L-22.042 199.258Z",
    fill: "black"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8389 103.632L-29.7886 167.638C-29.7886 167.638 -42.5457 214.418 36.9309 227.305L68.8389 103.632Z",
    fill: "#ED1B2F"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0233 207.622L36.941 227.312C-42.5522 214.419 -29.7786 167.628 -29.7786 167.628L-16.7459 159.157C-17.5704 173.836 -10.9341 185.434 5.10899 197.716C18.2414 207.769 31.9798 206.398 42.0233 207.622Z",
    fill: "#990E1B"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4635 106.065C48.6132 116.27 38.591 132.111 35.7255 149.9L18.4658 261.349H184.041C191.274 254.406 190.875 242.721 183.186 236.287L179.443 233.155L165.843 149.772C158.064 102.071 103.293 78.6902 63.4635 106.065Z",
    fill: "#F4F4F4"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4658 261.349H184.041C184.041 261.349 196.922 244.8 179.443 233.154L168.098 163.591",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8504 168.474L18.4658 261.349",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M174.29 201.545L179.446 177.88",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M150.627 84.0811C150.627 84.0811 137.575 93.11 139.982 107.354C139.982 107.354 128.378 116.407 116.994 113.321C103.847 109.757 100.278 94.4074 100.278 94.4074C100.278 94.4074 111.733 80.947 104.641 65.4932L150.627 84.0811Z",
    fill: "url(#paint4_linear_208_3329)"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M100.278 94.4113C100.278 94.4113 110.74 82.588 104.641 65.4971",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6695 96.4229C84.6695 96.4229 59.8303 100.044 42.9033 128.925",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.6793 186.588C-28.6793 186.588 -30.977 180.415 -29.7771 167.627L5.74489 144.579",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M110.11 67.7119C112.84 74.2532 116.181 80.7921 119.897 85.0262C129.824 96.341 141.94 94.414 141.94 94.414C141.94 94.414 141.94 94.3902 141.964 94.3902C145.162 87.8727 150.622 84.0853 150.622 84.0853L110.11 67.7119Z",
    fill: "black"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M134.32 88.2309C153.121 88.2309 168.362 72.9899 168.362 54.1892C168.362 35.3885 153.121 20.1475 134.32 20.1475C115.519 20.1475 100.278 35.3885 100.278 54.1892C100.278 72.9899 115.519 88.2309 134.32 88.2309Z",
    fill: "url(#paint5_linear_208_3329)"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M159.466 153.099L154.946 162.219L144.596 157.219L159.466 153.099Z",
    fill: "#E9FE53"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M129.727 161.339L134.246 152.219L144.596 157.219L129.727 161.339Z",
    fill: "#E9FE53"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M154.946 162.219L154.52 163.101L155.393 163.523L155.824 162.654L154.946 162.219ZM159.466 153.099L160.344 153.534L161.317 151.569L159.204 152.155L159.466 153.099ZM134.246 152.219L134.672 151.337L133.799 150.915L133.368 151.784L134.246 152.219ZM129.727 161.339L128.849 160.904L127.875 162.869L129.988 162.283L129.727 161.339ZM155.824 162.654L160.344 153.534L158.588 152.664L154.068 161.784L155.824 162.654ZM144.17 158.101L154.52 163.101L155.372 161.337L145.022 156.337L144.17 158.101ZM144.858 158.163L159.727 154.043L159.204 152.155L144.335 156.275L144.858 158.163ZM133.368 151.784L128.849 160.904L130.605 161.774L135.124 152.654L133.368 151.784ZM145.022 156.337L134.672 151.337L133.82 153.101L144.17 158.101L145.022 156.337ZM144.335 156.275L129.465 160.395L129.988 162.283L144.858 158.163L144.335 156.275Z",
    fill: "#202023"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M116.997 113.321C130.388 116.215 139.985 107.354 139.985 107.354C139.985 107.354 164.891 123.733 182.089 149.7",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M164.44 48.0043L163.411 58.9841C163.411 58.9841 166.776 64.335 164.44 70.0636C164.44 70.0636 174.27 58.8558 166.928 38.3623L164.44 48.0043Z",
    fill: "black"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M114.522 26.499L107.641 43.6351C107.641 43.6351 101.152 43.1148 100.275 54.1919C100.275 54.1919 98.7381 31.4079 114.522 26.499Z",
    fill: "black"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M116.528 14.9193L111.776 12.2962C128.016 7.99313 144.48 13.3131 144.48 13.3131L141.45 5.15137C141.45 5.15137 162.884 14.791 168.347 30.9957L176.093 33.1342C177.454 40.7399 173.522 45.6726 164.438 48.0035C164.438 48.0035 155.493 47.4285 149.068 37.0237L147.003 42.5148C147.003 42.5148 133.602 37.8316 130.366 29.3728V35.1086C130.366 35.1086 111.55 41.3268 107.38 28.2513C107.38 28.2513 108.779 19.9494 116.528 14.9193Z",
    fill: "#FFB434"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M173.639 62.9041C173.639 62.9041 168.291 59.6014 166.532 73.6842",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M168.36 66.1064L170.081 69.3402",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M96.79 41.3486C96.79 41.3486 102.352 41.5221 96.79 52.4757",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2314 48.0063L98.8811 44.6514",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M147.006 42.5147C147.006 42.5147 126.185 36.3702 130.369 21.6553",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M130.363 35.1104C130.363 35.1104 120.968 38.3109 116.06 36.0655",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M144.484 13.3127L141.454 5.15332",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M160.2 18.3428C165.313 22.9713 168.348 30.9952 168.348 30.9952L162.054 26.495L164.275 30.9952",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M107.38 28.2506C107.38 28.2506 109.865 12.9702 121.762 14.4743",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M176.091 33.1377C176.091 33.1377 179.501 45.0037 164.437 48.007C164.437 48.007 144.849 44.6901 148.03 26.499",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M111.778 12.2959L116.53 14.9191",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M484.946 105.697C484.946 105.697 502.792 104.757 497.502 87.923C497.502 87.923 516.064 85.6833 510.455 70.3543C510.455 70.3543 524.027 47.1174 504.621 35.9222C485.215 24.7255 436.329 38.3666 436.329 38.3666C436.329 38.3666 402.088 61.8516 429.595 80.0574C429.563 86.68 421.678 102.559 434.788 105.744C434.788 105.744 433.08 113.161 439.118 115.272C445.156 117.382 455.748 103.689 455.748 103.689L484.946 105.697Z",
    fill: "black"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M402.988 160.063L335.586 405.176C335.586 405.176 334.809 474.597 413.711 443.635L402.988 160.063Z",
    fill: "url(#paint6_linear_208_3329)"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M372.326 264.768C372.326 264.768 385.529 279.386 407.453 285.644L402.471 160.063L372.326 264.768Z",
    fill: "black"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M387.208 174.93L346.762 248.295C346.762 248.295 387.749 284.435 419.798 267.562L435.781 121.91L434.094 123.075C414.661 136.497 398.61 154.248 387.208 174.93Z",
    fill: "#FFB434"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M432.108 76.7908C426.244 75.2489 422.739 69.2448 424.281 63.3801C425.823 57.5155 431.827 54.0112 437.692 55.553C443.556 57.0948 447.061 63.0989 445.519 68.9636C443.977 74.8282 437.973 78.3326 432.108 76.7908Z",
    fill: "url(#paint7_linear_208_3329)"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M510.26 67.9021C508.718 73.7665 502.714 77.271 496.849 75.7292C490.985 74.1875 487.481 68.183 489.022 62.3186C490.564 56.4542 496.568 52.9497 502.433 54.4915C508.298 56.0309 511.802 62.0354 510.26 67.9021Z",
    fill: "url(#paint8_linear_208_3329)"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M523.229 132.715L654.509 228.622C683.1 249.51 676.143 293.973 642.538 305.126L598.64 319.699C602.939 323.776 603.554 330.405 600.08 335.205L599.615 335.849C605.569 338.479 607.372 346.063 603.238 351.091L600.717 354.156C600.717 354.156 562.931 364.421 550.457 332.396L523.229 132.715Z",
    fill: "url(#paint9_linear_208_3329)"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M597.809 213.816C597.809 213.816 579.004 252.633 530.293 253.066C481.582 253.496 519.945 152 519.945 152L597.809 213.816Z",
    fill: "black"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M506.65 116.059L600.449 186.952C600.449 186.952 609.83 234.524 529.635 241.697L506.65 116.059Z",
    fill: "#FFB434"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M527.184 223.392L531.229 243.321C611.288 234.606 600.98 187.21 600.98 187.21L588.408 178.069C588.464 192.771 581.23 204.006 564.566 215.431C550.926 224.783 537.278 222.696 527.184 223.392Z",
    fill: "#990E1B"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M512.303 120.623C527.153 130.828 537.176 146.669 540.041 164.458L557.301 275.907H391.726C384.493 268.964 384.892 257.279 392.581 250.844L396.323 247.713L409.924 164.33C417.703 116.628 472.473 93.248 512.303 120.623Z",
    fill: "#F4F4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 134.568,
    height: 7.32699,
    transform: "matrix(0.999331 -0.0365783 0.0426195 0.999091 407.777 156.922)",
    fill: "#FFB434"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 143.061,
    height: 7.32699,
    transform: "matrix(0.999324 -0.0367509 0.0424194 0.9991 403.961 166.519)",
    fill: "#FFB434"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 143.061,
    height: 7.32699,
    transform: "matrix(0.999324 -0.0367509 0.0424194 0.9991 403.961 175.519)",
    fill: "#FFB434"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M557.301 275.907H391.726C391.726 275.907 378.845 259.357 396.323 247.712L407.669 178.149",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M444.935 88.0288C444.935 88.0288 455.262 100.08 449.313 113.244C449.313 113.244 458.234 124.95 470.029 124.859C483.649 124.755 491.004 110.817 491.004 110.817C491.004 110.817 483.348 94.8869 494.136 81.7443L444.935 88.0288Z",
    fill: "url(#paint10_linear_208_3329)"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M491.003 110.821C491.003 110.821 483.891 96.7267 494.135 81.7482",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M491.097 110.981C491.097 110.981 515.936 114.602 532.863 143.483",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M598.891 206.087C598.891 206.087 601.508 200.042 600.979 187.209L566.711 162.335",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M449.715 82.0352C454.581 87.1891 460.017 92.125 464.99 94.7721C478.276 101.847 488.928 95.7622 488.928 95.7622C488.928 95.7622 488.92 95.7399 488.942 95.7315C489.63 88.5043 493.399 83.0313 493.399 83.0313L449.715 82.0352Z",
    fill: "black"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M459.652 96.1884C441.469 91.4081 430.604 72.7928 435.384 54.61C440.165 36.4272 458.78 25.5622 476.963 30.3425C495.146 35.1228 506.011 53.7382 501.23 71.921C496.45 90.1038 477.835 100.969 459.652 96.1884Z",
    fill: "url(#paint11_linear_208_3329)"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M435.781 121.912C435.781 121.912 410.876 138.29 393.678 164.258",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M440.75 49.6251L438.953 60.5056C438.953 60.5056 434.338 64.8251 435.141 70.9594C435.141 70.9594 428.484 57.6205 440.795 39.6674L440.75 49.6251Z",
    fill: "black"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M494.494 41.5188L496.792 59.8412C496.792 59.8412 503.2 60.9879 501.232 71.924C501.232 71.924 508.511 50.2797 494.494 41.5188Z",
    fill: "black"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M495.499 29.8105L500.762 28.4818C486.15 20.1909 468.874 21.1499 468.874 21.1499L473.88 14.0267C473.88 14.0267 450.699 17.8996 441.295 32.1828L433.26 32.2815C430.01 39.2911 432.559 45.0615 440.751 49.6254C440.751 49.6254 449.549 51.3439 458.408 42.9147L459.009 48.7503C459.009 48.7503 465.928 50.2726 471.208 42.9147L476.983 45.8177C476.983 45.8177 493.599 56.6157 500.957 45.0303C500.957 45.0303 501.714 36.6454 495.499 29.8105Z",
    fill: "black"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M428.064 61.6964C428.064 61.6964 434.076 59.8621 432.196 73.9292",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M432.355 66.1357L429.869 68.8258",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M507.868 60.3896C507.868 60.3896 502.445 59.1431 505.039 71.151",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M507.683 67.2242L505.006 63.0515",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M468.871 21.1483L473.875 14.0273",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M452.392 22.0166C446.27 25.1929 441.295 32.1817 441.295 32.1817L448.526 29.4297L445.234 33.2171",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M500.957 45.0288C500.957 45.0288 502.439 29.6187 490.55 28.0484",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M500.76 28.4805L495.497 29.8092",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M359.939 73.1976C359.939 73.1976 364.087 79.6019 360.801 109.612C360.801 109.612 393.918 106.871 389.545 134.475C389.545 134.475 426.283 154.922 396.426 180.433C366.568 205.946 298.433 214.145 298.433 214.145C298.433 214.145 216.19 166.164 213.804 155.096C211.417 144.028 223.585 111.63 245.295 101.719C245.295 101.719 239.709 89.9084 249.482 84.2675C259.255 78.6266 269.724 75.1822 269.724 75.1822L284.117 41.1636L359.939 73.1976Z",
    fill: "black"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M270.567 103.494L300.242 187.653L348.968 166.173C340.632 146.054 342.481 128.127 320.326 116.583C302.775 107.44 284.354 102.353 270.567 103.494Z",
    fill: "black"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M262.676 103.854C262.676 103.854 295.371 97.7629 284.839 79.6828L328.047 91.3417C328.047 91.3417 306.007 97.505 319.637 116.452C326.922 127.181 331.852 159.126 321.315 159.717C305.272 160.615 291.156 124.002 245.803 109.13C251.094 106.627 262.676 103.854 262.676 103.854Z",
    fill: "url(#paint12_linear_208_3329)"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M290.62 86.3946C290.62 86.3946 298.672 101.521 315.479 102.655C317.272 94.3622 328.045 91.3463 328.045 91.3463L290.956 81.3148L290.62 86.3946Z",
    fill: "black"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M222.577 260.541L211.311 149.541C216.56 131.377 229.354 116.841 245.808 109.128C291.158 124 314.075 164.708 330.084 166.192C351.444 168.153 327.644 128.44 320.07 117.075C342.466 128.701 363.417 146.513 371.588 166.255L375.015 176.004C380.334 184.32 386.002 191.944 379.722 195.084L313.416 207.046C313.18 207.357 289.068 239.207 297.652 282.551C310.657 348.222 205.403 363.668 205.403 363.668L158.442 367.555L222.577 260.541Z",
    fill: "#2C665B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_3329",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 109,
    width: 226,
    height: 259
  }, _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M222.573 260.539L211.307 149.539C216.556 131.376 229.351 116.839 245.804 109.126C291.154 123.998 314.071 164.707 330.08 166.19C351.44 168.151 327.64 128.439 320.066 117.073C342.462 128.7 363.413 146.511 371.584 166.253L375.011 176.002C377.227 184.518 387.331 189.503 381.051 192.643L313.412 207.045C313.176 207.355 289.064 239.205 297.648 282.55C310.653 348.221 205.399 363.667 205.399 363.667L158.438 367.554L222.573 260.539Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_3329)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_208_3329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.616 146.739L350.382 146.318L349.935 146.565L350.168 146.987L350.616 146.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.115 148.675L346.882 148.254L346.434 148.501L346.667 148.923L347.115 148.675Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.614 150.611L343.381 150.19L342.933 150.437L343.166 150.859L343.614 150.611Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.113 152.548L339.88 152.126L339.432 152.374L339.666 152.795L340.113 152.548Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.613 154.484L336.379 154.062L335.932 154.31L336.165 154.731L336.613 154.484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.112 156.42L332.879 155.998L332.431 156.246L332.664 156.667L333.112 156.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.611 158.356L329.378 157.934L328.93 158.182L329.163 158.604L329.611 158.356Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.11 160.292L325.877 159.871L325.429 160.118L325.663 160.54L326.11 160.292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.61 162.228L322.377 161.807L321.929 162.054L322.162 162.476L322.61 162.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.109 164.164L318.876 163.743L318.428 163.991L318.661 164.412L319.109 164.164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.608 166.101L315.375 165.679L314.927 165.927L315.16 166.348L315.608 166.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.107 168.037L311.874 167.615L311.427 167.863L311.66 168.284L312.107 168.037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.607 169.973L308.374 169.551L307.926 169.799L308.159 170.221L308.607 169.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.106 171.909L304.873 171.488L304.425 171.735L304.658 172.157L305.106 171.909Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.605 173.845L301.372 173.424L300.924 173.671L301.157 174.093L301.605 173.845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.104 175.781L297.871 175.36L297.424 175.608L297.657 176.029L298.104 175.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.604 177.718L294.371 177.296L293.923 177.544L294.156 177.965L294.604 177.718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.103 179.654L290.87 179.232L290.422 179.48L290.655 179.901L291.103 179.654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.602 181.59L287.369 181.168L286.921 181.416L287.154 181.838L287.602 181.59Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.27 149.087L353.981 148.565L353.426 148.872L353.715 149.394L354.27 149.087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.769 151.023L350.48 150.501L349.926 150.808L350.215 151.33L350.769 151.023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.268 152.96L346.98 152.437L346.425 152.744L346.714 153.266L347.268 152.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.768 154.896L343.479 154.374L342.924 154.68L343.213 155.203L343.768 154.896Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.267 156.832L339.978 156.31L339.423 156.617L339.712 157.139L340.267 156.832Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.766 158.768L336.477 158.246L335.923 158.553L336.212 159.075L336.766 158.768Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.266 160.704L332.977 160.182L332.422 160.489L332.711 161.011L333.266 160.704Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.765 162.64L329.476 162.118L328.921 162.425L329.21 162.947L329.765 162.64Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.264 164.577L325.975 164.054L325.421 164.361L325.709 164.883L326.264 164.577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.763 166.513L322.474 165.991L321.92 166.297L322.209 166.82L322.763 166.513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.263 168.449L318.974 167.927L318.419 168.234L318.708 168.756L319.263 168.449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.762 170.385L315.473 169.863L314.918 170.17L315.207 170.692L315.762 170.385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.261 172.321L311.972 171.799L311.418 172.106L311.706 172.628L312.261 172.321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.76 174.257L308.472 173.735L307.917 174.042L308.206 174.564L308.76 174.257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.26 176.194L304.971 175.671L304.416 175.978L304.705 176.5L305.26 176.194Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.759 178.13L301.47 177.608L300.915 177.914L301.204 178.437L301.759 178.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.258 180.066L297.969 179.544L297.415 179.85L297.703 180.373L298.258 180.066Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.757 182.002L294.469 181.48L293.914 181.787L294.203 182.309L294.757 182.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.257 183.938L290.968 183.416L290.413 183.723L290.702 184.245L291.257 183.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.929 151.437L357.581 150.808L356.913 151.177L357.261 151.807L357.929 151.437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.429 153.373L354.081 152.744L353.412 153.114L353.76 153.743L354.429 153.373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.928 155.309L350.58 154.68L349.912 155.05L350.26 155.679L350.928 155.309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.427 157.245L347.079 156.616L346.411 156.986L346.759 157.615L347.427 157.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.926 159.182L343.578 158.552L342.91 158.922L343.258 159.551L343.926 159.182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.426 161.118L340.078 160.489L339.409 160.858L339.757 161.487L340.426 161.118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.925 163.054L336.577 162.425L335.909 162.794L336.257 163.423L336.925 163.054Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.424 164.99L333.076 164.361L332.408 164.73L332.756 165.36L333.424 164.99Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.924 166.926L329.576 166.297L328.907 166.667L329.255 167.296L329.924 166.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.423 168.862L326.075 168.233L325.406 168.603L325.754 169.232L326.423 168.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.922 170.799L322.574 170.169L321.906 170.539L322.254 171.168L322.922 170.799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.421 172.735L319.073 172.106L318.405 172.475L318.753 173.104L319.421 172.735Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.921 174.671L315.573 174.042L314.904 174.411L315.252 175.04L315.921 174.671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.42 176.607L312.072 175.978L311.404 176.347L311.751 176.977L312.42 176.607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.919 178.543L308.571 177.914L307.903 178.284L308.251 178.913L308.919 178.543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.418 180.479L305.07 179.85L304.402 180.22L304.75 180.849L305.418 180.479Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.918 182.415L301.57 181.786L300.901 182.156L301.249 182.785L301.918 182.415Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.417 184.352L298.069 183.722L297.401 184.092L297.749 184.721L298.417 184.352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.916 186.288L294.568 185.659L293.9 186.028L294.248 186.657L294.916 186.288Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.415 188.224L291.067 187.595L290.399 187.964L290.747 188.594L291.415 188.224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.589 153.786L361.182 153.05L360.4 153.483L360.807 154.219L361.589 153.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.088 155.723L357.681 154.987L356.899 155.419L357.306 156.155L358.088 155.723Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.587 157.659L354.18 156.923L353.398 157.355L353.805 158.091L354.587 157.659Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.087 159.595L350.68 158.859L349.898 159.291L350.305 160.027L351.087 159.595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.586 161.531L347.179 160.795L346.397 161.227L346.804 161.964L347.586 161.531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.085 163.467L343.678 162.731L342.896 163.164L343.303 163.9L344.085 163.467Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.584 165.403L340.177 164.667L339.395 165.1L339.803 165.836L340.584 165.403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.084 167.34L336.677 166.603L335.895 167.036L336.302 167.772L337.084 167.34Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.583 169.276L333.176 168.54L332.394 168.972L332.801 169.708L333.583 169.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.082 171.212L329.675 170.476L328.893 170.908L329.3 171.644L330.082 171.212Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.581 173.148L326.174 172.412L325.392 172.844L325.8 173.581L326.581 173.148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.081 175.084L322.674 174.348L321.892 174.781L322.299 175.517L323.081 175.084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.58 177.02L319.173 176.284L318.391 176.717L318.798 177.453L319.58 177.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.079 178.957L315.672 178.22L314.89 178.653L315.297 179.389L316.079 178.957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.579 180.893L312.171 180.157L311.389 180.589L311.797 181.325L312.579 180.893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.078 182.829L308.671 182.093L307.889 182.525L308.296 183.261L309.078 182.829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.577 184.765L305.17 184.029L304.388 184.461L304.795 185.198L305.577 184.765Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.076 186.701L301.669 185.965L300.887 186.398L301.294 187.134L302.076 186.701Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.576 188.637L298.168 187.901L297.386 188.334L297.794 189.07L298.576 188.637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.075 190.574L294.668 189.837L293.886 190.27L294.293 191.006L295.075 190.574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.243 156.135L364.78 155.298L363.892 155.79L364.354 156.626L365.243 156.135Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.743 158.071L361.28 157.234L360.391 157.726L360.854 158.563L361.743 158.071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.242 160.007L357.779 159.17L356.89 159.662L357.353 160.499L358.242 160.007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.741 161.943L354.278 161.106L353.389 161.598L353.852 162.435L354.741 161.943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.24 163.879L350.777 163.043L349.889 163.534L350.351 164.371L351.24 163.879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.74 165.816L347.277 164.979L346.388 165.47L346.851 166.307L347.74 165.816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.239 167.752L343.776 166.915L342.887 167.407L343.35 168.243L344.239 167.752Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.738 169.688L340.275 168.851L339.386 169.343L339.849 170.179L340.738 169.688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.237 171.624L336.775 170.787L335.886 171.279L336.348 172.116L337.237 171.624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.737 173.56L333.274 172.723L332.385 173.215L332.848 174.052L333.737 173.56Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.236 175.496L329.773 174.66L328.884 175.151L329.347 175.988L330.236 175.496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.735 177.433L326.272 176.596L325.383 177.087L325.846 177.924L326.735 177.433Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.234 179.369L322.772 178.532L321.883 179.024L322.346 179.86L323.234 179.369Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.734 181.305L319.271 180.468L318.382 180.96L318.845 181.796L319.734 181.305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.233 183.241L315.77 182.404L314.881 182.896L315.344 183.733L316.233 183.241Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.732 185.177L312.269 184.34L311.38 184.832L311.843 185.669L312.732 185.177Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.231 187.113L308.769 186.277L307.88 186.768L308.343 187.605L309.231 187.113Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.731 189.049L305.268 188.213L304.379 188.704L304.842 189.541L305.731 189.049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.23 190.986L301.767 190.149L300.878 190.64L301.341 191.477L302.23 190.986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.729 192.922L298.266 192.085L297.378 192.577L297.84 193.413L298.729 192.922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.228 194.858L294.766 194.021L293.877 194.513L294.34 195.35L295.228 194.858Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.903 158.484L368.381 157.541L367.378 158.095L367.9 159.039L368.903 158.484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.402 160.42L364.88 159.477L363.878 160.031L364.399 160.975L365.402 160.42Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.901 162.357L361.379 161.413L360.377 161.967L360.899 162.911L361.901 162.357Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.4 164.293L357.879 163.349L356.876 163.904L357.398 164.847L358.4 164.293Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.9 166.229L354.378 165.285L353.375 165.84L353.897 166.783L354.9 166.229Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.399 168.165L350.877 167.221L349.875 167.776L350.397 168.72L351.399 168.165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.898 170.101L347.376 169.158L346.374 169.712L346.896 170.656L347.898 170.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.398 172.037L343.876 171.094L342.873 171.648L343.395 172.592L344.398 172.037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.897 173.974L340.375 173.03L339.372 173.584L339.894 174.528L340.897 173.974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.396 175.91L336.874 174.966L335.872 175.52L336.394 176.464L337.396 175.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.895 177.846L333.373 176.902L332.371 177.457L332.893 178.4L333.895 177.846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.395 179.782L329.873 178.838L328.87 179.393L329.392 180.337L330.395 179.782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.894 181.718L326.372 180.775L325.369 181.329L325.891 182.273L326.894 181.718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.393 183.654L322.871 182.711L321.869 183.265L322.391 184.209L323.393 183.654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.892 185.591L319.37 184.647L318.368 185.201L318.89 186.145L319.892 185.591Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.392 187.527L315.87 186.583L314.867 187.137L315.389 188.081L316.392 187.527Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.891 189.463L312.369 188.519L311.366 189.074L311.888 190.017L312.891 189.463Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.39 191.399L308.868 190.455L307.866 191.01L308.388 191.954L309.39 191.399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.889 193.335L305.367 192.391L304.365 192.946L304.887 193.89L305.889 193.335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.389 195.271L301.867 194.328L300.864 194.882L301.386 195.826L302.389 195.271Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.888 197.208L298.366 196.264L297.363 196.818L297.885 197.762L298.888 197.208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.061 162.77L368.48 161.719L367.364 162.337L367.945 163.387L369.061 162.77Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.561 164.706L364.98 163.656L363.863 164.273L364.445 165.324L365.561 164.706Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.06 166.642L361.479 165.592L360.363 166.209L360.944 167.26L362.06 166.642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.559 168.579L357.978 167.528L356.862 168.145L357.443 169.196L358.559 168.579Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.058 170.515L354.477 169.464L353.361 170.081L353.942 171.132L355.058 170.515Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.558 172.451L350.977 171.4L349.861 172.017L350.442 173.068L351.558 172.451Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.057 174.387L347.476 173.336L346.36 173.954L346.941 175.004L348.057 174.387Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.556 176.323L343.975 175.272L342.859 175.89L343.44 176.94L344.556 176.323Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.056 178.259L340.474 177.209L339.358 177.826L339.939 178.877L341.056 178.259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.555 180.196L336.974 179.145L335.858 179.762L336.439 180.813L337.555 180.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.054 182.132L333.473 181.081L332.357 181.698L332.938 182.749L334.054 182.132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.553 184.068L329.972 183.017L328.856 183.634L329.437 184.685L330.553 184.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.053 186.004L326.471 184.953L325.355 185.571L325.936 186.621L327.053 186.004Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.552 187.94L322.971 186.889L321.855 187.507L322.436 188.557L323.552 187.94Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.051 189.876L319.47 188.826L318.354 189.443L318.935 190.494L320.051 189.876Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.55 191.812L315.969 190.762L314.853 191.379L315.434 192.43L316.55 191.812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.05 193.749L312.468 192.698L311.352 193.315L311.933 194.366L313.05 193.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.549 195.685L308.968 194.634L307.852 195.251L308.433 196.302L309.549 195.685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.048 197.621L305.467 196.57L304.351 197.188L304.932 198.238L306.048 197.621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.547 199.557L301.966 198.506L300.85 199.124L301.431 200.174L302.547 199.557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.047 201.493L298.466 200.443L297.349 201.06L297.931 202.111L299.047 201.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.716 165.118L372.079 163.967L370.856 164.643L371.493 165.795L372.716 165.118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.215 167.055L368.578 165.903L367.355 166.58L367.992 167.731L369.215 167.055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.714 168.991L365.078 167.839L363.855 168.516L364.491 169.667L365.714 168.991Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.214 170.927L361.577 169.775L360.354 170.452L360.991 171.603L362.214 170.927Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.713 172.863L358.076 171.712L356.853 172.388L357.49 173.539L358.713 172.863Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.212 174.799L354.575 173.648L353.352 174.324L353.989 175.476L355.212 174.799Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.711 176.735L351.075 175.584L349.852 176.26L350.488 177.412L351.711 176.735Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.211 178.671L347.574 177.52L346.351 178.197L346.988 179.348L348.211 178.671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.71 180.608L344.073 179.456L342.85 180.133L343.487 181.284L344.71 180.608Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.209 182.544L340.572 181.392L339.349 182.069L339.986 183.22L341.209 182.544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.708 184.48L337.072 183.329L335.849 184.005L336.485 185.156L337.708 184.48Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.208 186.416L333.571 185.265L332.348 185.941L332.985 187.093L334.208 186.416Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.707 188.352L330.07 187.201L328.847 187.877L329.484 189.029L330.707 188.352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.206 190.288L326.569 189.137L325.346 189.814L325.983 190.965L327.206 190.288Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.705 192.225L323.069 191.073L321.846 191.75L322.482 192.901L323.705 192.225Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.205 194.161L319.568 193.009L318.345 193.686L318.982 194.837L320.205 194.161Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.704 196.097L316.067 194.946L314.844 195.622L315.481 196.773L316.704 196.097Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.203 198.033L312.566 196.882L311.343 197.558L311.98 198.71L313.203 198.033Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.702 199.969L309.066 198.818L307.843 199.494L308.479 200.646L309.702 199.969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.202 201.905L305.565 200.754L304.342 201.43L304.979 202.582L306.202 201.905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.701 203.842L302.064 202.69L300.841 203.367L301.478 204.518L302.701 203.842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.875 169.404L372.179 168.146L370.842 168.885L371.538 170.143L372.875 169.404Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.374 171.34L368.678 170.082L367.341 170.821L368.037 172.08L369.374 171.34Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.873 173.276L365.177 172.018L363.84 172.757L364.536 174.016L365.873 173.276Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.372 175.213L361.676 173.954L360.34 174.694L361.036 175.952L362.372 175.213Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.872 177.149L358.176 175.89L356.839 176.63L357.535 177.888L358.872 177.149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.371 179.085L354.675 177.827L353.338 178.566L354.034 179.824L355.371 179.085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.87 181.021L351.174 179.763L349.837 180.502L350.533 181.76L351.87 181.021Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.369 182.957L347.673 181.699L346.337 182.438L347.033 183.696L348.369 182.957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.869 184.893L344.173 183.635L342.836 184.374L343.532 185.633L344.869 184.893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.368 186.83L340.672 185.571L339.335 186.31L340.031 187.569L341.368 186.83Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.867 188.766L337.171 187.507L335.835 188.247L336.53 189.505L337.867 188.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.366 190.702L333.67 189.444L332.334 190.183L333.03 191.441L334.366 190.702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.866 192.638L330.17 191.38L328.833 192.119L329.529 193.377L330.866 192.638Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.365 194.574L326.669 193.316L325.332 194.055L326.028 195.313L327.365 194.574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.864 196.51L323.168 195.252L321.832 195.991L322.528 197.25L323.864 196.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.363 198.447L319.667 197.188L318.331 197.927L319.027 199.186L320.363 198.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.863 200.383L316.167 199.124L314.83 199.864L315.526 201.122L316.863 200.383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.362 202.319L312.666 201.061L311.329 201.8L312.025 203.058L313.362 202.319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.861 204.255L309.165 202.997L307.829 203.736L308.525 204.994L309.861 204.255Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.36 206.191L305.665 204.933L304.328 205.672L305.024 206.93L306.36 206.191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.86 208.127L302.164 206.869L300.827 207.608L301.523 208.867L302.86 208.127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.534 171.754L375.779 170.388L374.329 171.19L375.084 172.556L376.534 171.754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.033 173.69L372.278 172.325L370.828 173.127L371.583 174.492L373.033 173.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.533 175.626L368.777 174.261L367.327 175.063L368.082 176.428L369.533 175.626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.032 177.562L365.277 176.197L363.826 176.999L364.582 178.364L366.032 177.562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.531 179.498L361.776 178.133L360.326 178.935L361.081 180.3L362.531 179.498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.03 181.434L358.275 180.069L356.825 180.871L357.58 182.237L359.03 181.434Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.53 183.371L354.774 182.005L353.324 182.807L354.079 184.173L355.53 183.371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.029 185.307L351.274 183.942L349.823 184.744L350.579 186.109L352.029 185.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.528 187.243L347.773 185.878L346.323 186.68L347.078 188.045L348.528 187.243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.027 189.179L344.272 187.814L342.822 188.616L343.577 189.981L345.027 189.179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.527 191.115L340.771 189.75L339.321 190.552L340.076 191.917L341.527 191.115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.026 193.051L337.271 191.686L335.82 192.488L336.576 193.854L338.026 193.051Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.525 194.988L333.77 193.622L332.32 194.424L333.075 195.79L334.525 194.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.024 196.924L330.269 195.558L328.819 196.361L329.574 197.726L331.024 196.924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.524 198.86L326.769 197.495L325.318 198.297L326.073 199.662L327.524 198.86Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.023 200.796L323.268 199.431L321.818 200.233L322.573 201.598L324.023 200.796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.522 202.732L319.767 201.367L318.317 202.169L319.072 203.534L320.522 202.732Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.021 204.668L316.266 203.303L314.816 204.105L315.571 205.471L317.021 204.668Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.521 206.605L312.766 205.239L311.315 206.041L312.07 207.407L313.521 206.605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.02 208.541L309.265 207.175L307.815 207.978L308.57 209.343L310.02 208.541Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.519 210.477L305.764 209.112L304.314 209.914L305.069 211.279L306.519 210.477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.688 176.038L375.877 174.572L374.32 175.433L375.13 176.899L376.688 176.038Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.187 177.974L372.376 176.508L370.819 177.37L371.63 178.835L373.187 177.974Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.686 179.91L368.875 178.444L367.318 179.306L368.129 180.772L369.686 179.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.185 181.847L365.375 180.381L363.817 181.242L364.628 182.708L366.185 181.847Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.685 183.783L361.874 182.317L360.317 183.178L361.127 184.644L362.685 183.783Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.184 185.719L358.373 184.253L356.816 185.114L357.627 186.58L359.184 185.719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.683 187.655L354.872 186.189L353.315 187.05L354.126 188.516L355.683 187.655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.182 189.591L351.372 188.125L349.814 188.987L350.625 190.452L352.182 189.591Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.682 191.527L347.871 190.061L346.314 190.923L347.125 192.389L348.682 191.527Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.181 193.464L344.37 191.998L342.813 192.859L343.624 194.325L345.181 193.464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.68 195.4L340.869 193.934L339.312 194.795L340.123 196.261L341.68 195.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.179 197.336L337.369 195.87L335.812 196.731L336.622 198.197L338.179 197.336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.679 199.272L333.868 197.806L332.311 198.667L333.122 200.133L334.679 199.272Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.178 201.208L330.367 199.742L328.81 200.603L329.621 202.069L331.178 201.208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.677 203.144L326.866 201.678L325.309 202.54L326.12 204.006L327.677 203.144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.177 205.081L323.366 203.615L321.809 204.476L322.619 205.942L324.177 205.081Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.676 207.017L319.865 205.551L318.308 206.412L319.119 207.878L320.676 207.017Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.175 208.953L316.364 207.487L314.807 208.348L315.618 209.814L317.175 208.953Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.674 210.889L312.864 209.423L311.306 210.284L312.117 211.75L313.674 210.889Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.174 212.825L309.363 211.359L307.806 212.22L308.616 213.686L310.174 212.825Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.673 214.761L305.862 213.295L304.305 214.157L305.116 215.623L306.673 214.761Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.347 178.388L379.477 176.815L377.806 177.739L378.676 179.312L380.347 178.388Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.846 180.324L375.976 178.751L374.306 179.675L375.176 181.248L376.846 180.324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.346 182.26L372.476 180.687L370.805 181.611L371.675 183.184L373.346 182.26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.845 184.196L368.975 182.623L367.304 183.547L368.174 185.12L369.845 184.196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.344 186.132L365.474 184.559L363.803 185.483L364.673 187.056L366.344 186.132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.843 188.068L361.973 186.496L360.303 187.42L361.173 188.993L362.843 188.068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.343 190.005L358.473 188.432L356.802 189.356L357.672 190.929L359.343 190.005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.842 191.941L354.972 190.368L353.301 191.292L354.171 192.865L355.842 191.941Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.341 193.877L351.471 192.304L349.8 193.228L350.67 194.801L352.341 193.877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.84 195.813L347.97 194.24L346.3 195.164L347.17 196.737L348.84 195.813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.34 197.749L344.47 196.176L342.799 197.1L343.669 198.673L345.34 197.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.839 199.685L340.969 198.113L339.298 199.037L340.168 200.61L341.839 199.685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.338 201.622L337.468 200.049L335.797 200.973L336.667 202.546L338.338 201.622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.837 203.558L333.968 201.985L332.297 202.909L333.167 204.482L334.837 203.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.337 205.494L330.467 203.921L328.796 204.845L329.666 206.418L331.337 205.494Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.836 207.43L326.966 205.857L325.295 206.781L326.165 208.354L327.836 207.43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.335 209.366L323.465 207.793L321.795 208.717L322.664 210.29L324.335 209.366Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.834 211.302L319.965 209.73L318.294 210.654L319.164 212.226L320.834 211.302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.334 213.239L316.464 211.666L314.793 212.59L315.663 214.163L317.334 213.239Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.833 215.175L312.963 213.602L311.292 214.526L312.162 216.099L313.833 215.175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.332 217.111L309.462 215.538L307.792 216.462L308.661 218.035L310.332 217.111Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.506 182.673L379.577 180.994L377.792 181.98L378.721 183.66L380.506 182.673Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.005 184.61L376.076 182.93L374.292 183.917L375.221 185.596L377.005 184.61Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.504 186.546L372.575 184.866L370.791 185.853L371.72 187.533L373.504 186.546Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.004 188.482L369.074 186.802L367.29 187.789L368.219 189.469L370.004 188.482Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.503 190.418L365.574 188.738L363.789 189.725L364.718 191.405L366.503 190.418Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.002 192.354L362.073 190.674L360.289 191.661L361.218 193.341L363.002 192.354Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.501 194.29L358.572 192.611L356.788 193.597L357.717 195.277L359.501 194.29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.001 196.227L355.072 194.547L353.287 195.534L354.216 197.213L356.001 196.227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.5 198.163L351.571 196.483L349.786 197.47L350.715 199.15L352.5 198.163Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.999 200.099L348.07 198.419L346.286 199.406L347.215 201.086L348.999 200.099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.498 202.035L344.569 200.355L342.785 201.342L343.714 203.022L345.498 202.035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.998 203.971L341.069 202.291L339.284 203.278L340.213 204.958L341.998 203.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.497 205.907L337.568 204.227L335.783 205.214L336.712 206.894L338.497 205.907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.996 207.844L334.067 206.164L332.283 207.151L333.212 208.83L334.996 207.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.495 209.78L330.566 208.1L328.782 209.087L329.711 210.767L331.495 209.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.995 211.716L327.066 210.036L325.281 211.023L326.21 212.703L327.995 211.716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.494 213.652L323.565 211.972L321.78 212.959L322.71 214.639L324.494 213.652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.993 215.588L320.064 213.908L318.28 214.895L319.209 216.575L320.993 215.588Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.492 217.524L316.563 215.844L314.779 216.831L315.708 218.511L317.492 217.524Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.992 219.46L313.063 217.781L311.278 218.768L312.207 220.447L313.992 219.46Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.491 221.397L309.562 219.717L307.777 220.704L308.707 222.384L310.491 221.397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.16 185.022L383.175 183.241L381.284 184.287L382.269 186.068L384.16 185.022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.659 186.958L379.675 185.177L377.783 186.223L378.768 188.004L380.659 186.958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.159 188.894L376.174 187.113L374.283 188.16L375.267 189.94L377.159 188.894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.658 190.83L372.673 189.05L370.782 190.096L371.767 191.876L373.658 190.83Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.157 192.766L369.172 190.986L367.281 192.032L368.266 193.812L370.157 192.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.656 194.702L365.672 192.922L363.78 193.968L364.765 195.749L366.656 194.702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.156 196.639L362.171 194.858L360.28 195.904L361.264 197.685L363.156 196.639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.655 198.575L358.67 196.794L356.779 197.84L357.764 199.621L359.655 198.575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.154 200.511L355.169 198.73L353.278 199.777L354.263 201.557L356.154 200.511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.654 202.447L351.669 200.667L349.777 201.713L350.762 203.493L352.654 202.447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.153 204.383L348.168 202.603L346.277 203.649L347.261 205.429L349.153 204.383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.652 206.319L344.667 204.539L342.776 205.585L343.761 207.366L345.652 206.319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.151 208.256L341.167 206.475L339.275 207.521L340.26 209.302L342.151 208.256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.651 210.192L337.666 208.411L335.774 209.457L336.759 211.238L338.651 210.192Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.15 212.128L334.165 210.347L332.274 211.393L333.258 213.174L335.15 212.128Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.649 214.064L330.664 212.284L328.773 213.33L329.758 215.11L331.649 214.064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.148 216L327.164 214.22L325.272 215.266L326.257 217.046L328.148 216Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.648 217.936L323.663 216.156L321.771 217.202L322.756 218.982L324.648 217.936Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.147 219.873L320.162 218.092L318.271 219.138L319.255 220.919L321.147 219.873Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.646 221.809L316.661 220.028L314.77 221.074L315.755 222.855L317.646 221.809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.145 223.745L313.161 221.964L311.269 223.01L312.254 224.791L314.145 223.745Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.319 189.307L383.275 187.42L381.27 188.529L382.314 190.416L384.319 189.307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.818 191.244L379.774 189.356L377.769 190.465L378.813 192.352L380.818 191.244Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.317 193.18L376.273 191.292L374.269 192.401L375.312 194.289L377.317 193.18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.817 195.116L372.773 193.228L370.768 194.337L371.812 196.225L373.817 195.116Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.316 197.052L369.272 195.165L367.267 196.273L368.311 198.161L370.316 197.052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.815 198.988L365.771 197.101L363.766 198.21L364.81 200.097L366.815 198.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.314 200.924L362.271 199.037L360.266 200.146L361.309 202.033L363.314 200.924Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.814 202.861L358.77 200.973L356.765 202.082L357.809 203.969L359.814 202.861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.313 204.797L355.269 202.909L353.264 204.018L354.308 205.906L356.313 204.797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.812 206.733L351.768 204.845L349.763 205.954L350.807 207.842L352.812 206.733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.311 208.669L348.268 206.782L346.263 207.89L347.307 209.778L349.311 208.669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 210.605L344.767 208.718L342.762 209.827L343.806 211.714L345.811 210.605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.31 212.541L341.266 210.654L339.261 211.763L340.305 213.65L342.31 212.541Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.809 214.478L337.765 212.59L335.76 213.699L336.804 215.586L338.809 214.478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.309 216.414L334.265 214.526L332.26 215.635L333.304 217.523L335.309 216.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.808 218.35L330.764 216.462L328.759 217.571L329.803 219.459L331.808 218.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.307 220.286L327.263 218.399L325.258 219.507L326.302 221.395L328.307 220.286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.806 222.222L323.762 220.335L321.757 221.444L322.801 223.331L324.806 222.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.306 224.158L320.262 222.271L318.257 223.38L319.301 225.267L321.306 224.158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.805 226.094L316.761 224.207L314.756 225.316L315.8 227.203L317.805 226.094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.304 228.031L313.26 226.143L311.255 227.252L312.299 229.14L314.304 228.031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.978 191.657L386.875 189.663L384.757 190.834L385.86 192.829L387.978 191.657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.478 193.593L383.375 191.599L381.256 192.77L382.359 194.765L384.478 193.593Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.977 195.529L379.874 193.535L377.755 194.707L378.858 196.701L380.977 195.529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.476 197.465L376.373 195.471L374.254 196.643L375.358 198.637L377.476 197.465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.975 199.402L372.872 197.407L370.754 198.579L371.857 200.573L373.975 199.402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.475 201.338L369.372 199.343L367.253 200.515L368.356 202.51L370.475 201.338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.974 203.274L365.871 201.28L363.752 202.451L364.855 204.446L366.974 203.274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.473 205.21L362.37 203.216L360.252 204.387L361.355 206.382L363.473 205.21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.972 207.146L358.869 205.152L356.751 206.324L357.854 208.318L359.972 207.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.472 209.082L355.369 207.088L353.25 208.26L354.353 210.254L356.472 209.082Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.971 211.019L351.868 209.024L349.749 210.196L350.852 212.19L352.971 211.019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.47 212.955L348.367 210.96L346.249 212.132L347.352 214.127L349.47 212.955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.969 214.891L344.866 212.897L342.748 214.068L343.851 216.063L345.969 214.891Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.469 216.827L341.366 214.833L339.247 216.004L340.35 217.999L342.469 216.827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.968 218.763L337.865 216.769L335.746 217.941L336.849 219.935L338.968 218.763Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.467 220.699L334.364 218.705L332.246 219.877L333.349 221.871L335.467 220.699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.967 222.636L330.863 220.641L328.745 221.813L329.848 223.807L331.967 222.636Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.466 224.572L327.363 222.577L325.244 223.749L326.347 225.743L328.466 224.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.965 226.508L323.862 224.513L321.743 225.685L322.846 227.68L324.965 226.508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.464 228.444L320.361 226.45L318.243 227.621L319.346 229.616L321.464 228.444Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.964 230.38L316.86 228.386L314.742 229.558L315.845 231.552L317.964 230.38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.132 195.941L386.973 193.846L384.748 195.077L385.906 197.172L388.132 195.941Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.631 197.878L383.473 195.783L381.247 197.013L382.406 199.108L384.631 197.878Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.131 199.814L379.972 197.719L377.746 198.95L378.905 201.045L381.131 199.814Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.63 201.75L376.471 199.655L374.246 200.886L375.404 202.981L377.63 201.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.129 203.686L372.97 201.591L370.745 202.822L371.904 204.917L374.129 203.686Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.628 205.622L369.47 203.527L367.244 204.758L368.403 206.853L370.628 205.622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.128 207.558L365.969 205.463L363.743 206.694L364.902 208.789L367.128 207.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.627 209.495L362.468 207.399L360.243 208.63L361.401 210.725L363.627 209.495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.126 211.431L358.967 209.336L356.742 210.567L357.901 212.662L360.126 211.431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.625 213.367L355.467 211.272L353.241 212.503L354.4 214.598L356.625 213.367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.125 215.303L351.966 213.208L349.74 214.439L350.899 216.534L353.125 215.303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.624 217.239L348.465 215.144L346.24 216.375L347.398 218.47L349.624 217.239Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.123 219.175L344.964 217.08L342.739 218.311L343.898 220.406L346.123 219.175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.622 221.112L341.464 219.016L339.238 220.247L340.397 222.342L342.622 221.112Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.122 223.048L337.963 220.953L335.737 222.183L336.896 224.279L339.122 223.048Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.621 224.984L334.462 222.889L332.237 224.12L333.395 226.215L335.621 224.984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.12 226.92L330.961 224.825L328.736 226.056L329.895 228.151L332.12 226.92Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.619 228.856L327.461 226.761L325.235 227.992L326.394 230.087L328.619 228.856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.119 230.792L323.96 228.697L321.734 229.928L322.893 232.023L325.119 230.792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.618 232.729L320.459 230.633L318.234 231.864L319.392 233.959L321.618 232.729Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.117 234.665L316.958 232.57L314.733 233.8L315.892 235.896L318.117 234.665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.791 198.291L390.574 196.089L388.234 197.383L389.452 199.585L391.791 198.291Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.291 200.227L387.073 198.025L384.734 199.319L385.952 201.521L388.291 200.227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.79 202.163L383.572 199.961L381.233 201.255L382.451 203.457L384.79 202.163Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.289 204.1L380.071 201.897L377.732 203.191L378.95 205.393L381.289 204.1Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.788 206.036L376.571 203.834L374.231 205.127L375.449 207.329L377.788 206.036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.288 207.972L373.07 205.77L370.731 207.063L371.949 209.266L374.288 207.972Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.787 209.908L369.569 207.706L367.23 209L368.448 211.202L370.787 209.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.286 211.844L366.068 209.642L363.729 210.936L364.947 213.138L367.286 211.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.786 213.78L362.568 211.578L360.228 212.872L361.446 215.074L363.786 213.78Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.285 215.716L359.067 213.514L356.728 214.808L357.946 217.01L360.285 215.716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.784 217.653L355.566 215.451L353.227 216.744L354.445 218.946L356.784 217.653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.283 219.589L352.065 217.387L349.726 218.68L350.944 220.883L353.283 219.589Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.783 221.525L348.565 219.323L346.226 220.617L347.443 222.819L349.783 221.525Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.282 223.461L345.064 221.259L342.725 222.553L343.943 224.755L346.282 223.461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.781 225.397L341.563 223.195L339.224 224.489L340.442 226.691L342.781 225.397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.28 227.333L338.062 225.131L335.723 226.425L336.941 228.627L339.28 227.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.78 229.27L334.562 227.068L332.223 228.361L333.44 230.563L335.78 229.27Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.279 231.206L331.061 229.004L328.722 230.297L329.94 232.499L332.279 231.206Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.778 233.142L327.56 230.94L325.221 232.234L326.439 234.436L328.778 233.142Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.277 235.078L324.059 232.876L321.72 234.17L322.938 236.372L325.277 235.078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.777 237.014L320.559 234.812L318.22 236.106L319.438 238.308L321.777 237.014Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.95 202.577L390.673 200.268L388.22 201.624L389.497 203.933L391.95 202.577Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.449 204.513L387.172 202.204L384.72 203.56L385.997 205.869L388.449 204.513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.949 206.449L383.672 204.14L381.219 205.497L382.496 207.806L384.949 206.449Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.448 208.385L380.171 206.076L377.718 207.433L378.995 209.742L381.448 208.385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.947 210.321L376.67 208.012L374.217 209.369L375.494 211.678L377.947 210.321Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.446 212.258L373.169 209.949L370.717 211.305L371.994 213.614L374.446 212.258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.946 214.194L369.669 211.885L367.216 213.241L368.493 215.55L370.946 214.194Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.445 216.13L366.168 213.821L363.715 215.177L364.992 217.486L367.445 216.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.944 218.066L362.667 215.757L360.214 217.114L361.491 219.423L363.944 218.066Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.443 220.002L359.166 217.693L356.714 219.05L357.991 221.359L360.443 220.002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.943 221.938L355.666 219.629L353.213 220.986L354.49 223.295L356.943 221.938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.442 223.875L352.165 221.566L349.712 222.922L350.989 225.231L353.442 223.875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.941 225.811L348.664 223.502L346.211 224.858L347.489 227.167L349.941 225.811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.441 227.747L345.163 225.438L342.711 226.794L343.988 229.103L346.441 227.747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.94 229.683L341.663 227.374L339.21 228.731L340.487 231.04L342.94 229.683Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.439 231.619L338.162 229.31L335.709 230.667L336.986 232.976L339.439 231.619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.938 233.555L334.661 231.246L332.209 232.603L333.486 234.912L335.938 233.555Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.438 235.492L331.161 233.182L328.708 234.539L329.985 236.848L332.438 235.492Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.937 237.428L327.66 235.119L325.207 236.475L326.484 238.784L328.937 237.428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.436 239.364L324.159 237.055L321.706 238.411L322.983 240.72L325.436 239.364Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.935 241.3L320.658 238.991L318.206 240.348L319.483 242.657L321.935 241.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.605 204.925L394.272 202.515L391.712 203.931L393.045 206.341L395.605 204.925Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.104 206.861L390.771 204.452L388.211 205.867L389.544 208.277L392.104 206.861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.603 208.797L387.27 206.388L384.711 207.803L386.043 210.213L388.603 208.797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.102 210.734L383.77 208.324L381.21 209.74L382.543 212.149L385.102 210.734Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.602 212.67L380.269 210.26L377.709 211.676L379.042 214.085L381.602 212.67Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.101 214.606L376.768 212.196L374.208 213.612L375.541 216.022L378.101 214.606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.6 216.542L373.267 214.132L370.708 215.548L372.04 217.958L374.6 216.542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.099 218.478L369.767 216.068L367.207 217.484L368.54 219.894L371.099 218.478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.599 220.414L366.266 218.005L363.706 219.42L365.039 221.83L367.599 220.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.098 222.35L362.765 219.941L360.205 221.356L361.538 223.766L364.098 222.35Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.597 224.287L359.264 221.877L356.705 223.293L358.037 225.702L360.597 224.287Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.096 226.223L355.764 223.813L353.204 225.229L354.537 227.638L357.096 226.223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.596 228.159L352.263 225.749L349.703 227.165L351.036 229.575L353.596 228.159Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.095 230.095L348.762 227.685L346.203 229.101L347.535 231.511L350.095 230.095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.594 232.031L345.261 229.622L342.702 231.037L344.034 233.447L346.594 232.031Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.093 233.967L341.761 231.558L339.201 232.973L340.534 235.383L343.093 233.967Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.593 235.904L338.26 233.494L335.7 234.91L337.033 237.319L339.593 235.904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.092 237.84L334.759 235.43L332.2 236.846L333.532 239.255L336.092 237.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.591 239.776L331.258 237.366L328.699 238.782L330.032 241.192L332.591 239.776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.09 241.712L327.758 239.302L325.198 240.718L326.531 243.128L329.09 241.712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.59 243.648L324.257 241.239L321.697 242.654L323.03 245.064L325.59 243.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.763 209.211L394.371 206.694L391.698 208.173L393.09 210.689L395.763 209.211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.263 211.147L390.871 208.63L388.197 210.109L389.589 212.625L392.263 211.147Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.762 213.083L387.37 210.566L384.697 212.045L386.088 214.562L388.762 213.083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.261 215.019L383.869 212.503L381.196 213.981L382.588 216.498L385.261 215.019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.76 216.955L380.368 214.439L377.695 215.917L379.087 218.434L381.76 216.955Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.26 218.892L376.868 216.375L374.194 217.853L375.586 220.37L378.26 218.892Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.759 220.828L373.367 218.311L370.694 219.79L372.086 222.306L374.759 220.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.258 222.764L369.866 220.247L367.193 221.726L368.585 224.242L371.258 222.764Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.757 224.7L366.365 222.183L363.692 223.662L365.084 226.179L367.757 224.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.257 226.636L362.865 224.12L360.191 225.598L361.583 228.115L364.257 226.636Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.756 228.572L359.364 226.056L356.691 227.534L358.083 230.051L360.756 228.572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.255 230.509L355.863 227.992L353.19 229.47L354.582 231.987L357.255 230.509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.754 232.445L352.362 229.928L349.689 231.407L351.081 233.923L353.754 232.445Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.254 234.381L348.862 231.864L346.188 233.343L347.58 235.859L350.254 234.381Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.753 236.317L345.361 233.8L342.688 235.279L344.08 237.796L346.753 236.317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.252 238.253L341.86 235.737L339.187 237.215L340.579 239.732L343.252 238.253Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.751 240.189L338.36 237.673L335.686 239.151L337.078 241.668L339.751 240.189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.251 242.126L334.859 239.609L332.185 241.087L333.577 243.604L336.251 242.126Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.75 244.062L331.358 241.545L328.685 243.024L330.077 245.54L332.75 244.062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.249 245.998L327.857 243.481L325.184 244.96L326.576 247.476L329.249 245.998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.748 247.934L324.357 245.417L321.683 246.896L323.075 249.413L325.748 247.934Z",
    fill: "black"
  }))), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M247.987 169.754C248.116 171.312 249.483 172.469 251.041 172.341C252.599 172.212 253.757 170.845 253.628 169.287C253.499 167.729 252.132 166.573 250.574 166.702C249.016 166.831 247.858 168.198 247.987 169.754Z",
    fill: "#F4F4F4"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M268.05 141.735C268.179 143.293 269.545 144.45 271.101 144.322C272.659 144.193 273.817 142.826 273.688 141.268C273.559 139.71 272.192 138.552 270.634 138.681C269.079 138.812 267.921 140.179 268.05 141.735Z",
    fill: "#F4F4F4"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M304.586 161.1C306.143 160.971 307.302 159.604 307.173 158.046C307.044 156.488 305.677 155.33 304.119 155.459C302.562 155.588 301.403 156.955 301.532 158.513C301.661 160.07 303.028 161.229 304.586 161.1Z",
    fill: "#F4F4F4"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M341.514 143.234C341.643 144.792 343.009 145.947 344.567 145.818C346.125 145.689 347.283 144.322 347.154 142.767C347.025 141.209 345.659 140.051 344.101 140.18C342.543 140.311 341.385 141.678 341.514 143.234Z",
    fill: "#F4F4F4"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M315.935 94.6687C334.671 93.118 348.603 76.6719 347.053 57.9352C345.502 39.1986 329.056 25.2666 310.319 26.8173C291.583 28.3679 277.651 44.814 279.201 63.5507C280.752 82.2873 297.198 96.2193 315.935 94.6687Z",
    fill: "url(#paint13_linear_208_3329)"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M283.515 38.244C283.515 38.244 281.803 14.7276 317.124 19.8294C352.448 24.9287 361.396 52.8936 360.23 71.9372C359.064 90.9807 343.984 84.6137 333.875 84.7851C322.461 84.9764 326.47 69.1141 326.47 69.1141C312.754 63.986 307.401 52.3699 305.303 44.1393C301.498 48.8077 302.287 52.5786 302.287 52.5786C297.817 43.0447 303.953 35.0863 303.953 35.0863C288.133 39.6833 283.515 38.244 283.515 38.244Z",
    fill: "black"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9391 366.554L27.6466 366.164C33.4171 353.93 49.1817 352.091 49.1817 352.091L217.197 133.24C258.385 82.0046 253.92 162.27 220.944 244.423L114.184 364.273C109.885 369.085 103.904 372.065 97.4751 372.597L34.3998 377.817L25.6644 378.54L11.8142 379.686C11.26 372.989 16.2402 367.108 22.9391 366.554Z",
    fill: "url(#paint14_linear_208_3329)"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M455.158 322.752L433.216 218.834C428.898 198.387 413.903 183.59 395.819 178.094",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M119.256 358.582L220.946 244.423C253.922 162.27 258.387 82.0042 217.199 133.239",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M388.118 178.535L389.973 196.055",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M245.804 109.128C245.804 109.128 270.045 115.454 298.549 141.219C298.549 141.219 326.089 174.18 337.194 164.092",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M317.369 111.94L331.338 138.467",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M183.05 177.755L42.9224 360.247",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M303.963 35.0805C303.963 35.0805 292.756 67.2454 354.252 80.371C354.252 80.371 317.599 62.6669 303.963 35.0805Z",
    fill: "#ED1B2F"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M332.857 73.5447C328.22 76.1672 326.043 81.0918 327.993 84.5425C329.945 87.993 335.286 88.6644 339.923 86.0419C344.56 83.4194 346.737 78.4947 344.787 75.044C342.838 71.5934 337.496 70.9219 332.857 73.5447Z",
    fill: "url(#paint15_linear_208_3329)"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M342.486 77.0498C342.486 77.0498 341.036 74.4232 338.488 74.6341C335.94 74.845 330.5 77.7581 330.302 80.7523",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M336.557 81.8374L336.028 75.4463",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M303.955 35.082C303.955 35.082 308.423 61.4197 318.541 74.1412C318.541 74.1412 291.202 52.7456 303.955 35.082Z",
    fill: "#ED1B2F"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M303.956 35.082C303.956 35.082 286.113 37.7889 279.949 53.1001C279.949 53.1001 276.486 26.3788 303.956 35.082Z",
    fill: "#ED1B2F"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M318.541 74.1429C290.035 50.455 303.955 35.0837 303.955 35.0837C303.955 35.0837 284.783 38.0676 279.948 53.1018",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M304.063 47.4941C304.063 47.4941 306.094 58.3458 320.853 68.1511",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 585,
    height: 179,
    rx: 89.5,
    stroke: "#202023"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_3329",
    x1: 187.659,
    y1: 322.986,
    x2: 140.017,
    y2: 449.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_3329",
    x1: 156.552,
    y1: 98.3934,
    x2: 171.641,
    y2: 45.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_208_3329",
    x1: 94.2083,
    y1: 80.903,
    x2: 109.297,
    y2: 27.7491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_208_3329",
    x1: -33.1719,
    y1: 267.659,
    x2: -57.8116,
    y2: 405.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_208_3329",
    x1: 117.215,
    y1: 111.624,
    x2: 125.089,
    y2: 83.7836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_208_3329",
    x1: 131.398,
    y1: 84.3786,
    x2: 139.975,
    y2: -4.24533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_208_3329",
    x1: 388.107,
    y1: 337.544,
    x2: 435.749,
    y2: 463.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_208_3329",
    x1: 435.567,
    y1: 100.364,
    x2: 434.489,
    y2: 45.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_208_3329",
    x1: 500.309,
    y1: 99.3006,
    x2: 499.231,
    y2: 44.0571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_208_3329",
    x1: 608.939,
    y1: 282.217,
    x2: 633.578,
    y2: 419.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_208_3329",
    x1: 470.246,
    y1: 123.162,
    x2: 469.71,
    y2: 94.2345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_208_3329",
    x1: 463.457,
    y1: 93.2056,
    x2: 477.696,
    y2: 5.31356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_208_3329",
    x1: 285.427,
    y1: 160.656,
    x2: 290.213,
    y2: 27.8283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_208_3329",
    x1: 300.801,
    y1: 82.5648,
    x2: 333.01,
    y2: 25.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_208_3329",
    x1: 130.044,
    y1: 269.936,
    x2: 138.365,
    y2: 413.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_208_3329",
    x1: 319.765,
    y1: 91.1872,
    x2: 373.786,
    y2: 54.1672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_3329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 180,
    rx: 90,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_208_3329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.9827,
    height: 61.1632,
    fill: "white",
    transform: "translate(284.812 180.115) rotate(-27.4899)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureImage);
export default __webpack_public_path__ + "static/media/feature-image.85e7c7e2bc271bbdd5d29e14e3b4c32e.svg";
export { ForwardRef as ReactComponent };